
import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatAutocompleteModule, MatAutocompleteTrigger, MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { closeAutocompleteOnOutsideScrollFactory } from 'src/app/services/close-on-outside-scroll-strategy';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterModule } from "@angular/router";
import { navigateWithFreshRoute } from 'src/app/shared/route-reuse.util';
import { NgbModal, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as CryptoJS from 'crypto-js';
import { ConnectionService } from "ng-connection-service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { TypeaheadModule, TypeaheadOrder, TypeaheadConfig } from "ngx-bootstrap/typeahead";
import { CookieService } from "ngx-cookie-service";
import { NgSelectModule } from '@ng-select/ng-select';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { JoyrideModule } from 'ngx-joyride';
import { NgxSummernoteModule } from 'ngx-summernote';
import { forkJoin, Observable, of, Subject, Subscription, timer } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, switchMap, take, takeUntil } from 'rxjs/operators';
import { PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { BusinessProvider, businessSubject } from 'src/app/guard/business-details-guard.ts.service';
import { AppSettings } from "src/app/services/AppSettings";
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants, USER_TYPE } from 'src/app/services/GigsumoConstants';
import { HealthCareOrganization } from 'src/app/services/HealthCareOrganization';
import { TourService } from 'src/app/services/TourService';
import { userPlanProvider, UserService } from 'src/app/services/UserService';
import { ApiService } from "src/app/services/api.service";
import { CommonValues } from "src/app/services/commonValues";
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { ProfilePhoto } from "src/app/services/profilePhoto";
import { ResumeDataMapperService } from 'src/app/services/resume-data-mapper.service';
import { ResumeParserService } from 'src/app/services/resume-parser.service';
import { SearchData } from "src/app/services/searchData";
import { SocketService } from 'src/app/services/socket.service';
import { WorkExperience } from 'src/app/services/userModel';
import { UtilService } from "src/app/services/util.service";
import { environment } from 'src/environments/environment';
import Swal from "sweetalert2";
import { WorkexperienceModalComponent } from '../../page/model/workexperience-modal/workexperience-modal.component';
import { CountProviderService } from '../../services/count-provider.service';
import { CurrentOrganizationProviderService } from '../../services/current-organization-provider.service';
import { NotifierComponent } from '../../templates/notifier/notifier.component';
import { TimezonepopupComponent } from '../../timezonepopup/timezonepopup.component';
import { MessageWidgetComponent } from '../../widget/message-widget/message-widget.component';
import { CustomValidator } from '../Helper/custom-validator';
import { CandidateFormTabsComponent } from '../candidate-form-tabs/candidate-form-tabs.component';
import { PlanDowngradeModelComponent } from '../plan-downgrade-model/plan-downgrade-model.component';
import { SocketServiceStream } from './../../services/SocketServiceStream';
import { StreamService } from './../../services/stream.service';
import { ToasterService } from './../../services/toaster.service';
import { CreditModelComponent } from './../credit/credit-model/credit-model.component';
import { CacheInvalidationService } from '../../services/cache-invalidation.service';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { JobdescriptionparsingService } from 'src/app/services/jobdescriptionparsing.service';
import { JobCreationTriggerService } from 'src/app/services/job-creation-trigger.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { ProfileMenuComponent, ProfileMenuUser } from '../../shared/ui/profile-menu/profile-menu.component';
import { AppsMenuComponent } from '../../shared/ui/apps-menu/apps-menu.component';
import { NotificationPanelComponent, NotificationItem } from '../../shared/ui/notification-panel/notification-panel.component';
import { mapNotifications } from '../../shared/ui/notification-panel/notification-mappers';
import { NotificationContentService } from '../../shared/ui/notification-panel/notification-content.service';
import { NotificationMessageTextService } from '../../shared/ui/notification-message/notification-message-text.service';
import { GlobalSearchStateService } from 'src/app/services/global-search-state.service';

declare var $: any
type Location = {
  country: string,
  state: string,
  city: string;
  zipCode: string,
}

declare var $: any;

interface CustomModalOptions extends ModalOptions {
  data?: any
}

// Close mat-autocomplete panels when the form/page scrolls (so the panel
// never floats detached from its input) but NOT while the user scrolls the
// options list itself — the stock close() strategy did, which made long
// Client Name lists unselectable. See CloseOnOutsideScrollStrategy.

@Component({
  selector: "app-langding-page-nav-bar",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatAutocompleteModule,
    CdkScrollableModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    NgbModule,
    TypeaheadModule,
    BsDropdownModule,
    NgSelectModule,
    ImageCropperModule,
    NgxSummernoteModule,
    DatePipe,
    MessageWidgetComponent,
    TimezonepopupComponent,
    NotifierComponent,
    WorkexperienceModalComponent,
CandidateFormTabsComponent,
    JoyrideModule,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
    ProfileMenuComponent,
    AppsMenuComponent,
    NotificationPanelComponent,
  ],
  templateUrl: "./langding-page-nav-bar.component.html",
  styleUrls: ["./langding-page-nav-bar.component.scss"],
  providers: [
    TypeaheadConfig,
    { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: closeAutocompleteOnOutsideScrollFactory, deps: [NgZone] }
  ]
})
export class LangdingPageNavBarComponent extends FormValidation
  implements OnInit, OnDestroy, AfterViewInit {

  /** Shapes existing user state into the input expected by <app-profile-menu>. */
  get profileUser(): ProfileMenuUser {
    return {
      firstName: this.loginUser?.firstName,
      lastName: this.loginUser?.lastName,
      fullName: this.UserName,
      email: this.emailid,
      userType: this.userType,
      userTypeLabel: this.userTypeunder,
      gigsumoNo: this.gigsumono,
      companyName: this.companyName || undefined,
      photo: this.loginPhoto || null,
      initials: this.getInitials(this.loginUser?.firstName, this.loginUser?.lastName),
      avatarBg: this.getColor(this.loginUser?.firstName, this.loginUser?.lastName),
      avatarFg: this.getTextColor(this.loginUser?.firstName, this.loginUser?.lastName),
      online: true,
      plan: this.membershipType || 'Free',
    };
  }

  /** Profile-menu dropdown opened: refresh user data (preserves the legacy `(click)="onChangeProfile(true)"` behavior). */
  onProfileMenuToggled(open: boolean) { if (open) this.onChangeProfile(true); }

  gotoPlans() { this.router.navigate(['/plan-quota']); }
  gotoFaq()   { this.router.navigate(['/faq']); }

  /** Apps-menu footer "Manage Apps →" link. Placeholder: route to plans for now. */
  onAppsManage() { this.router.navigate(['/plan-quota']); }

  showmodel = false
  timezonSubmited = false;
  submited: boolean = false;
  public FORMERROR = super.Form;
  points: any = [];
  availableredim: any = [];
  redeimform: UntypedFormGroup;
  counts;
  userTypeunder: any = null;
  gigsumono: any = null;
  disable_for_draft: boolean = false;
  userId: string = localStorage.getItem('userId');
  fileSize = AppSettings.FILE_SIZE;
  currentTimeDate: string | Date;
  img;
  unit = { duration: '30' };
  mindate: any = new Date();
  currentDate: any = [];
  maxDate: any = [];
  autoComplete: MatAutocompleteTrigger;
  userDetailsLanding: any;
  photoId: any;
  name;
  // tslint:disable-next-line: variable-name
  userDetailsLanding_array = [];
  dynamicArray = [];
  public envName: any = environment.name;
  businessDataArray: any = [];
  BuninessPageData;
  serachForm: UntypedFormGroup;
  SerachList: Array<String> = [];
  conditionDropdown = [];
  keyword = "firstName";
  item: any;
  bsModalRef: BsModalRef;
  dynamicdata;
  userData: any[] = [];
  bunissData;
  CommunityData;
  errorMsg: any;
  BusinessId;
  SearchcArray;
  filteredStreets: Observable<any>;
  businessTitle = "BusinessPage";
  showSearchData = false;
  searchBarShow = false;
  reloadUser = false;
  highLighter: Subscription

  userCount: number = 0;
  businessCount : number = 0;

  // Apps Menu
  showAppsMenu = false;
  appsList: any[] = [];
  private documentClickListener: any;
  private appsMenuHoverTimeout: any;

  notificationList: any = [];
  callNotification = true;
  unreadUserMsgCount: number = 0;
  notificationcount: number = 0;

  notifPanelOpen = false;
  notifPanelLoading = false;
  notifPanelLoadingMore = false;
  notifPanelList: NotificationItem[] = [];
  notifPanelCursor: any = null;
  notifPanelHasMore = false;
  private readonly NOTIF_PAGE_SIZE = 10;
  jobInvitesReceivedCount: number = 0;
  resumeRequestReceivedCount: number = 0;
  jobApplicationsReceivedCount: number = 0;
  totalFeaturedCandidatesCount: number = 0;
  jobsAppliedCount: number = 0;
  totalFeaturedJobsCount: number = 0;
  jobInvitesSentCount: number = 0;
  resumeRequestedCount: number = 0;
  totalsuggJobsCount: number = 0;
  totalSuggCandidatesCount: number = 0;
  newPost: number = 0;
  callUnreadMsg: boolean = true;
  value: any = {}
  userValues: Subscription
  currentOrganizationDetail: WorkExperience;
  expireModalRef: BsModalRef;
  workauthcountry: any;
  supportModal: jobModuleConfig;
  businessDetails: any;
  companyName: any = '';
  selectedJobTitle: string;

  // Custom method to remove skill from selected array
  removeSkill(skill: string, isPrimary: boolean): void {
    if (isPrimary) {
      this.primarySkillsSelected = [...this.primarySkillsSelected.filter(s => s !== skill)];
      this.jobPostForm?.get('primarySkills')?.setValue(this.primarySkillsSelected);
      this.jobPostForm?.get('primarySkills')?.updateValueAndValidity();
      this.candidatePostForm?.get('primarySkills')?.setValue(this.primarySkillsSelected);
      this.candidatePostForm?.get('primarySkills')?.updateValueAndValidity();
    } else {
      this.secondarySkillsSelected = [...this.secondarySkillsSelected.filter(s => s !== skill)];
      this.jobPostForm?.get('secondarySkills')?.setValue(this.secondarySkillsSelected);
      this.jobPostForm?.get('secondarySkills')?.updateValueAndValidity();
      this.candidatePostForm?.get('secondarySkills')?.setValue(this.secondarySkillsSelected);
      this.candidatePostForm?.get('secondarySkills')?.updateValueAndValidity();
    }
  }
clearSkills(isPrimary: boolean): void {
  if (isPrimary) {
    this.primarySkillsSelected = [];
    this.jobPostForm?.get('primarySkills')?.setValue([]);
    this.jobPostForm?.get('primarySkills')?.updateValueAndValidity();
    this.candidatePostForm?.get('primarySkills')?.setValue([]);
    this.candidatePostForm?.get('primarySkills')?.updateValueAndValidity();
  } else {
    this.secondarySkillsSelected = [];
    this.jobPostForm?.get('secondarySkills')?.setValue([]);
    this.jobPostForm?.get('secondarySkills')?.updateValueAndValidity();
    this.candidatePostForm?.get('secondarySkills')?.setValue([]);
    this.candidatePostForm?.get('secondarySkills')?.updateValueAndValidity();
  }
}

syncPrimarySkills(event: any): void {
  this.primarySkillsSelected = event;
}

syncSecondarySkills(event: any): void {
  this.secondarySkillsSelected = event;
}

onPrimarySkillsClear(): void {
  this.primarySkillsSelected = [];
  this.jobPostForm?.get('primarySkills')?.setValue([]);
  this.jobPostForm?.get('primarySkills')?.updateValueAndValidity();
  this.candidatePostForm?.get('primarySkills')?.setValue([]);
  this.candidatePostForm?.get('primarySkills')?.updateValueAndValidity();
}

isPrimarySkillSelected(item: string): boolean {
  return this.primarySkillsSelected?.includes(item) || false;
}

togglePrimarySkill(item: string, event: Event): void {
  event.stopPropagation();
  const index = this.primarySkillsSelected?.indexOf(item);
  if (index === -1) {
    if (this.primarySkillsSelected?.length < 3) {
      this.primarySkillsSelected = [...(this.primarySkillsSelected || []), item];
    }
  } else {
    this.primarySkillsSelected = this.primarySkillsSelected?.filter((skill: string) => skill !== item) || [];
  }
  this.jobPostForm?.get('primarySkills')?.setValue(this.primarySkillsSelected);
  this.jobPostForm?.get('primarySkills')?.updateValueAndValidity();
  this.candidatePostForm?.get('primarySkills')?.setValue(this.primarySkillsSelected);
  this.candidatePostForm?.get('primarySkills')?.updateValueAndValidity();
}

isSecondarySkillSelected(item: string): boolean {
  return this.secondarySkillsSelected?.includes(item) || false;
}

toggleSecondarySkill(item: string, event: Event): void {
  event.stopPropagation();
  const index = this.secondarySkillsSelected?.indexOf(item);
  if (index === -1) {
    if (this.secondarySkillsSelected?.length < 3) {
      this.secondarySkillsSelected = [...(this.secondarySkillsSelected || []), item];
    }
  } else {
    this.secondarySkillsSelected = this.secondarySkillsSelected?.filter((skill: string) => skill !== item) || [];
  }
  this.jobPostForm?.get('secondarySkills')?.setValue(this.secondarySkillsSelected);
  this.jobPostForm?.get('secondarySkills')?.updateValueAndValidity();
  this.candidatePostForm?.get('secondarySkills')?.setValue(this.secondarySkillsSelected);
  this.candidatePostForm?.get('secondarySkills')?.updateValueAndValidity();
}

onJobTitleClear(): void {
  this.selectedJobTitle = null;
  this.jobPostForm?.get('jobTitle')?.setValue(null);
  this.jobPostForm?.get('jobTitle')?.updateValueAndValidity();
  this.candidatePostForm?.get('jobTitle')?.setValue(null);
  this.candidatePostForm?.get('jobTitle')?.updateValueAndValidity();
}

onSecondarySkillsClear(): void {
  this.secondarySkillsSelected = [];
  this.jobPostForm?.get('secondarySkills')?.setValue([]);
  this.jobPostForm?.get('secondarySkills')?.updateValueAndValidity();
  this.candidatePostForm?.get('secondarySkills')?.setValue([]);
  this.candidatePostForm?.get('secondarySkills')?.updateValueAndValidity();
}
  isOpenChange1(): void {
  }

  // Add this property near line 825
private tourModalShown: boolean = false;

  candidateSubmit: boolean = false
  isConnected = true;
  getclickStatus = true;
  result: any;
  noInternetConnection: boolean;
  globalsearchRes: any = [];
  candidateId: any;
  streamData: any = [];
  jobStreamData: any = [];
  canidateStreamData: any = [];
  notificationDatasshow: any;
  // True once getUserHeaderCount() has populated notificationDatasshow / notificationcount
  // from REST. The count-based stream toasters compare against those values, so they are
  // burst-safe only after this lands. (This replaced `isFirstStreamDataLoad`, which
  // treated the first stream frame as a baseline — but the backend never pushes a
  // baseline frame, so that gate silently ate the first real event after every login
  // and every nav-bar re-creation.)
  private headerCountsLoaded: boolean = false;
  // Ledger of notifyIds already accounted for: everything that existed when this
  // session started, plus everything toasted since. A notification is "new" only
  // when its notifyId is absent here. Identity, not clock or count arithmetic —
  // the previous `notifyTime > sessionStart` gate let pre-existing items through.
  private shownNotifyIds = new Set<string>();
  // Until the baseline snapshot lands, nothing may toast.
  private notifBaselineReady: boolean = false;
  // Unread count carried by the previous stream frame; null until the first one.
  // Kept apart from `notificationcount` (the badge), which REST also writes: when
  // `user/header` had already counted a new notification, its frame was "not an
  // increase", the fetch was skipped, and the record toasted late — together with
  // the next notification.
  private lastStreamNotificationCount: number | null = null;
  workExperienceContent: string;
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  @ViewChild("jobCandidateTemplate") jobCandidateTemplate: ElementRef;
  @ViewChild('welcometour', { static: true }) welcometour: TemplateRef<any>;
  TourmodalRef: BsModalRef;
  @ViewChild('customDropdown') customDropdown: any;
  imageChangedEvent: any = "";
  fileUploadName;
  fileshow = undefined;
  fileToUpload: File;
  photoIdnew: any;
  infoData: any = {};
  photo: any = null;
  url = AppSettings.ServerUrl + "download/";
  counter = 0
  previous = 0
  now = 0
  showModal: boolean = false;
  rxjsTimer = timer(AppSettings.timerSocket);
  destroy$ = new Subject<void>();
  streamRes: any = null;
  isScrollEnabled: boolean = false;
  showHeader: boolean = true
  private intervalId: any;
  private destroyed = false;
  constructor(
    private datePipe: DatePipe,
    private API: ApiService, private userService: UserService,
    private modalService: BsModalService,
    private userPlanProvider: userPlanProvider,
    private fb: UntypedFormBuilder,
    private commonValues: CommonValues,
    private pricePlanService: PricePlanService,
    private router: Router,
    private _route: ActivatedRoute,
    private connectionService: ConnectionService,
    private util: UtilService,
    private formBuilder: UntypedFormBuilder,
    private profilePhoto: ProfilePhoto,
    private cookieservice: CookieService,
    private searchData: SearchData,
    private stremService: StreamService,
    private businessProvider: BusinessProvider,
    private Socketserver: SocketService,
    private StreamSocket: SocketServiceStream,
    public gigsumoService: GigsumoService,
    private JobServicecolor: JobService,
    private tourService: TourService,
    private countProvider: CountProviderService,
    private currentOrgProvider: CurrentOrganizationProviderService,
    private resumeParserService: ResumeParserService,
    private resumeDataMapper: ResumeDataMapperService,
    private cdr: ChangeDetectorRef,
    private toasterService: ToasterService,
    private cacheInvalidationService: CacheInvalidationService,
    public jdParsingService: JobdescriptionparsingService,
    private jobCreationTrigger: JobCreationTriggerService,
    private notifContent: NotificationContentService,
    private notifMessageText: NotificationMessageTextService,
    private globalSearchState: GlobalSearchStateService,
    private ngbModal: NgbModal
  ) {
    super();

    this.gigsumoService.currentProfilePhoto.subscribe(photoUrl => {
      if (photoUrl != undefined) {
        this.loginPhoto = photoUrl;
      } else {
        this.loginPhoto = null;
      }

    });


    this.tourService.getTourSteps('LandingPage').subscribe(data => {
      this.tourSteps = data;
      const navBarSteps = data.filter(s => s.componentId === 'LangdingPageNavBarComponent');
      console.log('[NavBar] LandingPage tour steps loaded', navBarSteps.map(s => s.stepId));
    });

    this.tourService.landingTourCompleted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log('[NavBar] ===== landingTourCompleted$ RECEIVED =====');
        console.log('[NavBar] landingTourCompleted$ received — checking backup email');
        this.checkBackupEmailPrompt();
      });


    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const isTargetRoute = event.url.includes('/newjobs')
            || event.url.includes('/newcandidates') ? true : false;
          this.toggleBodyOverflow(!isTargetRoute);
          if (event.url.includes('/newjobs')) {
            localStorage.removeItem('candidateSource');
            localStorage.removeItem('candidateForm');
          } else if (event.url.includes('/newcandidates')) {
            localStorage.removeItem('jobSource');
            localStorage.removeItem('jobForm');
          }
        } else if (event instanceof NavigationEnd) {
          this.updatePageName(event.urlAfterRedirects);
        }
      });
    this.connectionService.monitor()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isConnected => {
        this.isConnected = isConnected;
      });


    this.StreamSocket.connect().pipe(
      switchMap(client => {
        if (!client.connected) {
          return of(null);  // Return an observable with null or handle reconnection
        } else {
          // Start topic subscription when socket connects to ensure data flows
          this.stremService.startTopic();
          // Re-take the baseline on every (re)connect. A notification saved while
          // no socket was listening never produced a frame here; left unrecorded
          // it would toast alongside the next notification that does.
          this.seedNotificationBaseline();
          return this.stremService.getstreamResponse();
        }
      }),
      // Must be LAST. Placed before switchMap it only stopped the outer connect()
      // stream: the inner streamData subscription (a root Subject that never
      // completes) kept this handler alive after the nav-bar was destroyed. After
      // logout → login that leaked handler still held the pre-logout ledger and
      // toasted every notification received while logged out.
      takeUntil(this.destroy$)
    ).subscribe(streamData => {
      if (streamData) {
        this.streamData = streamData;

        if (streamData.responseEntity == "JOB") {
          this.jobStreamData = streamData;
        }
        if (streamData.responseEntity == "CANDIDATE") {
          this.canidateStreamData = streamData;
        }
        if (streamData.responseEntity == "HOME") {
          this.streamData = streamData;
        }
        if (!this.notificationDatasshow) {
          this.notificationDatasshow = {};
        }
        if (streamData && streamData.data) {
          const data = streamData.data;

          // Track previous counts for toaster notifications BEFORE updating
          const prevJobApplications = this.notificationDatasshow?.jobApplicationsReceivedCount || 0;
          const prevJobInvites = this.notificationDatasshow?.jobInvitesReceivedCount || 0;
          // Toasters removed for message/chat actions (2026-09-12): the only readers
          // of these two were the job/candidate chat toaster branches below.
          // const prevJobMessages = this.notificationDatasshow?.jobNonSeenMessageCount || 0;
          // const prevCandidateMessages = this.notificationDatasshow?.candidateNonSeenMessageCount || 0;

          // Update counts - Only update if the field exists in data (don't overwrite with undefined/0)
          if (data.jobApplicationsReceivedCount !== undefined) {
            this.notificationDatasshow.jobApplicationsReceivedCount = data.jobApplicationsReceivedCount;
          }
          if (data.jobInvitesReceivedCount !== undefined) {
            this.notificationDatasshow.jobInvitesReceivedCount = data.jobInvitesReceivedCount;
          }
          if (data.jobNonSeenMessageCount !== undefined) {
            this.notificationDatasshow.jobNonSeenMessageCount = data.jobNonSeenMessageCount;
          }
          if (data.candidateNonSeenMessageCount !== undefined) {
            this.notificationDatasshow.candidateNonSeenMessageCount = data.candidateNonSeenMessageCount;
          }

          // Count-based toasters compare stream totals against the REST-loaded
          // counters. Until getUserHeaderCount() has landed those counters are 0
          // and any frame would announce every historical item as new, so hold
          // them until then. Do NOT gate on "first frame": the backend pushes no
          // baseline frame, so the first frame is always a real event.
          const shouldShowToasters = this.headerCountsLoaded;

          // Only trigger toasters when count increases AND we should show toasters
          if (shouldShowToasters) {
            if (data.jobApplicationsReceivedCount !== undefined && data.jobApplicationsReceivedCount > prevJobApplications) {
              const newCount = data.jobApplicationsReceivedCount - prevJobApplications;
              this.toasterService.showStreamNotification('jobApplicationsReceived', newCount);
            }

            if (data.jobInvitesReceivedCount !== undefined && data.jobInvitesReceivedCount > prevJobInvites) {
              const newCount = data.jobInvitesReceivedCount - prevJobInvites;
              this.toasterService.showStreamNotification('jobInvitesReceived', newCount);
            }

            // Toasters removed for message/chat actions (2026-09-12). Toast
            // notifications are not wanted for anything in the Messages/Chat
            // modules, so the job- and candidate-chat unread branches are off.
            // The count assignments above still run, so the header badges and
            // the messaging counters are unchanged.
            // if (data.jobNonSeenMessageCount !== undefined && data.jobNonSeenMessageCount > prevJobMessages) {
            //   const newCount = data.jobNonSeenMessageCount - prevJobMessages;
            //   this.toasterService.showStreamNotification('jobNonSeenMessage', newCount);
            // }

            // if (data.candidateNonSeenMessageCount !== undefined && data.candidateNonSeenMessageCount > prevCandidateMessages) {
            //   const newCount = data.candidateNonSeenMessageCount - prevCandidateMessages;
            //   this.toasterService.showStreamNotification('candidateNonSeenMessage', newCount);
            // }

          }

          // The count is only a "something arrived" ping. What actually gets a
          // toaster is decided by notifyId against the seen-ledger and the login
          // cutoff. The increase is measured against the previous stream frame, not
          // `notificationcount`, which is also written by getUserHeaderCount() and
          // the searchData count subject. The first frame has nothing to compare
          // with, so it fetches.
          // This runs regardless of `headerCountsLoaded`: fetchAndShowLatestNotification()
          // is replay-safe on its own (ledger + cutoff + baseline-on-first-response).
          if (data.notification !== undefined) {
            const prevStreamCount = this.lastStreamNotificationCount;
            this.lastStreamNotificationCount = Number(data.notification) || 0;
            if (prevStreamCount === null || this.lastStreamNotificationCount > prevStreamCount) {
              this.fetchAndShowLatestNotification();
            }
          }

          if (data.message != undefined) {
            this.notificationDatasshow.message = data.message || '';
          }
          if (data.notification != undefined) {
            this.notificationcount = data.notification || '';
          }
          this.notificationDatasshow.newPost = data.newPost || '';
          this.notificationDatasshow.notification = data.notification || '';
          this.notificationDatasshow.resumeRequestReceivedCount = data.resumeRequestReceivedCount || 0;
          this.notificationDatasshow.unreadUserMsgCount = data.unreadUserMsgCount || 0;
          this.commonValues.setMsgCount(data.messageBottomChat || 0);

        }
      }
    });

    this.userProfileDetails();
    this.checkUserProfileStatus();
    this.profilePhoto.getPhoto()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.photoId = res;
        this.img = {
          src:
            res && res.photo !== undefined && res.photo !== null && res.photo !== ""
              ? AppSettings.ServerUrl + "download/" + res.photo
              : null,
        };
      });
    this.searchData.getNotificationCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (!this.notificationDatasshow) {
          this.notificationDatasshow = {};
        }
        this.notificationDatasshow.message = res.unreadUserMsgCount;
        this.notificationcount = res.notificationcount;
        // const notificationCount = this.notificationcount
        // const userType = this.userType
        // const userId = this.userId
        // this.userService.setUserData({userType, userId, notificationCount});
      })
    this.searchData.getuserType()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        setTimeout(() => {
          this.userType = res.userType;
          this.cdr.detectChanges();
        }, 0);
      })
    // The /notifications page marks items read against its own fetched list;
    // pick up its broadcast so a notification already open in this flyout
    // panel flips to read/white too, instead of staying stuck until reopened.
    this.searchData.getNotificationRead()
      .pipe(takeUntil(this.destroy$))
      .subscribe(notifyId => {
        const item = this.notifPanelList.find(n => n.id === notifyId);
        if (item) {
          item.unread = false;
        }
      })
    this.searchData.getHighlighter()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.setHighLighter(res)
      })
    this.userId = localStorage.getItem("userId");
    this._route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if (res.showWelcomePost == "true") {
          setTimeout(() => {
            this.userType = localStorage.getItem('userType') as USER_TYPE;
          }, 4000);
        }
      })
    this.a = this._route.pathFromRoot[0]['_routerState']['snapshot'].url
    this.updatePageName(this.a);

    this.commonValues.startTour$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.startTour = true;
      });


    businessSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe((resolveData: any) => {
        if (resolveData) {
          this.businessDetails = resolveData;
        }
        this.updateBusinessMenuVisibility();
      });


  }
  config2 = {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html("");
        }
      },
      onKeydown: function (e) {
        var t: string = e.currentTarget.innerText;
        var words = t.split(" ");

      }
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      [
        "font",
        [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript",
          "clear",
        ],
      ],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: [
      "Helvetica",
      "Arial",
      "Arial Black",
      "Comic Sans MS",
      "Courier New",
      "Roboto",
      "Times",
    ], onPaste(e) {
      const buffertext = (e.originalEvent || e).clipboardData.getData("text");
      e.preventDefault();
      const all = buffertext.trim();
      document.execCommand("insertText", false, all.substring(0, 1000));
    },
  };

  // Job Description Summernote config - blocks images/videos
  // Job Description config - blocks images/videos (matching gigsumo-admin customer-detail config)
  jobDescConfig: any = {
    placeholder: '',
    tabsize: 2,
    height: 150,
    focus: false,
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    toolbar: [
      ['misc', ['codeview', 'undo', 'redo']],
      ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
      ['fontsize', ['fontname', 'fontsize', 'color']],
      ['para', ['style', 'ul', 'ol', 'paragraph', 'height']]
    ],
    fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times'],
    callbacks: {
      onPaste: function(e) {
        // Stop Summernote's Clipboard module from processing images
        e.stopImmediatePropagation();
        e.preventDefault();
        // Only allow plain text
        const bufferText = (e.originalEvent || e).clipboardData.getData('text');
        const cleanText = bufferText.trim();
        document.execCommand('insertText', false, cleanText);
      },
      onImageUpload: function(files) {
        // Block image upload completely
        return false;
      }
    }
  };
  userProfileDetails() {
    let data: any = {};
    data.userId = localStorage.getItem('userId');
    data.userType = localStorage.getItem('userType');

    this.API.create('user/profileDetails', data).toPromise()
      .then(profileResponse => {
        if (profileResponse.code !== GigsumoConstants.SUCESSCODE) {
          throw new Error("Server Exception");
        }
        localStorage.setItem("timezonedate", profileResponse.data.userData.timeZone);
        return profileResponse.data;
      })
      .catch(error => {
        throw error;
      });
  }
  timezonepopup() {
    this.createJobsOrCandidates(this.currentEntity, this.jobCandidateTemplate);
  }
  get showJobsButton(): boolean {
    return this.userType === 'RECRUITER' || this.userType === 'FREELANCE_RECRUITER' || this.userType === 'MANAGEMENT_TALENT_ACQUISITION';
  }

  get showCandidateButton(): boolean {
    return this.userType === 'BENCH_RECRUITER' || this.userType === 'FREELANCE_RECRUITER' || this.userType === 'MANAGEMENT_TALENT_ACQUISITION' || this.userType === 'JOB_SEEKER';
  }


  highlightMenu(value: string) {
    switch (value) {
      case "":
        break;
      default: ""
    }
  }
  userDetailPage: boolean = false
  pageName: any = null
  activeAppId: string = '';
  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]+.[a-zA-Z]{2,4}$";
  a: any;
  b: any;
  domainForm: UntypedFormGroup
  domainForfreeLauchtimezoneFromm: UntypedFormGroup
  clientTypeListprofile: Array<string> = ['Direct Client', 'Supplier', 'Systems Integrator', 'Prime Vendor', 'Vendor', 'Staffing Agency']
  activejobcount: number = 0;
  activeCandidatesCount: number = 0;
  totalCount: number = 0;
  showingcount: boolean = false;
  loadAPIcall: boolean = false;
  startTour: boolean = false;
  tourSteps: any[] = [];
  currentPath: string;

  openTourModal(welcometour:any) {
    if (this.tourModalShown) {
    console.log('[NavBar] Tour modal already shown, skipping duplicate call');
    return;
  }
  this.tourModalShown = true;
    this.modalService.hide(1);
    setTimeout(() => {
      // Match any landing-page URL (including role-specific child routes
      // like `/landingPage/bench`, `/landingPage/recruiter`,
      // `/landingPage/feed`, `/landingPage/business`). Earlier variants
      // used `substring(0, 20)` and then a strict `=== '/landingPage'`
      // check; both silently skipped the welcome modal for users whose
      // post-onboarding redirect lands on a child route.
      const pathOnly = this.router.url.split('?')[0];
      this.currentPath = pathOnly;
      const ut = localStorage.getItem('userType');

      if (pathOnly.startsWith('/landingPage') && ut !== 'JOB_SEEKER') {
        if (!welcometour) return;
        const config: ModalOptions = { backdrop: 'static', keyboard: false };
        this.TourmodalRef = this.modalService.show(welcometour, config);
      }
    }, 1000);
  }
  canDeactivate(): boolean {
    // Prevent navigation by returning false
    return false;
  }

  startUI() {
    this.TourmodalRef.hide();
    localStorage.setItem("tourshowed", 'true');
    this.startTour = true;

    // Persist tour completion the moment the user clicks "Get Started", instead of
    // relying ONLY on the joyride `complete` callback. In PROD the joyride chain can
    // silently break before `complete` (slow render / missing DOM target), so
    // updateUserGuidelines was never called and the onboarding popup kept re-showing
    // on every login. "Get Started" is a guaranteed click event, so firing the POST
    // here marks the tour done up-front and the popup never returns even if the tour
    // is interrupted. The per-step / `complete` updates still refine saved progress.
    const finalStep = this.tourSteps && this.tourSteps.length > 0
      ? this.tourSteps[this.tourSteps.length - 1].stepId
      : null;
    if (finalStep) {
      this.tourService.updateTour('LandingPage', finalStep);
      this.tourService.updateTourAPI();
    }

    // The tour's `step.userbadge` step targets `<app-user-badge>`, which is
    // only rendered inside the Activity Feed tab. Default-routing now puts
    // recruiter/bench-sales users on their dashboards, so before starting
    // joyride we navigate to `/landingPage/feed` and wait a tick for the
    // tab content to render — otherwise the badge step has no DOM target
    // and the joyride chain silently breaks at step 1.
    const startJoyride = () => {
      this.tourService.startTourForComponent('LangdingPageNavBarComponent', 'LandingPage');
    };
    const onFeed = (this.router.url.split('?')[0] || '').startsWith('/landingPage/feed');
    if (onFeed) {
      startJoyride();
      return;
    }
    this.router.navigate(['/landingPage', 'feed']).then(() => {
      setTimeout(startJoyride, 200);
    });
  }

  closeTour() {
    this.TourmodalRef.hide();
    localStorage.setItem("tourshowlater", 'true');
    localStorage.setItem('tourshowlater_timestamp', new Date().toISOString());
    console.log('[NavBar] closeTour — user skipped onboarding tour');
    this.tourService.markLandingTourComplete('show-me-later');
      this.tourModalShown = false;
  }

  getTourData(stepId: string, key: string): string {
    const step = this.tourSteps.find(s => s.stepId === stepId);
    return step ? step[key] : 'Loading...';
  }



  userType: USER_TYPE;
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
    this.restoreGlobalSearch();

    const userType = localStorage.getItem('userType');
    const data: any = {};
    data.userId = this.userId;
    if (userType == "null" || userType == undefined) {
      this.router.navigate(["userClassification"], { queryParams: data });
    }

    // Apply body overflow logic on initial load for /newjobs and /newcandidates
    const currentUrl = this.router.url;
    const isTargetRoute = currentUrl.includes('/newjobs') || currentUrl.includes('/newcandidates');
    this.toggleBodyOverflow(!isTargetRoute);

    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    this.seedNotificationBaseline();
    this.instantiateComponent();
    this.apicallforDowngrade();
    this.updateSupportModule();

    this.instantiateDependencies();
    this.initializeAppsList();

    this.jobCreationTrigger.trigger$
      .pipe(takeUntil(this.destroy$))
      .subscribe(entity => this.createJobsOrCandidates(entity, this.jobCandidateTemplate));

    this.domainForm = this.formBuilder.group({
      priEmail: null,
      secEmail: null,
      swapEmail: [null, [Validators.required,
      Validators.email,
      Validators.pattern(this.emailPattern)]],
      domainValidationOtp: null,
    })
    if (this.b == 'userClassification') {
      this.userDetailPage = true
    } else {
      this.userDetailPage = false
    }

    setTimeout(() => {
      this.onChangeProfile();
    }, 1000);

    // Expose test method to window for console testing
    (window as any)['testToaster'] = this.testToaster.bind(this);

    this.globalSearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(
      res => {
        this.onChangeSearch(res);
      }
    )
    this.searchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    ).subscribe(
      res => {
        this.patchEmail(res);
      }
    )
    const userGuidelines = localStorage.getItem('userGuidelines');
    const tourshowlater = localStorage.getItem('tourshowlater');

    // Fresh-user check: userGuidelines is unset (null / "null" / "[]" /
    // "undefined"), user hasn't explicitly dismissed the tour via
    // "Show me later", and they aren't a JOB_SEEKER (no tour defined).
    const isFresh = userGuidelines === null || userGuidelines === 'null' || userGuidelines === '[]' || userGuidelines === 'undefined';
    const notDismissed = tourshowlater !== 'true';
    const tourableUser = localStorage.getItem('userType') !== 'JOB_SEEKER';

    if (isFresh && notDismissed && tourableUser) {
      this.openTourModal(this.welcometour);
    } else {
      localStorage.setItem('tourshowed', 'true');

      // Check if a tour is currently in progress (user refreshed during tour)
      const isTourInProgress = this.tourService.isTourInProgress('LangdingPageNavBarComponent');
      const tourStarted = localStorage.getItem('tourStarted_LangdingPageNavBarComponent') === 'true';

      console.log('[NavBar] Tour in progress check:', { isTourInProgress, tourStarted });

      if (isTourInProgress || tourStarted) {
        // Resume the tour from the last step if user refreshed during tour
        console.log('[NavBar] Tour in progress or started, resuming tour');
        setTimeout(() => {
          this.resumeTour();
        }, 400);
      }
    }

    this.orgNameSubject.pipe(debounceTime(1000), distinctUntilChanged()).subscribe(res => { this.getOrganization1(res); })

    // Subscribe to resume parser progress updates once during initialization
    this.resumeParserService.progress$.subscribe(progress => {
      console.log('Progress update from service:', progress);

      // Only update if not simulating or if it's a major update
      if (!this.progressSimulationInterval || progress >= 70 || progress === 0) {
        this.uploadProgress = progress;
      }

      // Start simulated progress increments when API call starts (at 30%)
      if (progress === 30 && !this.progressSimulationInterval) {
        console.log('Starting progress simulation at 30%');
        this.progressSimulationInterval = setInterval(() => {
          if (this.uploadProgress < 68) {
            this.uploadProgress += 1; // Increment by 1% every 150ms
            console.log('Simulating progress:', this.uploadProgress);
          }
        }, 150); // Faster increments (every 150ms)
      }

      // Stop simulation when real progress updates arrive (70% or higher)
      if (progress >= 70 && this.progressSimulationInterval) {
        console.log('Stopping simulation, real progress:', progress);
        clearInterval(this.progressSimulationInterval);
        this.progressSimulationInterval = null;
        this.uploadProgress = progress;
      }

      // Hide progress bar when complete (100%)
      if (progress === 100) {
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        setTimeout(() => {
          this.isUploading = false;
          this.uploadProgress = 0;
        }, 500);
      } else if (progress === 0 && this.isUploading && this.uploadProgress > 0) {
        // Error occurred during upload
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        this.isUploading = false;
        this.uploadProgress = 0;
      }
    });

  }

  truncateMiddle(text: string): string {
    // If text is short enough to fit in the container, return it as is
    const maxWidth: number = 20
    const startPercentage: number = 0.75
    const endPercentage: number = 0.15
    if (text.length <= maxWidth) {
      return text;
    }

    // Calculate how many characters to keep from start and end
    const totalCharsToKeep = Math.floor(maxWidth * 0.9); // 90% for text (10% for ellipsis)
    const startChars = Math.floor(totalCharsToKeep * startPercentage);
    const endChars = Math.floor(totalCharsToKeep * endPercentage);

    // Get the start and end portions
    const startPortion = text.substring(0, startChars);
    const endPortion = text.substring(text.length - endChars);

    // Return the truncated text with ellipsis
    return `${startPortion}...${endPortion}`;
  }


  resumeTour() {
    console.log('[NavBar] resumeTour - Starting tour resume logic');
    const lastTourStep = localStorage.getItem('lastTourStep_LangdingPageNavBarComponent');
    const tourStarted = localStorage.getItem('tourStarted_LangdingPageNavBarComponent') === 'true';
    const isCompleted = localStorage.getItem('tourCompleted_LangdingPageNavBarComponent') === 'true';

    console.log('[NavBar] resumeTour - localStorage values:', {
      lastTourStep,
      tourStarted,
      isCompleted
    });

    if (isCompleted) {
      console.log('[NavBar] resumeTour — landing tour already completed');
      this.tourService.markLandingTourComplete('resume-already-complete');
      return;
    }

    // If we have a lastTourStep, use it to resume from that step
    if (lastTourStep) {
      console.log('[NavBar] resumeTour - Resuming from lastTourStep:', lastTourStep);
      this.tourService.resumeTourForComponent('LangdingPageNavBarComponent', 'LandingPage');
    } else if (tourStarted) {
      // If tour was started but no lastTourStep (refresh on step 1), start from beginning
      console.log('[NavBar] resumeTour - Tour was started but no lastTourStep, starting tour from step 1');
      this.tourService.startTourForComponent('LangdingPageNavBarComponent', 'LandingPage');
    } else {
      console.log('[NavBar] resumeTour - No tour in progress');
    }
  }


  notificationTitle: string = "";
  notificationContent: string = "";
  notificationButtonName: string = "Add Backup Email";
  showSecondaryAlert: boolean = false;

  onLandingTourStepDone(event: any) {
    console.log('[NavBar] ===== onLandingTourStepDone CALLED =====');
    console.log('[NavBar] Event received:', event);
    const stepId = event?.name || event;
    console.log('[NavBar] joyride (done) event for step:', stepId);
    const navBarSteps = this.tourSteps.filter(
      s => s.componentId === 'LangdingPageNavBarComponent'
    );
    console.log('[NavBar] Available tour steps:', navBarSteps.map(s => s.stepId));
    if (!navBarSteps.length) {
      console.log('[NavBar] onLandingTourStepDone — tour steps not loaded yet');
      return;
    }
    // Trigger secondary email popup for ANY Done click, not just the last step
    console.log('[NavBar] Calling markLandingTourComplete for Done click on step:', stepId);
    document.body.classList.remove('noscroll');
    this.tourService.markLandingTourComplete('joyride-done-' + stepId);
    // Direct call to ensure secondary email popup shows
    setTimeout(() => {
      console.log('[NavBar] Directly calling checkBackupEmailPrompt as fallback');
      this.checkBackupEmailPrompt();
    }, 200);
  }

  checkBackupEmailPrompt() {
    console.log('[NavBar] ===== checkBackupEmailPrompt CALLED =====');
    const tourPending = this.tourService.isLandingTourPending();
    console.log('[NavBar] checkBackupEmailPrompt', {
      backupEmailPromptShown: this.tourService.hasShownBackupEmailPrompt(),
      tourPending,
      tourshowlater: localStorage.getItem('tourshowlater'),
      userType: localStorage.getItem('userType'),
    });

    // Clear the flag for testing since it was set from previous tests
    if (this.tourService.hasShownBackupEmailPrompt()) {
      console.log('[NavBar] backup email prompt already shown, clearing flag for testing');
      localStorage.removeItem('backupEmailPromptShown');
    }

    console.log('[NavBar] calling home/checkSecondaryIsNonGenericMail');
    this.API.query('home/checkSecondaryIsNonGenericMail').subscribe((res) => {
      console.log('[NavBar] checkSecondaryIsNonGenericMail response', res);
      console.log('[NavBar] Full response structure:', JSON.stringify(res));
      if (res?.data?.show) {
        console.log('[NavBar] API says show backup email popup');
        this.tourService.markBackupEmailPromptShown();
        this.notificationTitle = 'Add a Backup Email';
        this.notificationButtonName = 'Add Backup Email';
        this.notificationContent = res.data.isSecondaryNull
          ? 'Secondary email address is missing in your profile. It is mandatory to maintain your account on the platform. Please update your profile with a secondary email address.'
          : 'Please change your secondary email address to a generic one (Hotmail, Gmail etc) in the profile';
        this.showSecondaryAlert = false;
        setTimeout(() => {
          console.log('[NavBar] showing backup email popup - showSecondaryAlert set to true');
          this.showSecondaryAlert = true;
        }, 0);
      } else {
        console.log('[NavBar] API says do not show backup email popup - res.data.show:', res?.data?.show);
      }
    }, (err) => {
      console.error('[NavBar] checkSecondaryIsNonGenericMail error', err);
    });
  }

  getTheEmailSearchContent(value: string) {
    this.searchSubject.next(value);
  }
  getOrganisationName(value: string) {
    this.orgNameSubject.next(value);
  }
  membershipType = localStorage.getItem('MemberShipType');

  async apicallforDowngrade() {
    this.util.startLoader();
    this.loadAPIcall = true;
    const maxRetries = 5;
    let retryCount = 0;
    let planbenefits: any = null;

    //Retry function called when we getting lambda delay by monisha
    const exponentialDelay = (attempt: number) => {
      const delayTime = Math.pow(2, attempt) * 1000;
      return new Promise(resolve => setTimeout(resolve, delayTime));
    };

    // Function to make the API call and retry if necessary
    const fetchPlanBenefits = async () => {
      while (retryCount < maxRetries) {
        try {
          planbenefits = await this.API.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));

          if (planbenefits && planbenefits.data) {
            return planbenefits; // Success, return data
          }

          // Log when retrying

        } catch (error) {

        }

        retryCount++;
        await exponentialDelay(retryCount); // Exponential backoff delay
      }
      return null; // If all retries fail, return null
    };

    // Call the fetch function
    planbenefits = await fetchPlanBenefits();

    if (this.userType !== "JOB_SEEKER" && planbenefits && planbenefits.data != undefined) {
      this.util.stopLoader();
      this.loadAPIcall = false;
      this.showingcount = true;
      let isDowngraded: boolean = false;
      let isPromotional: boolean = false;
      this.membershipType = planbenefits.data.userPlanAndBenefits && planbenefits.data.userPlanAndBenefits.membershipType;
      this.userService.updateUserPlanDetails(planbenefits.data.userPlanAndBenefits);
      localStorage.setItem("MemberShipType", planbenefits?.data?.userPlanAndBenefits?.membershipType);
      let localDate = new Date();
      let expiredDate = new Date(planbenefits.data.userPlanAndBenefits.toDate);

      // Promotional credits validation
      let promotionEndDate = null;
      if (planbenefits.data.userPlanAndBenefits.promotionsEndDate != null
        && planbenefits.data.userPlanAndBenefits.promotionsEndDate != undefined) {
        promotionEndDate = new Date(planbenefits.data.userPlanAndBenefits.promotionsEndDate);
      }

      if (planbenefits.data.userPlanAndBenefits.downgradeRequested != undefined
        && planbenefits.data.userPlanAndBenefits.downgradeRequested == true
        && localDate > expiredDate) {
        this.calculateCountsWhilePromotionIsOnOrNull(planbenefits, 'downgradeRequested');
      }

      if (localDate > expiredDate && planbenefits.data.userPlanAndBenefits.membershipType != "Free") {
        isDowngraded = true;
      }

      if (promotionEndDate != null && promotionEndDate < localDate) {
        isPromotional = true;
      }

      this.calculateCountsWhilePromotionOrPlanIsOver(planbenefits, isDowngraded, isPromotional);

      if (promotionEndDate != null && promotionEndDate > localDate && !isDowngraded) {
        this.calculateCountsWhilePromotionIsOnOrNull(planbenefits, 'onOrNull');
      }
    } else {

    }
  }

  // Exponential backoff delay function
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  calculateCountsWhilePromotionIsOnOrNull(planBenefits, param) {
    if (param == 'onOrNull') {
      this.entityCountConfig.modalTitle = 'Promotion Credits Minimized'
    }
    if (param == 'downgradeRequested') {
      this.entityCountConfig.modalTitle = 'Plan Downgrade Requested'
    }
    let openModal: boolean = false
    let candidateCount = 0
    let jobCount = 0
    if (planBenefits.data.activeCandidatesCount != undefined) {
      candidateCount = planBenefits.data.activeCandidatesCount
    }
    if (planBenefits.data.activeJobsCount != undefined) {
      jobCount = planBenefits.data.activeJobsCount
    }
    let totalCount: number = candidateCount + jobCount;
    let benefits: Array<any> = planBenefits.data.userPlanAndBenefits.benefitsUsages;
    benefits.forEach(ele => {
      if (ele.benefitKey == 'JOB_CANDIDATE_POSTINGS') {
        this.entityCountConfig.allowedJobsCandidatesCount = ele.actual + ele.promotional
        if (totalCount > (ele.actual + ele.promotional)) {
          openModal = true
          this.entityCountConfig.isPromotional = true;
        }
      }
      if (ele.benefitKey == 'TEAM_WORKSPACES') {
        this.entityCountConfig.allowedWorkspaceCount = ele.actual + ele.promotional
        if (ele.utilized > (ele.actual + ele.promotional)) {
          openModal = true
          this.entityCountConfig.isPromotional = true;
        }
      }
      if (ele.benefitKey == 'PERSONAL_NETWORKS') {
        this.entityCountConfig.allowedNetworksCount = ele.actual + ele.promotional
        if (ele.utilized > (ele.actual + ele.promotional)) {
          openModal = true
          this.entityCountConfig.isPromotional = true;
        }
      }
    })
    if (openModal) {
      this.openModals(planBenefits);
    }
  }
  calculateCountsWhilePromotionOrPlanIsOver(planBenefits, isDowngraded, isPromotional) {
    this.entityCountConfig.isDowngraded = isDowngraded == true ? true : false;
    this.entityCountConfig.isPromotional = isPromotional == true ? true : false;
    let totalcount = 0;
    if (planBenefits.data.activeCandidatesCount != undefined) {
      totalcount = planBenefits.data.activeCandidatesCount
    }
    if (planBenefits.data.activeJobsCount != undefined) {
      totalcount = totalcount + planBenefits.data.activeJobsCount
    }
    if (isPromotional === true && isDowngraded == false) {
      this.entityCountConfig.modalTitle = 'Promotion Credits Exhausted'
    }
    if (isDowngraded === true && isPromotional == false) {
      this.entityCountConfig.modalTitle = `${planBenefits.data.userPlanAndBenefits.membershipType} Plan Expired`
    }
    if (isPromotional == true && isDowngraded == true) {
      this.entityCountConfig.modalTitle = `Promotion Credits and '${planBenefits.data.userPlanAndBenefits.membershipType}' Plan Expired`
    }
    let openModal: boolean = false
    let downgradePlanForJobAndCandidate: boolean = false
    let downgradePlanForNetwork: boolean = false
    let downgradePlanForTeam: boolean = false
    let benefits: Array<any> = planBenefits.data.userPlanAndBenefits.benefitsUsages;
    let data: any = {}
    benefits.forEach(ele => {
      if (ele.benefitKey == 'JOB_CANDIDATE_POSTINGS') {
        if (totalcount > GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT && isPromotional == true && isDowngraded == true) {
          openModal = true
          this.entityCountConfig.allowedJobsCandidatesCount = GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT
        } else if (totalcount > ele.actual && isPromotional == true && isDowngraded == false) {
          openModal = true
          this.entityCountConfig.allowedJobsCandidatesCount = ele.actual
        } else if (totalcount > (GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT + ele.promotional) && isPromotional == false && isDowngraded == true) {
          openModal = true
          this.entityCountConfig.allowedJobsCandidatesCount = GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT + ele.promotional;
        } else if ((isDowngraded == true || isPromotional == true) && totalcount <= GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT) {
          data.isDowngraded = this.entityCountConfig.isDowngraded
          data.isPromotional = this.entityCountConfig.isPromotional
          downgradePlanForJobAndCandidate = true
        }
      }
      if (ele.benefitKey == 'TEAM_WORKSPACES') {
        if (ele.utilized > GigsumoConstants.FREE_PLAN_TEAM_COUNT && isPromotional == true && isDowngraded == true) {
          openModal = true
          this.entityCountConfig.allowedWorkspaceCount = GigsumoConstants.FREE_PLAN_TEAM_COUNT
        } else if (isPromotional == false && isDowngraded == true && ele.utilized > (GigsumoConstants.FREE_PLAN_TEAM_COUNT + ele.promotional)) {
          openModal = true
          this.entityCountConfig.allowedWorkspaceCount = GigsumoConstants.FREE_PLAN_TEAM_COUNT + ele.promotional;
        } else if (isPromotional == true && isDowngraded == false && ele.utilized > ele.actual) {
          openModal = true
          this.entityCountConfig.allowedWorkspaceCount = ele.actual;
        } else if ((isDowngraded == true || isPromotional == true) && ele.utilized <= GigsumoConstants.FREE_PLAN_TEAM_COUNT) {
          data.isDowngraded = this.entityCountConfig.isDowngraded
          data.isPromotional = this.entityCountConfig.isPromotional
          downgradePlanForTeam = true
        }
      }
      if (ele.benefitKey == 'PERSONAL_NETWORKS') {
        if (ele.utilized > GigsumoConstants.FREE_PLAN_NETWORK_COUNT && isPromotional == true && isDowngraded == true) {
          openModal = true
          this.entityCountConfig.allowedNetworksCount = GigsumoConstants.FREE_PLAN_NETWORK_COUNT
        } else if (isDowngraded == true && isPromotional == false && (ele.utilized > GigsumoConstants.FREE_PLAN_NETWORK_COUNT + ele.promotional)) {
          openModal = true
          this.entityCountConfig.allowedNetworksCount = GigsumoConstants.FREE_PLAN_NETWORK_COUNT + ele.promotional;
        }
        // else if (isDowngraded == false && isPromotional == true && ele.utilized > ele.actual) {
        // }
        else if (isDowngraded == false && isPromotional == true && ele.utilized > ele.actual) {
          openModal = true
          this.entityCountConfig.allowedNetworksCount = ele.actual;
        } else if ((isDowngraded == true || isPromotional == true) && ele.utilized <= GigsumoConstants.FREE_PLAN_NETWORK_COUNT) {
          data.isDowngraded = this.entityCountConfig.isDowngraded
          data.isPromotional = this.entityCountConfig.isPromotional
          downgradePlanForNetwork = true
        }
      }
    })
    if (openModal && this.membershipType == 'Pro') {
      this.openModals(planBenefits);
    }
    if (downgradePlanForJobAndCandidate && downgradePlanForTeam && downgradePlanForNetwork && this.membershipType == 'Pro') {
      this.callDowngradeAPI(data, planBenefits);
    }
  }
  callDowngradeAPI(values, planBenefits) {
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.updateToFreePlan = values.isDowngraded === true ? true : false;
    data.expirePrmotional = values.isPromotional === true ? true : false;
    this.API.create('user/downgradeSubscriptionPlan', data).subscribe(
      res => {
        if (res.code == "00000") {
          localStorage.setItem('MemberShipType', 'Free');
          if (data.updateToFreePlan == true && data.expirePrmotional == true) {
            this.notificationTitle = this.prepareContent('title', planBenefits, 'both');
            this.notificationContent = this.prepareContent('text', planBenefits, 'both');
          } else if (data.updateToFreePlan == true && data.expirePrmotional == false) {
            this.notificationTitle = this.prepareContent('title', planBenefits, 'planExpired');
            this.notificationContent = this.prepareContent('text', planBenefits, 'planExpired');
          } else if (data.expirePrmotional == true && data.updateToFreePlan == false) {
            this.notificationTitle = this.prepareContent('title', planBenefits, 'promotionExpired');
            this.notificationContent = this.prepareContent('text', planBenefits, 'promotionExpired');
          }
          this.showSecondaryAlert = true;
        } else if (res.code === "99998") {
          Swal.fire({
            icon: "info",
            title: "Plan already downgraded",
            timer: 2000
          })
        }
      },
      error => {
        this.util.stopLoader();
      })
  }
  prepareContent(param: 'title' | 'text', content, scenario: 'promotionExpired' | 'planExpired' | 'both'): string {
    if (scenario == 'promotionExpired') {
      if (param == 'title') {
        return `Promotion Credits Expired`;
      }
      if (param == 'text') {
        return `Your Promotional Credits have been expired on ${this.dateFormat(content.data.userPlanAndBenefits.promotionsEndDate)}`;
      }
    } else if (scenario == 'planExpired') {
      if (param == 'title') {
        return `'${content.data.userPlanAndBenefits.membershipType}' Plan Expired`;
      }
      if (param == 'text') {
        return `Your plan is moved from '${content.data.userPlanAndBenefits.membershipType}' to 'Free' as it had expired on ${this.dateFormat(content.data.userPlanAndBenefits.toDate)}`
      }
    } else if (scenario == 'both') {
      if (param == 'title') {
        return `'${content.data.userPlanAndBenefits.membershipType}' Plan and Promotional Credits Expired`
      }
      if (param == 'text') {
        return `Your '${content.data.userPlanAndBenefits.membershipType}' Plan and Promotional Credits have both expired on ${this.dateFormat(content.data.userPlanAndBenefits.toDate)} and
        ${this.dateFormat(content.data.userPlanAndBenefits.promotionsEndDate)} respectively. And your plan is downgraded to 'Free'.`
      }
    }
  }
  entityCountConfig: any = {
    allowedJobsCandidatesCount: GigsumoConstants.FREE_PLAN_JOB_CANDIDATE_COUNT,
    allowedContactsCount: 0,
    allowedWorkspaceCount: GigsumoConstants.FREE_PLAN_TEAM_COUNT,
    allowedInteractionsCount: 0,
    allowedNetworksCount: GigsumoConstants.FREE_PLAN_NETWORK_COUNT,
    modalTitle: '',
    isPromotional: false,
    isDowngraded: false,
    showClosButton: false
  }

  openModals(planBenefits) {
    this.entityCountConfig.planBenefits = planBenefits
    const initialState: CustomModalOptions = {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg',
      ignoreBackdropClick: true,
      data: this.entityCountConfig
    }
    this.bsModalRef = this.modalService.show(PlanDowngradeModelComponent,
      Object.assign({ initialState }, initialState)
    );
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  onChangeProfile(event: boolean = false) {
    if (!event) {
      this.userProfileUpdate();
    }
    else if (event) {
      // if (this.userTypeunder == null || this.gigsumono == null) {
      this.userProfileUpdate();
      // }
    }
  }
  loginUser: any = {};
  loginPhoto: string | null = null; // Initialize to null
  userProfileUpdate() {
    // Invalidate user cache to ensure fresh data is fetched (especially for first sign-up or profile changes)
    this.cacheInvalidationService.invalidateCurrentUserCache();

    this.API.query("user/" + localStorage.getItem('userId')).subscribe((res) => {
      if (res) {
        setTimeout(() => {
          this.userTypeunder = res.userType;
          this.gigsumono = res.gigsumoNo;
          this.UserName = res.firstName + " " + res.lastName
          this.emailid = res.email;
          this.companyName = res?.workExperience?.find(e => e.currentOrganization)?.organisationName || null;

          // Convert userType to display-friendly format
          if (this.userTypeunder == 'MANAGEMENT_TALENT_ACQUISITION') {
            this.userTypeunder = 'Manager';
          } else if (this.userTypeunder == 'BENCH_RECRUITER') {
            this.userTypeunder = 'Bench Sales';
          } else if (this.userTypeunder == 'FREELANCE_RECRUITER') {
            this.userTypeunder = 'Freelancer';
          } else {
            this.userTypeunder = this.userTypeunder && this.userTypeunder.replaceAll("_", " ");
          }

          this.cdr.detectChanges();
        }, 0);

        const data = res.workExperience;
        if (data) {
          this.currentOrgProvider.setCurrentOrg({ gigNo: res.gigsumoNo, ...data.find(x => x.currentOrganization === true) });
        }

        // Fix photo URL to prevent double prepending
        // Check if photo already contains the full download URL path to avoid double prepending
        if (res.photo && res.photo != null) {
          // If photo already starts with http:// or https://, use as-is
          if (res.photo.startsWith('http://') || res.photo.startsWith('https://')) {
            this.loginPhoto = res.photo;
          }
          // If photo already contains '/download/', it's already been processed
          else if (res.photo.includes('/download/')) {
            this.loginPhoto = res.photo.startsWith('/') ? (AppSettings.ServerUrl.replace(/\/$/, '') + res.photo) : res.photo;
          }
          // Otherwise, it's just the file ID, prepend the full URL
          else {
            this.loginPhoto = AppSettings.photoUrl + res.photo;
          }
        } else {
          this.loginPhoto = null;
        }

        this.loginUser = res;
      }
    });
  }
  instantiateComponent() {
    this.generateYearsprofile();
    this.profileStatus();
  }




  modelclose(data) {
    this.showModal = false
    this.modalService.hide(1);
  }

  setHighLighter(value) {
    this.pageName = value;
  }

  updatePageName(url: string) {
    const a = url;
    console.log('updatePageName called with URL:', a);
    this.pageName = '';
    this.activeAppId = '';
    
    // Check specific landingPage sub-routes first before the general landingPage
    if (a.includes('/newcandidates')) {
      this.pageName = 'newcandidates'
    } else if (a.includes('/newjobs')) {
      this.pageName = 'newjobs'
    } else if (a.includes('/landingPage/business')) {
      this.pageName = 'business'
    } else if (a.includes('/landingPage/network')) {
      this.pageName = 'network'
    } else if (a.includes('/landingPage/connection')) {
      this.pageName = 'connection'
    } else if (a.includes('/landingPage/team')) {
      this.pageName = 'workspace'
    } else if (a.includes('/landingPage/membernetworkListing')) {
      this.pageName = 'member'
    } else if (a.includes('/landingPage/b2bnetworkListing')) {
      this.pageName = 'business-network'
    } else if (a.startsWith('/landingPage')) {
      // All other landingPage routes (feed, bench, recruiter, etc.) should highlight Home
      this.pageName = 'landingPage'
    } else if (a.includes('/message')) {
      this.pageName = 'message'
    } else if (a.includes('/notification')) {
      this.pageName = 'notification'
    } else if (a.includes('/community')) {
      this.pageName = 'community'
      this.activeAppId = 'community'
    } else if (a.includes('/contract-center')) {
      this.pageName = 'contract-center'
      this.activeAppId = 'contract-center'
    } else if (a.includes('/user-management/company/profile')) {
      this.pageName = 'admin-center'
      this.activeAppId = 'admin-center'
    } else if (a.includes('/billing-center')) {
      this.pageName = 'billing-center'
      this.activeAppId = 'billing-center'
    } else if (a.includes('/job-center')) {
      this.pageName = 'job-center'
      this.activeAppId = 'job-center'
    } else if (a.includes('/talent-center')) {
      this.pageName = 'talent-center'
      this.activeAppId = 'talent-center'
    } else if (a.includes('talent-pools') || a.includes('Talent Pools')) {
      this.pageName = 'talent-pools'
    }
    console.log('updatePageName set pageName to:', this.pageName);
  }

  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: "modal-small",
    // scroll
  };
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  createAJob(postTemplate: TemplateRef<any>) {
    this.modalRef = this.modalService.show(postTemplate, this.backdropConfig);
  }
  openEmailDomain(postTemplate: TemplateRef<any>) {
    this.modalRef = this.modalService.show(postTemplate, this.backdropConfig);
  }
  get jobControls() {
    return this.jobPostForm.controls
  }
  candidatePostForm: UntypedFormGroup;
  get candidateControls() {
    return this.candidatePostForm.controls;
  }

  // JD Parsing state getters
  get isJdParsing(): boolean {
    return this.jdParsingService.isJdParsing;
  }

  get jdParseSuccess(): boolean {
    return this.jdParsingService.jdParseSuccess;
  }

  get jdParseFailed(): boolean {
    return this.jdParsingService.jdParseFailed;
  }

  // Parse job description method
  parseJobDescription(): void {
    // Initialize JD parsing service with form and config
    this.jdParsingService.patchFormToService(this.jobPostForm, {
      engagementTypeList: this.engagementTypeList,
      payTypeList: this.payTypeList,
      countryList: this.countryList,
      years: this.years,
      Toyears: this.Toyears,
      years2: this.years2,
      durationTypeList: this.durationTypeList,
      usStatesList: this.usStatesList,
      stateListCA: this.stateListCA,
      stateListIN: this.stateListIN,
      stateListAU: this.stateListAU
    });

    // Subscribe once to update ng-select bindings after parse completes
    this.jdParsingService.parsedSkills$.pipe(take(1)).subscribe(({ primarySkills, secondarySkills }) => {
      this.primarySkillsSelected = primarySkills;
      this.secondarySkillsSelected = secondarySkills;
      // Add parsed skills to available option lists so ng-select can display them
      [...primarySkills, ...secondarySkills].forEach(skill => {
        if (!this.primarySkillsList.includes(skill)) this.primarySkillsList.push(skill);
        if (!this.secondarySkillsList.includes(skill)) this.secondarySkillsList.push(skill);
      });
    });

    this.jdParsingService.parseJobDescription();
  }

  onChangeCountrypatchvalue(event, value, index) {
    if (value == "work") {
      this.workExperience.controls[index].patchValue({
        state: null,
        zipcode: null,
        city: null,
        country: event,
      });
      this.workExperience.controls.forEach((ele) => {
        ele.get("state").setValidators([Validators.required]);
        ele.get("state").updateValueAndValidity();
      });
    }
    if (event == "United States") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListAU = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListIN = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListCA = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else {
    }
  }
  onChngOrg1(value, index) {
    var data = value.organizationName + "/" + value.organizationId;
    this.util.startLoader();
    this.API.query("care/organization/" + data).subscribe((res) => {
      if (res) {
        const organisationSuggestedDetail = res[0]
        this.workExperience.controls[index].get('timeZone').enable()
        this.timeZonecountryvalues(res[0].countryCode);
        if (res[0].businessId) {
          this.workExperience.controls[index].get('country').disable()
          this.workExperience.controls[index].get('city').disable()
          this.workExperience.controls[index].get('state').disable()
          this.workExperience.controls[index].get('zipcode').disable()
          this.util.startLoader();
          this.API.query("business/details/" + res[0].businessId).subscribe((res) => {
            if (res.code == '00000') {
              this.util.stopLoader();
              if (res.data.businessModelList[0].organizationType && res.data.businessModelList[0].organizationType != null) {
                this.workExperience.controls[index].get('clientType').disable()
              } else {
                this.workExperience.controls[index].get('clientType').enable()
              }
              this.onChangeCountrypatchvalue(res.data.businessModelList[0].companyLocationDetails[0].country, 'work', index)
              setTimeout(() => {
                this.workExperience.controls[index].patchValue({
                  organisationId: organisationSuggestedDetail.organizationId,
                  clientType: res.data.businessModelList[0].organizationType,
                  country: res.data.businessModelList[0].companyLocationDetails[0].country,
                  city: res.data.businessModelList[0].companyLocationDetails[0].city,
                  state: res.data.businessModelList[0].companyLocationDetails[0].state,
                  zipcode: res.data.businessModelList[0].companyLocationDetails[0].zipCode
                })
              }, 500);
            } else {
              this.util.stopLoader();
              this.workExperience.controls[index].get('clientType').enable()
              this.workExperience.controls[index].get('country').enable()
              this.workExperience.controls[index].get('city').enable()
              this.workExperience.controls[index].get('state').enable()
              this.workExperience.controls[index].get('zipcode').enable()
              this.workExperience.controls[index].patchValue({
                clientType: null,
                country: null,
                city: null,
                state: null,
                zipcode: null
              })
            }
          }, err => {
            this.util.stopLoader();
            this.workExperience.controls[index].get('clientType').enable()
            this.workExperience.controls[index].get('country').enable()
            this.workExperience.controls[index].get('city').enable()
            this.workExperience.controls[index].get('state').enable()
            this.workExperience.controls[index].get('zipcode').enable()
            this.workExperience.controls[index].patchValue({
              clientType: null,
              country: null,
              city: null,
              state: null,
              zipcode: null
            })
          })
        } else {
          this.onChangeCountry(value.country, '');
          this.workExperience.controls[index].get('clientType').enable()
          this.workExperience.controls[index].get('country').enable()
          this.workExperience.controls[index].get('city').enable()
          this.workExperience.controls[index].get('state').enable()
          this.workExperience.controls[index].get('zipcode').enable()
          this.workExperience.controls[index].patchValue({
            clientType: null,
            country: value.country,
            city: value.city,
            state: value.state,
            zipcode: value.zipCode
          })
        }
      }
      setTimeout(() => {
        var data: any = {}
        data.userId = this.userId
        data.businessId = value.businessId
        data.organisationId = value.organizationId
        this.API.create('business/find/superadmin', data).subscribe(res => {
          if (res.code == '0000') {
            this.util.stopLoader()
            this.workExperience.controls[0].get("city").disable()
            this.workExperience.controls[0].get("state").disable()
            this.workExperience.controls[0].get("country").disable()
            this.workExperience.controls[0].get("zipcode").disable()
          } else {
            this.util.stopLoader()
          }
        })
      }, 500);
    }, err => {
      this.util.stopLoader();
    });
  }
  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }
  // Tracks the most recent clientName autocomplete selection so the createJob
  // submit can resolve behalfOfBusinessId. Free-text edits reset these via
  // getOrganization1.
  selectedClientBusinessId: string = '';
  selectedClientBusinessName: string = '';
  selectedClientSource: 'EXTERNAL' | 'INTERNAL' | '' = '';

  onChngOrg2(event, source: 'INTERNAL' | 'EXTERNAL' = 'INTERNAL') {
    this.selectedClientBusinessId = event.organizationId || event.businessId || '';
    this.selectedClientBusinessName = event.organizationName || '';
    this.selectedClientSource = source;
  }
  OnChangeCurrentOrg(selectedOrg: string) {
    if (this.jobPostForm.get('clientType').value == GigsumoConstants.DIRECT_HIRE) {
      this.jobPostForm.patchValue({ clientName: this.jobPostForm.get("jobPostedBehalfOf").value })
      this.jobPostForm.get("clientName").disable();
    }
    this.jobPostedBehalfOflist.forEach(ele => {
      if (ele.orgName === selectedOrg && this.jobPostForm.get('clientType').value != GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.get('country').patchValue(ele.country);
      } else if (ele.orgName === selectedOrg && this.jobPostForm.get('clientType').value == GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.get('country').patchValue(ele.country);
        this.jobPostForm.get('state').patchValue(ele.state);
        this.jobPostForm.get('city').patchValue(ele.city);
        this.jobPostForm.get('zipCode').patchValue(ele.zipCode);
      }
    });
  }
  inboxCount: number = 0;
  labelToShow: Array<any> = [
    { value: 'Job Invites Sent', title: 'Outbox', url: 'JobInviteSentComponent', param: '', id: 'jobInviteSent', count: this.jobInvitesSentCount },
    { value: 'Job Applicants', title: 'Inbox', url: 'CandidateInviteComponent', param: '', id: 'jobApplicants', count: this.jobApplicationsReceivedCount },
    { value: 'Featured Candidates', title: 'Featured', url: 'FeaturedCandidateComponent', param: '', id: 'featureCandidates', count: this.totalFeaturedCandidatesCount },
    { value: 'Marketplace Candidates', title: 'Marketplace', url: 'SuggestedCandidateComponent', param: '', id: 'suggestedCadidate', count: this.totalSuggCandidatesCount },
    { value: 'Resume Requests Sent', title: 'Outbox', url: 'ResumeRequestSentComponent', param: '', id: 'resumeRequestSent', count: this.resumeRequestedCount },
    { value: 'Job Invites Received', title: 'Inbox', url: 'JobInviteComponent', param: '', id: 'jobInviteRecieved', count: this.jobInvitesReceivedCount },
    { value: 'Jobs Applied', title: 'Outbox', url: 'JobsAppliedByTheUserComponent', param: '', id: 'jobApplied', count: this.jobsAppliedCount },
    { value: 'Marketplace Jobs', title: 'Marketplace', url: 'SuggestedJobComponent', param: '', id: 'suggestedJobs', count: this.totalsuggJobsCount },
    { value: 'Featured Jobs', title: 'Featured', url: 'FeaturedJobsComponent', param: '', id: 'featureJobs', count: this.totalFeaturedJobsCount },
    { value: 'Resume Requests Received', title: 'Inbox', url: 'ResumeRequestComponent', param: '', id: 'resumeRequestRecieved', count: this.resumeRequestReceivedCount },
  ]
  isFreelanceorMTA(userType: string): boolean {
    return userType == GigsumoConstants.FREELANCE_RECRUITER || userType === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION;
  }
  labelsBasedonUserType(userType: string): Array<any> {
    return this.isFreelanceorMTA(userType) ? this.labelToShow : ((userType === GigsumoConstants.BENCH_RECRUITER || userType === GigsumoConstants.JOB_SEEKER) ? [...this.labelToShow].splice(5) : [...this.labelToShow].splice(0, 5))
  }
  figureLength: number = 0;
  selectedCountries: boolean = false
  typeTargetValue: null;
  organizationList: any = []
  // primarySkillsList: any = []
  // secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  jobPostedBehalfOflist: Array<{ country: string, orgName: string, state: string, city: string, zipCode: string }> = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  usStatesList = []
  jobId: any;
  jobClassificationList: any = []
  totalExperienceList = []
  periodList = []
  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;
  validateBeginning(year) {
    // var fromYear = this.jobPostForm.value.experienceFrom
    var toYear = this.jobPostForm.value.experienceTo
    if (toYear != null) {
      if (year > toYear) {
        return true
      } else {
        return false
      }
    }
  }
  resumeupload;
  fileTypeExtension: any;
  isParsing: boolean = false;
  parseSuccess: boolean = false;
  parseFailed: boolean = false;
  parsedResumeData: any = null;
  showParsedDetails: boolean = false;
  activeResumeTab: string = 'overview';

  // Upload progress tracking
  uploadProgress: number = 0;
  isUploading: boolean = false;
  progressSimulationInterval: any = null;
  // Kept so Clear can cancel an in-flight parse before its response refills the form
  private resumeParseSubscription: Subscription | null = null;

  // fileDragdrop: any;
  // removeFiles() {
  //   $("#fileDropRef")[0].value = '';
  //   this.fileDragdrop = "";
  //   this.resumeupload = "";
  //   this.tempFile = ""
  //   // this.prepareFilesList(null);
  // }

  filetoView: any
  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }
  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }
  tempFile: File | any;
  parseData: any;
  
  // Method to prioritize skills based on job title
  prioritizeSkillsByJobTitle(skills: string[], jobTitle: string): string[] {
    if (!skills || skills.length === 0) return skills;
    
    const titleLower = jobTitle.toLowerCase();
    const technicalSkills = [];
    const frameworkSkills = [];
    const toolSkills = [];
    const softSkills = [];
    
    // Define keyword mappings for different job types
    const jobKeywords = {
      developer: ['java', 'python', 'javascript', 'c++', 'c#', 'ruby', 'go', 'swift', 'kotlin', 'typescript', 'php', 'scala'],
      java: ['java', 'spring', 'hibernate', 'maven', 'gradle', 'junit', 'mockito', 'springboot', 'microservices', 'jpa'],
      frontend: ['javascript', 'react', 'angular', 'vue', 'html', 'css', 'typescript', 'webpack', 'sass', 'redux', 'next.js', 'jquery'],
      backend: ['nodejs', 'python', 'java', 'spring', 'django', 'express', 'mongodb', 'postgresql', 'mysql', 'redis', 'graphql', 'rest api'],
      fullstack: ['javascript', 'typescript', 'react', 'nodejs', 'mongodb', 'postgresql', 'express', 'angular', 'vue', 'docker', 'aws'],
      data: ['python', 'sql', 'pandas', 'numpy', 'spark', 'hadoop', 'tensorflow', 'scikit-learn', 'tableau', 'powerbi', 'r', 'matlab'],
      devops: ['docker', 'kubernetes', 'jenkins', 'aws', 'azure', 'terraform', 'ansible', 'ci/cd', 'linux', 'python', 'bash', 'git'],
      cloud: ['aws', 'azure', 'gcp', 'docker', 'kubernetes', 'terraform', 'serverless', 'lambda', 'microservices', 'cloud formation'],
      mobile: ['react native', 'flutter', 'swift', 'kotlin', 'ios', 'android', 'xamarin', 'ionic', 'firebase', 'objective-c'],
      qa: ['selenium', 'cypress', 'jest', 'mocha', 'testng', 'junit', 'postman', 'jira', 'automation', 'manual testing', 'api testing'],
      warehouse: ['inventory', 'logistics', 'supply chain', 'safety', 'forklift', 'warehouse management', 'shipping', 'packing'],
      manager: ['leadership', 'project management', 'agile', 'scrum', 'team management', 'budgeting', 'planning', 'stakeholder management'],
      analyst: ['sql', 'excel', 'python', 'tableau', 'data analysis', 'reporting', 'statistics', 'powerbi', 'business intelligence'],
      ai: ['python', 'tensorflow', 'pytorch', 'machine learning', 'deep learning', 'nlp', 'computer vision', 'scikit-learn', 'keras'],
      security: ['cybersecurity', 'penetration testing', 'owasp', 'firewall', 'encryption', 'siem', 'vulnerability assessment', 'network security']
    };
    
    // Determine job type from title
    let relevantKeywords = [];
    
    // Check for specific job types (more comprehensive detection)
    if (titleLower.includes('java')) {
      relevantKeywords = jobKeywords.java;
    } else if (titleLower.includes('frontend') || titleLower.includes('front-end') || titleLower.includes('ui') || 
               titleLower.includes('react') || titleLower.includes('angular') || titleLower.includes('vue')) {
      relevantKeywords = jobKeywords.frontend;
    } else if (titleLower.includes('backend') || titleLower.includes('back-end') || titleLower.includes('server')) {
      relevantKeywords = jobKeywords.backend;
    } else if (titleLower.includes('full stack') || titleLower.includes('fullstack') || titleLower.includes('full-stack')) {
      relevantKeywords = jobKeywords.fullstack;
    } else if (titleLower.includes('devops') || titleLower.includes('sre') || titleLower.includes('infrastructure')) {
      relevantKeywords = jobKeywords.devops;
    } else if (titleLower.includes('cloud') || titleLower.includes('aws') || titleLower.includes('azure')) {
      relevantKeywords = jobKeywords.cloud;
    } else if (titleLower.includes('mobile') || titleLower.includes('ios') || titleLower.includes('android')) {
      relevantKeywords = jobKeywords.mobile;
    } else if (titleLower.includes('qa') || titleLower.includes('test') || titleLower.includes('quality')) {
      relevantKeywords = jobKeywords.qa;
    } else if (titleLower.includes('ai') || titleLower.includes('machine learning') || titleLower.includes('ml') || 
               titleLower.includes('data scientist')) {
      relevantKeywords = jobKeywords.ai;
    } else if (titleLower.includes('security') || titleLower.includes('cyber')) {
      relevantKeywords = jobKeywords.security;
    } else if (titleLower.includes('data')) {
      relevantKeywords = jobKeywords.data;
    } else if (titleLower.includes('warehouse') || titleLower.includes('logistics')) {
      relevantKeywords = jobKeywords.warehouse;
    } else if (titleLower.includes('manager') || titleLower.includes('lead')) {
      relevantKeywords = jobKeywords.manager;
    } else if (titleLower.includes('analyst')) {
      relevantKeywords = jobKeywords.analyst;
    } else if (titleLower.includes('developer') || titleLower.includes('engineer')) {
      relevantKeywords = jobKeywords.developer;
    }
    
    // Sort skills by relevance
    const highPrioritySkills = [];
    const mediumPrioritySkills = [];
    const lowPrioritySkills = [];
    
    skills.forEach(skill => {
      const skillLower = skill.toLowerCase();
      
      // Check if skill matches relevant keywords
      const isHighPriority = relevantKeywords.some(keyword => 
        skillLower.includes(keyword) || keyword.includes(skillLower)
      );
      
      // Check if it's a technical skill (contains programming/tech keywords)
      const isTechnical = /^(java|python|javascript|c\+\+|c#|ruby|go|swift|kotlin|typescript|php|scala|sql|html|css|react|angular|vue|spring|django|node|express)/.test(skillLower);
      
      // Check if it's a soft skill
      const isSoftSkill = /^(communication|leadership|teamwork|problem solving|analytical|creative|organized|detail|cricket|rugby|athletics|sports)/.test(skillLower);
      
      if (isHighPriority) {
        highPrioritySkills.push(skill);
      } else if (isTechnical || (!isSoftSkill && skillLower.length > 2)) {
        mediumPrioritySkills.push(skill);
      } else {
        lowPrioritySkills.push(skill);
      }
    });
    
    // Return skills in priority order
    return [...highPrioritySkills, ...mediumPrioritySkills, ...lowPrioritySkills];
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }

    const file = files[0]; // Get the first file
    console.log('Processing file:', file);

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    console.log('File type:', file.type);

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Show upload progress - subscription is already set up in ngOnInit
      this.isUploading = true;
      this.uploadProgress = 0;

      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;

      // Reset previous parsing states
      this.parseSuccess = false;
      this.parseFailed = false;
      this.parsedResumeData = null;
      this.showParsedDetails = false;
      this.parseRetryCount = 0; // Reset retry count for new file

      // Start the actual resume parsing API call (progress updates via ngOnInit subscription)
      this.autoParseResume();
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  // Track retry attempts
  private parseRetryCount: number = 0;
  private readonly MAX_PARSE_RETRIES: number = 2;

  // New method for automatic parsing with retry logic
  autoParseResume(isRetry: boolean = false) {
    let fileToProcess = this.resumeupload || this.fileDragdrop;

    if (fileToProcess && fileToProcess.file) {
      fileToProcess = fileToProcess.file;
    }

    if (!fileToProcess) {
      console.log('No file to parse');
      return;
    }

    // Reset retry count if this is a fresh upload (not a retry)
    if (!isRetry) {
      this.parseRetryCount = 0;
      console.log('Starting fresh parsing attempt');
    } else {
      console.log(`Retry attempt ${this.parseRetryCount + 1} of ${this.MAX_PARSE_RETRIES}`);
    }

    this.isParsing = true;
    this.parseSuccess = false;
    this.parseFailed = false;

    // Get candidateId, userId, and organisationId if available
    const candidateId = this.candidatePostForm?.get('candidateId')?.value || null;
    const userId = localStorage.getItem('userId') || null;
    const organisationId = this.currentOrganizationDetail?.organisationId || null;

    // Use the resume parser service
    this.resumeParseSubscription = this.resumeParserService.parseResume(fileToProcess, candidateId, userId, organisationId).subscribe(
      (response) => {
        this.isParsing = false;
        console.log('Resume parser response:', response);
        console.log('Response code:', response?.code);
        console.log('Response status:', response?.status);

        // Check for success in multiple possible response formats
        const isSuccess = (response && (
          response.code === '00000' ||
          response.status === 'success' ||
          response.status === 'SUCCESS' ||
          (response.data && response.data.code === '00000')
        ));

        if (isSuccess) {
          this.parseSuccess = true;
          this.parseFailed = false;

          // Extract the actual resume data from the nested structure
          const resumeData = response.data?.resumeData || response.data;

          this.parsedResumeData = resumeData;
          console.log('Parsed resume data:', resumeData);

          // Show the tabbed interface immediately
          this.showParsedDetails = true;
          this.activeResumeTab = 'overview';

          // Auto-fill form fields with parsed data immediately
          console.log('About to populate form with API response data:', resumeData);

          try {
            this.populateFormWithParsedData(resumeData);
            console.log('Form population completed successfully');

            // Show success message
            Swal.fire({
              icon: "success",
              title: "Resume parsed successfully!",
              text: "Form fields have been auto-filled. Review the data below.",
              showDenyButton: false,
              timer: 3000,
            });
          } catch (formError) {
            console.error('Error during form population:', formError);

            // Still consider parsing successful, but form population failed
            Swal.fire({
              icon: "warning",
              title: "Resume parsed successfully",
              text: "Resume was parsed but some form fields couldn't be auto-filled. You can fill them manually.",
              showDenyButton: false,
              timer: 5000,
            });
          }
        } else {
          this.handleParseErrorWithRetry('Failed to parse resume');
        }
      },
      (error) => {
        console.error('autoParseResume error caught:', error);
        this.handleParseErrorWithRetry(error?.message || error?.error?.message || 'Failed to parse resume');
      }
    );
  }

  // Handle parse error with automatic retry logic
  handleParseErrorWithRetry(errorMessage: string) {
    this.isParsing = false;

    // Reset progress bar on error
    if (this.progressSimulationInterval) {
      clearInterval(this.progressSimulationInterval);
      this.progressSimulationInterval = null;
    }
    this.isUploading = false;
    this.uploadProgress = 0;

    // Increment retry count
    this.parseRetryCount++;

    if (this.parseRetryCount < this.MAX_PARSE_RETRIES) {
      // Still have retries left, attempt automatic retry
      console.log(`Parse failed. Attempting automatic retry ${this.parseRetryCount} of ${this.MAX_PARSE_RETRIES}...`);

      // Show temporary message about retrying
      Swal.fire({
        icon: "info",
        title: "Retrying...",
        text: `Parse failed. Automatically retrying (Attempt ${this.parseRetryCount + 1}/${this.MAX_PARSE_RETRIES})...`,
        timer: 2000,
        showConfirmButton: false,
        allowOutsideClick: false
      });

      // Wait 2 seconds before retrying
      setTimeout(() => {
        // Restart progress bar for retry
        this.isUploading = true;
        this.uploadProgress = 0;
        this.autoParseResume(true); // Pass true to indicate this is a retry
      }, 2000);
    } else {
      // No more retries, show the parse button
      console.error(`Parse failed after ${this.MAX_PARSE_RETRIES} attempts:`, errorMessage);
      this.parseSuccess = false;
      this.parseFailed = true;

      // Show final error message with the actual error
      Swal.fire({
        icon: "error",
        title: "Resume parsing failed",
        text: errorMessage || `Failed after ${this.MAX_PARSE_RETRIES} automatic attempts. Please click 'Retry Parse Resume' button to try again manually.`,
        showConfirmButton: true
      });
    }
  }

  // New method to handle parsing errors
  // Handle secondary skill selection to maintain order
  onSecondarySkillAdd(skill: any) {
    console.log('Secondary skill added:', skill);
    // Add the skill to the end of the selected list to maintain click order
    if (!this.secondarySkillsSelected.includes(skill)) {
      this.secondarySkillsSelected.push(skill);
      // Update the form control
      this.candidatePostForm.patchValue({
        secondarySkills: [...this.secondarySkillsSelected]
      });
    }
  }

  onSecondarySkillRemove(skill: any) {
    console.log('Secondary skill removed:', skill);
    // Remove the skill from the selected list
    const index = this.secondarySkillsSelected.indexOf(skill);
    if (index > -1) {
      this.secondarySkillsSelected.splice(index, 1);
      // Update the form control
      this.candidatePostForm.patchValue({
        secondarySkills: [...this.secondarySkillsSelected]
      });
    }
  }

  handleParseError(errorMessage: string) {
    console.error('handleParseError called with:', errorMessage);
    console.trace('Stack trace for handleParseError');
    this.isParsing = false;
    this.parseSuccess = false;
    this.parseFailed = true;
    console.error('Error parsing resume:', errorMessage);

    // Show error message with retry option
    Swal.fire({
      icon: "error",
      title: "Parsing Failed",
      text: "Unable to parse the resume. You can try again using the Retry Parse Resume button or fill the form manually.",
      showConfirmButton: true,
      confirmButtonText: "OK",
      timer: 5000,
    });
  }

  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    this.parseSuccess = false;
    this.parseFailed = false;
    this.parsedResumeData = null;
    this.showParsedDetails = false;
    this.activeResumeTab = 'overview';
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }
  
  // Get total skills count
  getTotalSkillsCount(): number {
    if (!this.parsedResumeData?.skills) return 0;
    const skills = this.parsedResumeData.skills;
    let count = 0;
    if (skills.technical_skills) count += skills.technical_skills.length;
    if (skills.languages) count += skills.languages.length;
    if (skills.frameworks) count += skills.frameworks.length;
    if (skills.tools) count += skills.tools.length;
    if (skills.databases) count += skills.databases.length;
    if (skills.soft_skills) count += skills.soft_skills.length;
    return count;
  }
  
  // Clear parsed data
  clearParsedData() {
    this.parsedResumeData = null;
    this.showParsedDetails = false;
    this.parseSuccess = false;
    this.parseFailed = false;
    this.activeResumeTab = 'overview';
  }
  
  // Apply parsed data to form
  applyParsedDataToForm() {
    if (this.parsedResumeData) {
      this.populateFormWithParsedData(this.parsedResumeData);
      this.showParsedDetails = false;
      Swal.fire({
        icon: "success",
        title: "Data Applied",
        text: "Resume data has been applied to the form",
        showDenyButton: false,
        timer: 2000,
      });
    }
  }

  // Parse Resume Method (Manual retry by user)
  parseResume() {
    // Reset retry count when user manually clicks parse button
    this.parseRetryCount = 0;
    console.log('Manual parse requested by user - resetting retry count');

    // Check both resumeupload and fileDragdrop for the file
    let fileToProcess = this.resumeupload || this.fileDragdrop;

    // If fileDragdrop has a file property, use that
    if (fileToProcess && fileToProcess.file) {
      fileToProcess = fileToProcess.file;
    }

    if (!fileToProcess) {
      Swal.fire({
        icon: "warning",
        title: "Please upload a resume first",
        showDenyButton: false,
        timer: 3000,
      });
      return;
    }

    // Validate the resume file
    const validation = this.resumeParserService.validateResumeFile(fileToProcess);
    if (!validation.valid) {
      Swal.fire({
        icon: "warning",
        title: "Invalid file",
        text: validation.message,
        showDenyButton: false,
        timer: 3000,
      });
      return;
    }

    this.isParsing = true;
    this.parseSuccess = false;
    this.parseFailed = false;

    // Get candidateId, userId, and organisationId if available
    const candidateId = this.candidatePostForm?.get('candidateId')?.value || null;
    const userId = localStorage.getItem('userId') || null;
    const organisationId = this.currentOrganizationDetail?.organisationId || null;

    // Use the resume parser service
    this.resumeParseSubscription = this.resumeParserService.parseResume(fileToProcess, candidateId, userId, organisationId).subscribe(
      (response) => {
        this.isParsing = false;
        console.log('Resume parser response:', response);

        // Check for success in multiple possible response formats
        const isSuccess = (response && (
          response.code === '00000' ||
          response.status === 'success' ||
          response.status === 'SUCCESS' ||
          (response.data && response.data.code === '00000')
        ));

        if (isSuccess) {
          this.parseSuccess = true;
          this.parseFailed = false;

          // Extract the actual resume data from the nested structure
          const resumeData = response.data?.resumeData || response.data;

          this.parsedResumeData = resumeData;
          console.log('Parsed resume data:', resumeData);

          // Show the tabbed interface immediately
          this.showParsedDetails = true;
          this.activeResumeTab = 'overview';

          // Auto-fill form fields with parsed data immediately
          console.log('About to populate form with API response data:', resumeData);

          try {
            this.populateFormWithParsedData(resumeData);
            console.log('Form population completed successfully');

            Swal.fire({
              icon: "success",
              title: "Resume parsed successfully!",
              text: "Form fields have been auto-filled",
              showDenyButton: false,
              timer: 3000,
            });
          } catch (formError) {
            console.error('Error during form population:', formError);

            // Still mark parsing as successful since API call worked
            this.parseSuccess = true;
            this.parseFailed = false;

            Swal.fire({
              icon: "warning",
              title: "Resume parsed successfully",
              text: "Resume data was extracted successfully, but some form fields may need manual review. Please check the form.",
              showConfirmButton: true
            });
          }
        } else {
          this.parseFailed = true;
          Swal.fire({
            icon: "error",
            title: "Failed to parse resume",
            text: response.message || "Please try again using the retry button",
            showDenyButton: false,
            timer: 3000,
          });
        }
      },
      (error) => {
        this.isParsing = false;
        this.parseFailed = true;
        console.error('Resume parsing error:', error);
        Swal.fire({
          icon: "error",
          title: "Error parsing resume",
          text: error.message || "Please try again later",
          showDenyButton: false,
          timer: 3000,
        });
      }
    );
  }

  // Populate form with parsed resume data using the mapper service
  populateFormWithParsedData(data: any) {
    console.log('Populating form with data:', data);

    if (!data || !this.candidatePostForm) {
      console.error('No data or form not initialized');
      return;
    }

    try {
      // Log form state before mapping
      console.log('Form controls before mapping:', Object.keys(this.candidatePostForm.controls));
      console.log('Form values before mapping:', this.candidatePostForm.value);

      // Use the mapper service to populate the form first
      const options = {
        enhanceSummary: true,
        primarySkillsList: this.primarySkillsList,
        secondarySkillsList: this.secondarySkillsList
      };

      console.log('Mapping options:', options);

      // For JOB_SEEKER, First Name / Last Name / Email are locked to the user
      // account and must not be overridden by resume parsing. Capture the locked
      // values before mapping so we can restore them afterwards (the shared
      // mapper service also patches these fields).
      const isJobSeeker = this.userType === 'JOB_SEEKER';
      const lockedIdentity = isJobSeeker ? {
        firstName: this.candidatePostForm.get('firstName')?.value,
        lastName: this.candidatePostForm.get('lastName')?.value,
        email: this.candidatePostForm.get('email')?.value,
        candidateEmailId: this.candidatePostForm.get('candidateEmailId')?.value
      } : null;

      this.resumeDataMapper.mapResumeDataToForm(data, this.candidatePostForm, options);

      // Log form state after mapping
      console.log('Form values after mapper service:', this.candidatePostForm.value);

      // Now override with direct mappings for the new API response structure
      this.directlyPopulateFormFields(data);

      // Restore the JOB_SEEKER's locked identity (name + email) in case the
      // mapper overrode it above.
      if (isJobSeeker && lockedIdentity) {
        this.candidatePostForm.patchValue(lockedIdentity);
      }

      // Update selected skills arrays for UI
      this.primarySkillsSelected = this.candidatePostForm.get('primarySkills')?.value || [];
      this.secondarySkillsSelected = this.candidatePostForm.get('secondarySkills')?.value || [];

      console.log('Primary skills selected:', this.primarySkillsSelected);
      console.log('Secondary skills selected:', this.secondarySkillsSelected);

      // Force form update
      this.candidatePostForm.markAllAsTouched();
      this.candidatePostForm.updateValueAndValidity();

      console.log('Final form values:', this.candidatePostForm.value);

      console.log('=== FINAL SKILL CHECK ===');
      console.log('primarySkills in form:', this.candidatePostForm.get('primarySkills')?.value);
      console.log('secondarySkills in form:', this.candidatePostForm.get('secondarySkills')?.value);
      console.log('primarySkillsSelected array:', this.primarySkillsSelected);
      console.log('secondarySkillsSelected array:', this.secondarySkillsSelected);
      console.log('primarySkillsList (available options):', this.primarySkillsList);
      console.log('secondarySkillsList (available options):', this.secondarySkillsList);

      // Update education dates for UI display
      this.updateEducationDatesForDisplay();

    } catch (error) {
      console.error('Error populating form:', error);
    }
  }

  // Direct form field population for the new API response structure
  directlyPopulateFormFields(data: any) {
    console.log('Starting comprehensive form field population with data:', data);

    // Store the data for later use in work authorization selection
    this.parsedResumeData = data;

    // 1. PERSONAL INFORMATION
    // For JOB_SEEKER, First Name / Last Name / Email are locked to the user
    // account (disabled fields), so resume parsing must NOT override them.
    const isJobSeekerIdentityLocked = this.userType === 'JOB_SEEKER';
    if (data.personal_info) {
      const personal = data.personal_info;
      console.log('Personal info found:', personal);

      // Names
      if (personal.name && !isJobSeekerIdentityLocked) {
        const names = personal.name.split(' ');
        const firstName = names[0];
        const lastName = names.slice(1).join(' ') || firstName;

        console.log('Setting names:', { firstName, lastName });
        this.candidatePostForm.patchValue({
          firstName: firstName,
          lastName: lastName
        });
      }

      // Contact Information
      if (personal.email && !isJobSeekerIdentityLocked) {
        console.log('Setting email:', personal.email);
        this.candidatePostForm.patchValue({
          email: personal.email,
          candidateEmailId: personal.email
        });
        this.getTheEmailSearchContent(personal.email);
      }

      if (personal.phone) {
        console.log('Setting phone:', personal.phone);
        this.candidatePostForm.patchValue({
          phone: personal.phone
        });
      }
    }

    // 2. PROFESSIONAL SUMMARY - structured JD-like HTML for Summernote
    {
      let structuredHtml = '';

      // Role
      const roleTitle = data.job_title_match?.current_title_match?.current_title
        || (data.summary ? (data.summary.match(/\*\*(.*?)\*\*/) || [])[1] : null)
        || (data.experience?.[0]?.title || '');
      if (roleTitle) {
        structuredHtml += `<p><strong>Title:</strong></p><p>${roleTitle}</p>`;
      }

      // Summary
      if (data.summary) {
        const cleanSummary = data.summary.replace(/\*\*(.*?)\*\*/g, '$1').trim();
        structuredHtml += `<p><strong>Summary:</strong></p><p>${cleanSummary}</p>`;
      }

      // Responsibilities (from latest experience)
      const responsibilities = data.experience?.[0]?.responsibilities || [];
      if (responsibilities.length > 0) {
        structuredHtml += `<p><strong>Responsibilities:</strong></p><ul>`;
        responsibilities.slice(0, 8).forEach((resp: string) => {
          structuredHtml += `<li>${resp}</li>`;
        });
        structuredHtml += `</ul>`;
      }

      // Technical Skills
      const techSkills = [
        ...(data.skills?.technical_skills || []),
        ...(data.skills?.frameworks || []),
        ...(data.skills?.tools || []),
        ...(data.skills?.databases || [])
      ].filter((s, i, arr) => s && arr.indexOf(s) === i);
      if (techSkills.length > 0) {
        structuredHtml += `<p><strong>Technical Skills:</strong></p><p>${techSkills.join(', ')}</p>`;
      }

      // Languages
      if (data.skills?.languages?.length > 0) {
        structuredHtml += `<p><strong>Languages:</strong></p><p>${data.skills.languages.join(', ')}</p>`;
      }

      // Soft Skills
      if (data.skills?.soft_skills?.length > 0) {
        structuredHtml += `<p><strong>Soft Skills:</strong></p><p>${data.skills.soft_skills.join(', ')}</p>`;
      }

      // Certifications
      if (data.certifications?.length > 0) {
        const certNames = data.certifications.map((c: any) => typeof c === 'object' ? c.name : c).filter(Boolean);
        if (certNames.length > 0) {
          structuredHtml += `<p><strong>Certifications:</strong></p><p>${certNames.join(', ')}</p>`;
        }
      }

      if (structuredHtml) {
        console.log('Setting structured JD summary:', structuredHtml);
        this.candidatePostForm.patchValue({ resumeSummary: structuredHtml });
      }
    }

    // 3. JOB TITLE
    let jobTitle = null;
    if (data.job_title_match?.current_title_match?.current_title) {
      jobTitle = data.job_title_match.current_title_match.current_title;
    } else if (data.summary) {
      const summaryMatch = data.summary.match(/\*\*(.*?)\*\*/);
      if (summaryMatch) {
        jobTitle = summaryMatch[1];
      }
    }

    if (jobTitle) {
      console.log('Setting job title:', jobTitle);
      this.candidatePostForm.patchValue({
        jobTitle: jobTitle
      });
    }

    // 4. EXPERIENCE
    if (data.ranking_metrics?.total_experience_years) {
      console.log('Setting total experience:', data.ranking_metrics.total_experience_years);
      this.candidatePostForm.patchValue({
        totalExperience: data.ranking_metrics.total_experience_years
      });
    }

    // 5. SKILLS (Primary and Secondary)
    let allSkills = [];

    console.log('=== SKILL EXTRACTION DEBUG ===');
    console.log('Full data object:', data);
    console.log('skills.primary_skills:', data.skills?.primary_skills);
    console.log('skills.secondary_skills:', data.skills?.secondary_skills);
    console.log('skill_analysis:', data.skill_analysis);
    console.log('required_skills_matched:', data.skill_analysis?.required_skills_matched);
    console.log('additional_relevant_skills:', data.skill_analysis?.additional_relevant_skills);

    // PRIORITY 1: Use the new primary_skills and secondary_skills fields from OpenAI
    if (data.skills?.primary_skills && data.skills.primary_skills.length > 0) {
      console.log('Using primary_skills and secondary_skills from API:', data.skills);

      const primarySkills = data.skills.primary_skills || [];
      const secondarySkills = data.skills.secondary_skills || [];

      allSkills = [...primarySkills, ...secondarySkills];

      if (primarySkills.length > 0) {
        console.log('Setting primary skills from API:', primarySkills);
        this.candidatePostForm.patchValue({
          primarySkills: primarySkills
        });
        this.primarySkillsSelected = primarySkills;
        console.log('Primary skills in form after patch:', this.candidatePostForm.get('primarySkills')?.value);
      }

      if (secondarySkills.length > 0) {
        console.log('Setting secondary skills from API:', secondarySkills);
        this.candidatePostForm.patchValue({
          secondarySkills: secondarySkills
        });
        this.secondarySkillsSelected = secondarySkills;
        console.log('Secondary skills in form after patch:', this.candidatePostForm.get('secondarySkills')?.value);
      }
    }
    // PRIORITY 2: Fallback to skill_analysis (old logic)
    else if (data.skill_analysis?.required_skills_matched && data.skill_analysis.required_skills_matched.length > 0) {
      console.log('Processing skills from skill_analysis:', data.skill_analysis.required_skills_matched);

      // Get all matched skills sorted by proficiency and experience
      const allMatchedSkills = data.skill_analysis.required_skills_matched
        .sort((a, b) => {
          // Sort by proficiency level first (Expert > Advanced > Intermediate)
          const proficiencyOrder = { 'Expert': 3, 'Advanced': 2, 'Intermediate': 1 };
          const proficiencyDiff = proficiencyOrder[b.proficiency_level] - proficiencyOrder[a.proficiency_level];
          if (proficiencyDiff !== 0) return proficiencyDiff;

          // Then by years of experience
          return (b.years_of_experience || 0) - (a.years_of_experience || 0);
        });

      // Split skills intelligently: Show ALL skills found
      const allSkillNames = allMatchedSkills.map(skill => skill.skill);

      // Add additional relevant skills
      let additionalSkills = [];
      if (data.skill_analysis?.additional_relevant_skills && Array.isArray(data.skill_analysis.additional_relevant_skills)) {
        additionalSkills = data.skill_analysis.additional_relevant_skills; // Get ALL additional skills
      }

      // Combine ALL skills and remove duplicates
      const allUniqueSkills = [...new Set([...allSkillNames, ...additionalSkills])];

      // Split: Half as primary, half as secondary (or show ALL in both if you prefer)
      const halfPoint = Math.ceil(allUniqueSkills.length / 2);
      const primarySkills = allUniqueSkills.slice(0, halfPoint); // First half as primary
      const finalSecondarySkills = allUniqueSkills.slice(halfPoint); // Second half as secondary

      allSkills = [...primarySkills, ...finalSecondarySkills];

      if (primarySkills.length > 0) {
        console.log('Setting primary skills:', primarySkills);
        this.candidatePostForm.patchValue({
          primarySkills: primarySkills
        });
        this.primarySkillsSelected = primarySkills;

        // Verify the form value was set
        console.log('Primary skills in form after patch:', this.candidatePostForm.get('primarySkills')?.value);
      } else {
        console.log('No primary skills found');
      }

      if (finalSecondarySkills.length > 0) {
        console.log('Available secondary skills:', finalSecondarySkills);

        // Show ALL secondary skills, not just the first one
        const defaultSecondarySkills = finalSecondarySkills; // Show all secondary skills

        console.log('Setting ALL secondary skills:', defaultSecondarySkills);
        this.candidatePostForm.patchValue({
          secondarySkills: defaultSecondarySkills
        });
        this.secondarySkillsSelected = defaultSecondarySkills;

        // Verify the form value was set
        console.log('Secondary skills in form after patch:', this.candidatePostForm.get('secondarySkills')?.value);
      } else {
        console.log('No secondary skills found');
      }
    } else if (data.skill_analysis?.additional_relevant_skills && data.skill_analysis.additional_relevant_skills.length > 0) {
      // Fallback to additional_relevant_skills if required_skills_matched is empty
      console.log('Using additional_relevant_skills as fallback:', data.skill_analysis.additional_relevant_skills);

      allSkills = data.skill_analysis.additional_relevant_skills;

      // Show ALL skills - split evenly between primary and secondary
      const halfPoint = Math.ceil(allSkills.length / 2);
      const primarySkills = allSkills.slice(0, halfPoint); // First half as primary
      const secondarySkills = allSkills.slice(halfPoint); // Second half as secondary

      if (primarySkills.length > 0) {
        console.log('Setting primary skills from additional:', primarySkills);
        this.candidatePostForm.patchValue({
          primarySkills: primarySkills
        });
        this.primarySkillsSelected = primarySkills;
      }

      if (secondarySkills.length > 0) {
        console.log('Setting secondary skills from additional:', secondarySkills);
        this.candidatePostForm.patchValue({
          secondarySkills: secondarySkills
        });
        this.secondarySkillsSelected = secondarySkills;
      }
    } else if (data.skills && typeof data.skills === 'object') {
      // Try to extract from skills object if it has any properties
      console.log('Checking skills object:', data.skills);

      // Extract all skills from various skill categories
      const skillCategories = ['programming', 'frameworks', 'databases', 'tools', 'technical', 'soft_skills'];

      skillCategories.forEach(category => {
        if (data.skills[category] && Array.isArray(data.skills[category])) {
          allSkills = [...allSkills, ...data.skills[category]];
        }
      });

      if (allSkills.length > 0) {
        // Show ALL skills - split evenly between primary and secondary
        const halfPoint = Math.ceil(allSkills.length / 2);
        const primarySkills = allSkills.slice(0, halfPoint); // First half as primary
        const secondarySkills = allSkills.slice(halfPoint); // Second half as secondary

        if (primarySkills.length > 0) {
          console.log('Setting primary skills from skills object:', primarySkills);
          this.candidatePostForm.patchValue({
            primarySkills: primarySkills
          });
          this.primarySkillsSelected = primarySkills;
        }

        if (secondarySkills.length > 0) {
          console.log('Setting secondary skills from skills object:', secondarySkills);
          this.candidatePostForm.patchValue({
            secondarySkills: secondarySkills
          });
          this.secondarySkillsSelected = secondarySkills;
        }
      }
    }

    // If we found any skills, add them to the available skills lists
    if (allSkills.length > 0) {
      // Add unique skills to the primary and secondary skills lists
      allSkills.forEach(skill => {
        if (!this.primarySkillsList.includes(skill)) {
          this.primarySkillsList.push(skill);
        }
        if (!this.secondarySkillsList.includes(skill)) {
          this.secondarySkillsList.push(skill);
        }
      });

      console.log('Updated primarySkillsList:', this.primarySkillsList);
      console.log('Updated secondarySkillsList:', this.secondarySkillsList);
    }

    // 6. WORK PREFERENCES & ENGAGEMENT
    console.log('Setting work preferences and engagement type');
    this.candidatePostForm.patchValue({
      // Work preferences based on experience and skills
      workMode: this.determineWorkMode(data),
      engagementType: this.determineEngagementType(data),

      // Availability
      availableIn: 'Immediate',

      // Work authorization (based on location/experience)

      // Flexible work options (default based on modern practices)
      remoteWork: true,
      workFromHome: true,
      relocationRequired: false,

      // Security clearance (check if mentioned in resume)
      securityClearance: this.hasSecurityClearanceMention(data),

      // Resume attached flag
      isResumeAttached: true
    });

   this.onChangeCountry("US","")


    // 7. COMPENSATION - Use ONLY values from resume, NO auto-estimation
    const personalInfo = data.personal_info;
    if (personalInfo?.targetRateFrom) {
      console.log('Setting target rate from resume:', personalInfo.targetRateFrom);
      this.candidatePostForm.patchValue({ targetRateFrom: personalInfo.targetRateFrom });
    }
    if (personalInfo?.targetRateTo) {
      console.log('Setting target rate to resume:', personalInfo.targetRateTo);
      this.candidatePostForm.patchValue({ targetRateTo: personalInfo.targetRateTo });
    }
    if (personalInfo?.payType) {
      console.log('Setting pay type from resume:', personalInfo.payType);
      this.candidatePostForm.patchValue({ payType: this.normalizePayType(personalInfo.payType) });
    }

    // 8. LOCATION (if available from experience or personal info)
    this.setLocationFromData(data);

    // 8.1. WORK AUTHORIZATION (based on detected country code)
    const detectedCountryCode = this.countryChosen || 'US';
    console.log('Setting work authorization for country code:', detectedCountryCode);
    // Only set work authorization if field is empty
    const currentWorkAuth = this.candidatePostForm.get('workAuthorization')?.value;
    if (!currentWorkAuth || (typeof currentWorkAuth === 'string' && currentWorkAuth.trim() === '')) {
      console.log('Calling onChangeCountry with country code:', detectedCountryCode);
      this.onChangeCountry(detectedCountryCode, '');
      console.log('Work authorization set for country:', detectedCountryCode);
    } else {
      console.log('Skipped work authorization - already has value:', currentWorkAuth);
    }

    // 9. ADDITIONAL FLAGS
    this.candidatePostForm.patchValue({
      createCandidateOnPlatform: true,
      candidateStatus: true, // Active candidate
      status: 'ACTIVE'
    });

    console.log('Completed comprehensive form field population');
  }

  // Helper methods for determining values
  determineWorkMode(data: any) {
    // Check if remote work is mentioned in experience/projects
    const dataText = JSON.stringify(data).toLowerCase();
    if (dataText.includes('remote') || dataText.includes('distributed')) {
      return 'Remote';
    } else if (dataText.includes('hybrid')) {
      return 'Hybrid';
    }
    return null; // Default modern preference
  }

  determineEngagementType(data: any) {
    // Based on experience level and role
    const experience = data.ranking_metrics?.total_experience_years || 0;
    const title = data.job_title_match?.current_title_match?.current_title || '';

    if (experience >= 5 || title.toLowerCase().includes('senior') || title.toLowerCase().includes('lead')) {
      return 'W2 - Contract'; // Senior folks often prefer contract
    }
    return null;
  }

  determineWorkAuthorization(data: any): string {
    // Return null initially - will be set after country triggers API call
    // The actual work authorization will be set based on the workAuthorizationList from API
    return null;
  }


  hasSecurityClearanceMention(data: any): boolean {
    const dataText = JSON.stringify(data).toLowerCase();
    return dataText.includes('security clearance') ||
           dataText.includes('clearance') ||
           dataText.includes('classified');
  }

  /**
   * DEPRECATED: Auto-estimation removed per requirements.
   * Compensation values now come ONLY from resume parsing.
   * This method is kept for backwards compatibility but returns null.
   */
  estimateCompensation(data: any): any {
    // Check if resume has target rate - use those values only
    const personalInfo = data.personal_info;
    if (personalInfo?.targetRateFrom || personalInfo?.targetRateTo) {
      return {
        from: personalInfo.targetRateFrom || null,
        to: personalInfo.targetRateTo || null,
        type: this.normalizePayType(personalInfo.payType) || 'Hourly'
      };
    }

    // No rate in resume - return null (don't estimate)
    return null;
  }

  /**
   * Normalize payType to match UI expected values (Title Case)
   * API may return lowercase values like "hourly", UI expects "Hourly"
   */
  private normalizePayType(payType: string): string {
    if (!payType) return null;
    const normalized = payType.toLowerCase();
    // Valid values: Hourly, Daily, Weekly, Monthly, Yearly
    if (normalized === 'hourly' || normalized === 'hr') return 'Hourly';
    if (normalized === 'daily') return 'Daily';
    if (normalized === 'weekly') return 'Weekly';
    if (normalized === 'monthly') return 'Monthly';
    if (normalized === 'yearly' || normalized === 'annual') return 'Yearly';
    return payType; // Return as-is if not recognized
  }

  setLocationFromData(data: any): void {
    try {
      // Determine country from resume data
      const dataText = JSON.stringify(data).toLowerCase();
      let detectedCountry = null;

      // Check for country indicators in resume
      if (dataText.includes('india') || dataText.includes('indian') ||
          dataText.includes('bangalore') || dataText.includes('mumbai') ||
          dataText.includes('chennai') || dataText.includes('hyderabad')) {
        detectedCountry = 'IN'; // India
      } else if (dataText.includes('canada') || dataText.includes('canadian') ||
                 dataText.includes('toronto') || dataText.includes('vancouver')) {
        detectedCountry = 'CA'; // Canada
      } else if (dataText.includes('australia') || dataText.includes('australian') ||
                 dataText.includes('sydney') || dataText.includes('melbourne')) {
        detectedCountry = 'AU'; // Australia
      } else if (dataText.includes('united states') || dataText.includes('usa') ||
                 dataText.includes('california') || dataText.includes('texas') ||
                 dataText.includes('new york') || dataText.includes('florida')) {
        detectedCountry = 'US'; // United States
      }

      // Default to US for work visa scenarios (most job opportunities)
      if (!detectedCountry) {
        detectedCountry = 'US';
      }

      console.log('Setting country to:', detectedCountry);

      // Set the country normally to trigger existing change events
      if (this.candidatePostForm && this.candidatePostForm.get('country')) {
        this.candidatePostForm.get('country').patchValue(detectedCountry);
      }

      // Store the country for later work authorization processing
      this.countryChosen = detectedCountry;
    } catch (error) {
      console.error('Error in setLocationFromData:', error);
      // Fallback to US if there's any error
      if (this.candidatePostForm && this.candidatePostForm.get('country')) {
        this.candidatePostForm.get('country').patchValue('US');
      }
      this.countryChosen = 'US';
    }
  }


  // Update education dates for UI display based on first job year
  updateEducationDatesForDisplay() {
    if (!this.parsedResumeData || !this.parsedResumeData.education) {
      return;
    }
    
    // Get first job year from experience data
    let firstJobYear = null;
    if (this.parsedResumeData.experience && this.parsedResumeData.experience.length > 0) {
      let earliestYear = new Date().getFullYear();
      
      this.parsedResumeData.experience.forEach(exp => {
        if (exp.start_date) {
          const yearMatch = exp.start_date.match(/\d{4}/);
          if (yearMatch) {
            const year = parseInt(yearMatch[0]);
            if (year < earliestYear && year > 1980) {
              earliestYear = year;
            }
          }
        }
      });
      
      if (earliestYear < new Date().getFullYear()) {
        firstJobYear = earliestYear;
      }
    }
    
    // Update education dates with calculated values
    if (firstJobYear) {
      this.parsedResumeData.education.forEach((edu, index) => {
        const formattedEdu = this.resumeDataMapper.formatEducationForBackend(
          edu, 
          'temp', 
          index, 
          this.parsedResumeData.education, 
          firstJobYear
        );
        
        // Update the display dates based on calculated values
        if (formattedEdu.startYear && formattedEdu.endYear) {
          edu.start_date = formattedEdu.startMonth ? 
            `${formattedEdu.startMonth}, ${formattedEdu.startYear}` : 
            formattedEdu.startYear.toString();
          edu.end_date = formattedEdu.endMonth ? 
            `${formattedEdu.endMonth}, ${formattedEdu.endYear}` : 
            formattedEdu.endYear.toString();
        }
      });
      
      console.log('Updated education dates for display:', this.parsedResumeData.education);
    }
  }
  
  // Helper method to map degree to qualification dropdown
  mapDegreeToQualification(degree: string): string {
    if (!degree) return '';
    
    const degreeLower = degree.toLowerCase();
    
    if (degreeLower.includes('bachelor') || degreeLower.includes('b.tech') || 
        degreeLower.includes('b.e') || degreeLower.includes('bsc') || 
        degreeLower.includes('ba') || degreeLower.includes('bba')) {
      return 'Bachelor';
    } else if (degreeLower.includes('master') || degreeLower.includes('m.tech') || 
               degreeLower.includes('mba') || degreeLower.includes('msc') || 
               degreeLower.includes('ma') || degreeLower.includes('mca')) {
      return 'Master';
    } else if (degreeLower.includes('phd') || degreeLower.includes('doctorate')) {
      return 'Doctorate';
    } else if (degreeLower.includes('diploma')) {
      return 'Diploma';
    } else if (degreeLower.includes('associate')) {
      return 'Associate';
    }
    
    return degree; // Return as-is if no mapping found
  }
  
  saveParsedResumeDataToBackend(candidateId: string) {
    console.log('✅ saveParsedResumeDataToBackend called with candidateId:', candidateId);
    console.log('✅ parsedResumeData exists?', !!this.parsedResumeData);
    console.log('✅ Experience count:', this.parsedResumeData?.experience?.length || 0);
    console.log('✅ Education count:', this.parsedResumeData?.education?.length || 0);
    console.log('✅ Certifications count:', this.parsedResumeData?.certifications?.length || 0);
 
    console.log('✅ saveParsedResumeDataToBackend called with candidateId:', candidateId);
    console.log('✅ parsedResumeData exists?', !!this.parsedResumeData);
    console.log('✅ Experience count:', this.parsedResumeData?.experience?.length || 0);
    console.log('✅ Education count:', this.parsedResumeData?.education?.length || 0);
    console.log('✅ Certifications count:', this.parsedResumeData?.certifications?.length || 0);

    if (!this.parsedResumeData || !candidateId) {
      console.error('❌ FAILED: No parsed data or candidate ID available');
      console.error('   - parsedResumeData:', this.parsedResumeData ? 'EXISTS' : 'NULL');
      console.error('   - candidateId:', candidateId ? candidateId : 'NULL');
      return;
    }
 
    console.log('✅ ✅ Saving parsed resume data for candidate:', candidateId);
 
    // Save Work Experience
    if (this.parsedResumeData.experience && this.parsedResumeData.experience.length > 0) {
      this.saveParsedWorkExperience(candidateId);
    }
 
    // Save Education
    if (this.parsedResumeData.education && this.parsedResumeData.education.length > 0) {
      this.saveParsedEducation(candidateId);
    }
 
    // Save Projects/Certifications
    if (this.parsedResumeData.certifications && this.parsedResumeData.certifications.length > 0) {
      this.saveParsedCertifications(candidateId);
    }
  }
  
    // Save parsed work experience to backend (BATCH PROCESSING)
  saveParsedWorkExperience(candidateId: string) {
    const experiences = this.parsedResumeData.experience;
 
    console.log('================================');
    console.log('RESUME PARSER - WORK EXPERIENCE DATA');
    console.log('================================');
    console.log('Total experiences to save:', experiences.length);
    console.log('Raw experience data from parser:', JSON.stringify(experiences, null, 2));
    console.log('================================');
 
    if (!experiences || experiences.length === 0) {
      console.warn('NO WORK EXPERIENCES FOUND IN RESUME DATA');
      // Swal.fire({
      //   title: 'No Work Experiences',
      //   text: 'No work experiences found in the resume to save.',
      //   icon: 'info',
      //   confirmButtonText: 'OK'
      // });
      return;
    }
 
    // Show loading indicator
    // Swal.fire({
    //   title: 'Saving Work Experiences',
    //   html: `Saving ${experiences.length} work experience(s)...`,
    //   icon: 'info',
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   }
    // });
 
    // Create array of API calls (observables)
    const apiCalls = experiences.map((exp, index) => {
      console.log(`\n--- Processing Experience ${index + 1} ---`);
      console.log('Raw experience object:', exp);
      console.log('Location field:', exp.location);
      console.log('Company:', exp.company);
      console.log('Position:', exp.position);
 
      // Use mapper service to format the payload
      const payload = this.resumeDataMapper.formatWorkExperienceForBackend(exp, candidateId, index,this.countryList);
      console.log('Formatted payload for backend:', JSON.stringify(payload, null, 2));
 
      // Return observable with metadata about which experience this is
      return this.API.updatePut('candidates/updateCandidateWorkExperience', payload).pipe(
        // Map the response to include the index for tracking
        switchMap(response => {
          console.log(`✅ Experience ${index + 1} saved successfully:`, response);
          return of({
            success: true,
            index: index + 1,
            company: exp.company,
            position: exp.position,
            response: response
          });
        }),
        // Catch errors and convert to error object (so forkJoin doesn't fail)
        catchError((error: any) => {
          console.error(`❌ Error saving experience ${index + 1}:`, error);
          console.error(`   - Status: ${error.status}`);
          console.error(`   - Message: ${error.message}`);
          console.error(`   - Error body:`, error.error);
          return of({
            success: false,
            index: index + 1,
            company: exp.company,
            position: exp.position,
            error: error,
            statusCode: error.status,
            errorMessage: error.message
          });
        })
      );
    });
 
    // Use forkJoin to wait for all API calls to complete
    forkJoin(apiCalls).subscribe(
      (results: any[]) => {
        // Count successes and failures
        const successResults = results.filter((r: any) => r.success);
        const failureResults = results.filter((r: any) => !r.success);
        const successCount = successResults.length;
        const errorCount = failureResults.length;
 
        console.log(`\n📊 FINAL SUMMARY:`);
        console.log(`✅ Successful: ${successCount}/${experiences.length}`);
        console.log(`❌ Failed: ${errorCount}/${experiences.length}`);
        console.log('Success details:', successResults);
        console.log('Failure details:', failureResults);
 
        // Show appropriate notification based on results
        if (errorCount === 0) {
          // All successful
          // Swal.fire({
          //   title: 'Success!',
          //   html: `All <strong>${successCount}</strong> work experience(s) saved successfully!`,
          //   icon: 'success',
          //   confirmButtonText: 'OK'
          // });
        } else if (successCount === 0) {
          // All failed
          const failureList = failureResults
            .map(r => `• ${r.company} - ${r.position}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.error('❌ ALL FAILED - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Failed to Save',
          //   html: `Failed to save all ${errorCount} work experience(s):<br><br>${failureList}<br><br><small style="color: red;">Check console for details</small>`,
          //   icon: 'error',
          //   confirmButtonText: 'OK'
          // });
        } else {
          // Partial success
          const failureList = failureResults
            .map(r => `• ${r.company} - ${r.position}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.warn('⚠️ PARTIAL SUCCESS - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Partially Saved',
          //   html: `Saved ${successCount} of ${experiences.length} work experience(s).<br><br>Failed to save:<br>${failureList}<br><br><small style="color: orange;">Check console for details</small>`,
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });
        }
      },
      (error) => {
        console.error('Unexpected error while saving work experiences:', error);
        // Swal.fire({
        //   title: 'Unexpected Error',
        //   text: 'An unexpected error occurred while saving work experiences.',
        //   icon: 'error',
        //   confirmButtonText: 'OK'
        // });
      }
    );
  }
 
  // Save parsed education to backend
  saveParsedEducation(candidateId: string) {
    const educations = this.parsedResumeData.education;
    console.log('saveParsedEducation - All education data:', educations);
    console.log('saveParsedEducation - All experience data:', this.parsedResumeData.experience);
 
    if (!educations || educations.length === 0) {
      console.warn('NO EDUCATION FOUND IN RESUME DATA');
      return;
    }
 
    if (!educations || educations.length === 0) {
      console.warn('NO EDUCATION FOUND IN RESUME DATA');
      return;
    }

    // Get first job year from experience data
    let firstJobYear = null;
    if (this.parsedResumeData.experience && this.parsedResumeData.experience.length > 0) {
      // Look through all experiences to find the earliest start date
      let earliestYear = new Date().getFullYear();
 
      this.parsedResumeData.experience.forEach(exp => {
        console.log('Checking experience:', exp);
        if (exp.start_date) {
          console.log('Experience start_date:', exp.start_date);
          const yearMatch = exp.start_date.match(/\d{4}/);
          if (yearMatch) {
            const year = parseInt(yearMatch[0]);
            console.log('Found year in experience:', year);
            if (year < earliestYear && year > 1980) { // Sanity check
              earliestYear = year;
              console.log('Updated earliest year to:', earliestYear);
            }
          }
        }
      });
 
      // Only set if we found a valid year
      if (earliestYear < new Date().getFullYear()) {
        firstJobYear = earliestYear;
        console.log('FINAL First job year detected:', firstJobYear);
      } else {
        console.log('No valid first job year found, earliestYear was:', earliestYear);
      }
    } else {
      console.log('No experience data found to extract first job year');
    }
 
    console.log('✅ Total education entries to save:', educations.length);
 
    // Show loading indicator
    // Swal.fire({
    //   title: 'Saving Education Details',
    //   html: `Saving ${educations.length} education details(s)...`,
    //   icon: 'info',
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   }
    // });
 
    // Create array of API calls
    const apiCalls = educations.map((edu, index) => {
      console.log(`\n--- Processing Education ${index + 1} ---`);
      console.log('Raw education object:', edu);
 
      // Use mapper service to format the payload with first job year
      const payload = this.resumeDataMapper.formatEducationForBackend(edu, candidateId, index, educations, firstJobYear);
 
      // Add location from form only if not already set
      if (!payload.city) payload.city = this.candidatePostForm.value.city || '';
      if (!payload.street) payload.street = '';
      if (!payload.state) payload.state = this.candidatePostForm.value.state || '';
      if (!payload.zipcode) payload.zipcode = this.candidatePostForm.value.zipCode || '';
      if (!payload.country) payload.country = this.candidatePostForm.value.country || 'US';
 
      console.log('Final education payload for backend:', JSON.stringify(payload, null, 2));
 
      // Return observable with error handling
      return this.API.updatePut('candidates/updateCandidateEducationalDetail', payload).pipe(
        switchMap(response => {
          console.log(`✅ Education ${index + 1} saved successfully:`, response);
          return of({
            success: true,
            index: index + 1,
            school: edu.institution,
            degree: edu.degree,
            response: response
          });
        }),
        catchError((error: any) => {
          console.error(`❌ Error saving education ${index + 1}:`, error);
          console.error(`   - Status: ${error.status}`);
          console.error(`   - Message: ${error.message}`);
          console.error(`   - Error body:`, error.error);
          return of({
            success: false,
            index: index + 1,
            school: edu.institution,
            degree: edu.degree,
            error: error,
            statusCode: error.status,
            errorMessage: error.message
          });
        })
      );
    });
 
    // Use forkJoin to coordinate all API calls
    forkJoin(apiCalls).subscribe(
      (results: any[]) => {
        const successResults = results.filter((r: any) => r.success);
        const failureResults = results.filter((r: any) => !r.success);
        const successCount = successResults.length;
        const errorCount = failureResults.length;
 
        console.log(`\n📊 EDUCATION SAVE SUMMARY:`);
        console.log(`✅ Successful: ${successCount}/${educations.length}`);
        console.log(`❌ Failed: ${errorCount}/${educations.length}`);
        console.log('Success details:', successResults);
        console.log('Failure details:', failureResults);
 
        // Show appropriate notification
        if (errorCount === 0) {
          // Swal.fire({
          //   title: 'Success!',
          //   html: `All <strong>${successCount}</strong> education detail(s) saved successfully!`,
          //   icon: 'success',
          //   confirmButtonText: 'OK'
          // });
        } else if (successCount === 0) {
          const failureList = failureResults
            .map(r => `• ${r.school} - ${r.degree}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.error('❌ ALL EDUCATION SAVES FAILED - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Failed to Save',
          //   html: `Failed to save all ${errorCount} education detail(s):<br><br>${failureList}<br><br><small style="color: red;">Check console for details</small>`,
          //   icon: 'error',
          //   confirmButtonText: 'OK'
          // });
        } else {
          // Partial success
          const failureList = failureResults
            .map(r => `• ${r.school} - ${r.degree}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.warn('⚠️ PARTIAL EDUCATION SUCCESS - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Partially Saved',
          //   html: `Saved ${successCount} of ${educations.length} education detail(s).<br><br>Failed to save:<br>${failureList}<br><br><small style="color: orange;">Check console for details</small>`,
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });
        }
      },
      (error) => {
        console.error('Unexpected error while saving education:', error);
        // Swal.fire({
        //   title: 'Unexpected Error',
        //   text: 'An unexpected error occurred while saving education details.',
        //   icon: 'error',
        //   confirmButtonText: 'OK'
        // });
      }
    );
  }
 
  // Save parsed certifications to backend (BATCH PROCESSING)
  saveParsedCertifications(candidateId: string) {
    const certifications = this.parsedResumeData.certifications;
 
    console.log('================================');
    console.log('RESUME PARSER - CERTIFICATIONS DATA');
    console.log('================================');
    console.log('Total certifications to save:', certifications.length);
    console.log('Raw certification data from parser:', JSON.stringify(certifications, null, 2));
    console.log('================================');
 
    if (!certifications || certifications.length === 0) {
      console.warn('NO CERTIFICATIONS FOUND IN RESUME DATA');
      return;
    }
 
    console.log('✅ Total certification entries to save:', certifications.length);
 
    // Show loading indicator
    // Swal.fire({
    //   title: 'Saving Certifications',
    //   html: `Saving ${certifications.length} certification(s)...`,
    //   icon: 'info',
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   }
    // });
 
    // Create array of API calls
    const apiCalls = certifications.map((cert, index) => {
      console.log(`\n--- Processing Certification ${index + 1} ---`);
      console.log('Raw certification object:', cert);
 
      // Use mapper service to format the payload
      const payload = this.resumeDataMapper.formatCertificationForBackend(cert, candidateId);
      console.log('Formatted payload for backend:', JSON.stringify(payload, null, 2));
 
      // Return observable with error handling
      return this.API.updatePut('candidates/updateCandidateCertifications', payload).pipe(
        switchMap(response => {
          console.log(`✅ Certification ${index + 1} saved successfully:`, response);
          return of({
            success: true,
            index: index + 1,
            certName: cert.name || 'Unknown',
            response: response
          });
        }),
        catchError((error: any) => {
          console.error(`❌ Error saving certification ${index + 1}:`, error);
          console.error(`   - Status: ${error.status}`);
          console.error(`   - Message: ${error.message}`);
          console.error(`   - Error body:`, error.error);
          return of({
            success: false,
            index: index + 1,
            certName: cert.name || 'Unknown',
            error: error,
            statusCode: error.status,
            errorMessage: error.message
          });
        })
      );
    });
 
    // Use forkJoin to coordinate all API calls
    forkJoin(apiCalls).subscribe(
      (results: any[]) => {
        const successResults = results.filter((r: any) => r.success);
        const failureResults = results.filter((r: any) => !r.success);
        const successCount = successResults.length;
        const errorCount = failureResults.length;
 
        console.log(`\n📊 CERTIFICATION SAVE SUMMARY:`);
        console.log(`✅ Successful: ${successCount}/${certifications.length}`);
        console.log(`❌ Failed: ${errorCount}/${certifications.length}`);
        console.log('Success details:', successResults);
        console.log('Failure details:', failureResults);
 
        // Show appropriate notification
        if (errorCount === 0) {
          // Swal.fire({
          //   title: 'Success!',
          //   html: `All <strong>${successCount}</strong> certification(s) saved successfully!`,
          //   icon: 'success',
          //   confirmButtonText: 'OK'
          // });
        } else if (successCount === 0) {
          const failureList = failureResults
            .map(r => `• ${r.certName}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.error('❌ ALL CERTIFICATION SAVES FAILED - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Failed to Save',
          //   html: `Failed to save all ${errorCount} certification(s):<br><br>${failureList}<br><br><small style="color: red;">Check console for details</small>`,
          //   icon: 'error',
          //   confirmButtonText: 'OK'
          // });
        } else {
          // Partial success
          const failureList = failureResults
            .map(r => `• ${r.certName}<br/>  Status: ${r.statusCode}, ${r.errorMessage}`)
            .join('<br>');
          console.warn('⚠️ PARTIAL CERTIFICATION SUCCESS - Error details:', failureResults);
          // Swal.fire({
          //   title: 'Partially Saved',
          //   html: `Saved ${successCount} of ${certifications.length} certification(s).<br><br>Failed to save:<br>${failureList}<br><br><small style="color: orange;">Check console for details</small>`,
          //   icon: 'warning',
          //   confirmButtonText: 'OK'
          // });
        }
      },
      (error) => {
        console.error('Unexpected error while saving certifications:', error);
        // Swal.fire({
        //   title: 'Unexpected Error',
        //   text: 'An unexpected error occurred while saving certifications.',
        //   icon: 'error',
        //   confirmButtonText: 'OK'
        // });
      }
    );
  }
  
  // Helper to parse date strings
  parseDateString(dateStr: string): { month: string, year: string } {
    if (!dateStr) return { month: 'January', year: new Date().getFullYear().toString() };
    
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 
                    'July', 'August', 'September', 'October', 'November', 'December'];
    
    // Try to parse different date formats
    if (dateStr.includes('-')) {
      // Format: 2020-03 or 2020-03-01
      const parts = dateStr.split('-');
      const year = parts[0];
      const monthNum = parseInt(parts[1]) - 1;
      return {
        month: months[monthNum] || 'January',
        year: year
      };
    } else if (dateStr.includes('/')) {
      // Format: 03/2020 or 03/01/2020
      const parts = dateStr.split('/');
      const monthNum = parseInt(parts[0]) - 1;
      const year = parts.length > 2 ? parts[2] : parts[1];
      return {
        month: months[monthNum] || 'January',
        year: year
      };
    } else if (dateStr.match(/^\d{4}$/)) {
      // Just a year
      return {
        month: 'January',
        year: dateStr
      };
    } else {
      // Try to extract year from string
      const yearMatch = dateStr.match(/\d{4}/);
      if (yearMatch) {
        // Try to find month name
        for (let i = 0; i < months.length; i++) {
          if (dateStr.toLowerCase().includes(months[i].toLowerCase().substring(0, 3))) {
            return {
              month: months[i],
              year: yearMatch[0]
            };
          }
        }
        return {
          month: 'January',
          year: yearMatch[0]
        };
      }
    }
    
    return { month: 'January', year: new Date().getFullYear().toString() };
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  payType: null;
  targetRate: null;
  countryChosen: string | null = null;
  onChangePayType(value, param) {
    this.payType = value

    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }

    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }
  }
  closeCredit() {
    this.commonVariables.creditFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.postPrivacyFlag = false
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.educationFlag = false
    this.searchData.setCommonVariables(this.commonVariables)
  }
  getCountries() {
    this.countryList = [];
    this.API.query("country/getAllCountries").subscribe((res) => {
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  timeZonecountryvalues(countryCode) {
    if (countryCode != undefined && countryCode != "") {
      this.timezoneslist = [];
      this.API.query("user/timeZoneByCountryCode/" + countryCode).subscribe((res) => {
        if (res) {
          this.timezoneslist = res.data.zones;
        }
      }, err => {
        this.util.stopLoader();
      });
    }
  }
  userid = localStorage.getItem('userId')
  currentTime: any;
  async initiateJobForm() {
    try {
      // Pre-select Marketplace for Free plan users before form initialization
      if (this.membershipType === 'Free') {
        this.selectedNetworks = ['1'];
      } else {
        this.selectedNetworks = [];
      }

      await Promise.all([
        this.getCountries(),
        this.getListValues('JOBS'),
        this.generateYears(),
        this.generateYears2()
      ]);
      var country: any = '';
      let location: Location;
      if (this.userdata1 != null) {
        this.userdata1.forEach(ele => {
          if (ele.currentOrganization == true) {
            country = ele.country;
            location = {
              country: ele.country, city: ele.city, state: ele.state, zipCode: ele.zipcode
            };
          }
        });
        if (location != undefined) await this.onChangeCountry(location.country, '');
      }
      this.jobPostForm = new AppSettings().getCreateJobForm(location);

      var formval: any = localStorage.getItem(this.userid + "_landingPagejobPostForm");
      if (formval != null || formval != undefined) {
        formval = formval.slice(1, -1);
        var tempdata: CryptoJS.lib.WordArray = CryptoJS.AES.decrypt(decodeURIComponent(formval), "secret key");
        var decrypt: any = JSON.parse(tempdata.toString(CryptoJS.enc.Utf8));
        await new Promise(resolve => setTimeout(resolve, 3500)); // Wait for 3500 ms
        if (decrypt.secondarySkills != null) {
          decrypt.secondarySkills.forEach(ele => {
            this.secondarySkillsSelected.push(ele);
          });
        }
        if (decrypt.primarySkills != null) {
          decrypt.primarySkills.forEach(ele => {
            this.primarySkillsSelected.push(ele);
          });
        }
        if (decrypt.targetRate == 0) {
          decrypt.targetRate = '';
        }
        await new Promise(resolve => setTimeout(resolve, 500)); // Additional wait
        this.jobPostForm.patchValue(decrypt);
        this.onClientTypeChange(decrypt.clientType);
      }
    } catch (error) {
    } finally {
      (this.jobPostForm.get('primarySkills') as UntypedFormControl).valueChanges.forEach(res => { });
    }
  }
  currentOrganisationRequired: boolean = true
  removeCurrentOrgValidation() {
    this.currentOrganisationRequired = false
    this.jobPostForm.get('jobPostedBehalfOf').clearValidators();
    this.jobPostForm.get('jobPostedBehalfOf').updateValueAndValidity();
  }
  addCurrentOrgValidation() {
    this.currentOrganisationRequired = true
    this.jobPostForm.get('jobPostedBehalfOf').setValidators([Validators.required]);
    this.jobPostForm.get('jobPostedBehalfOf').updateValueAndValidity();
  }
  checkspace(event: any): boolean {
    return super.validSpace(event);
  }
  private scrollToFirstInvalidControl(id: string) {
    let form = document.getElementById(id);
    let firstInvalidControl = form.getElementsByClassName('ng-invalid')[0];
    if (firstInvalidControl != undefined) {
      firstInvalidControl.scrollIntoView();
      (firstInvalidControl as HTMLElement).focus();
    }
  }
  createJobs() {
    this.initiateJobForm();
  }
  primaryEmail: any;
  firstName: any;
  lastName: any;
  phoneNo: any;

  secondaryEmail: any = null;
  workExperienceDetailsCheck: any = [];
  domainList: any = []
  creditPoints: any;
  currentEntity: any;
  openModalWithComponent() {
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "open"
    };
    this.bsModalRef = this.modalService.show(CreditModelComponent, initialState);
    this.bsModalRef.content.closeBtnName = 'Close';
  }
  callMethod() {
    this.gigsumoService.buttonClicked = true;
  }
  userdata1: any;
  currentOrg: boolean = false
  userdatacandidate: any;
  showContent: "JOBS" | "CANDIDATE";
  workExp: Array<WorkExperience>;

  async createJobsOrCandidates(param, template, called = false) {

    this.util.startLoader();
    this.gigsumoService.buttonClicked = false;
    this.currentEntity = param;
    this.showContent = param;

    if (!called) {
      let hasCurrentOrganization = await this.userService.checkIfUserHasCurrentOrganization({ userId: this.userId, userType: this.userType });
      if (!hasCurrentOrganization && this.userType != 'FREELANCE_RECRUITER') {
        this.modalRef = this.modalService.show(template, this.backdropConfig);
        this.addWorkExperience();
        this.util.stopLoader();
        return;
      }
    }

    try {

      // skip plan validation for job_seeker usertype
      if (this.userType === GigsumoConstants.JOB_SEEKER) {
        this.afterValidatingPlan(param, template);
        return;
      }

      const isValid: boolean = await this.pricePlanService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS");

      if (isValid) {
        this.afterValidatingPlan(param, template);
        this.util.stopLoader();
      }
      this.gigsumoService.buttonClicked = true;

    } catch (error) {
      this.util.stopLoader();
    }
  }

  afterValidatingPlan(param, template) {

    this.submit = false;
    this.candidateSubmit = false;
    this.commonVariables.candidatePostingFlag = false;
    this.commonVariables.jobPostingFlag = false;
    this.commonVariables.workExperienceFlag = false;
    this.commonVariables.emailDomainValidation = false;
    this.commonVariables.educationFlag = false
    this.primarySkillsSelected = [];
    this.secondarySkillsSelected = [];
    this.otherSelectedStates = [];
    this.currentDate = [];
    this.disable_for_draft = false;
    this.maxDate = [];
    this.fileDragdrop = null;
    this.commonVariables.creditFlag = false;
    this.points = 0;
    this.photoIdnew = null;
    var data: any = {}
    data.userId = this.userId
    data.userType = this.userType;

    try {

      this.API.create('user/profileDetails', data).subscribe(res => {
        if (res.data && res.data.exeperienceList) {
          this.workExp = res.data.exeperienceList;
          res.data.exeperienceList.forEach(workExperience => {
            if (workExperience.currentOrganization) {
              this.currentOrg = true;
              this.currentOrganizationDetail = workExperience;
            }
            if (workExperience.currentOrganization == true) {
              this.workauthcountry = workExperience.country;
            }
          });
        }
        //patching work exp country in default job and candidate form by monisha
        this.onChangeCountry(this.workauthcountry, null)
        this.firstName = res.data.userData.firstName;
        this.lastName = res.data.userData.lastName;
        this.phoneNo = res.data.userData.phoneNo;
        this.primaryEmail = res.data.userData.email;

        if (res.data.userData.secondaryEmail == null || res.data.userData.secondaryEmail == undefined) {
          this.secondaryEmail = 'None provided'
        } else {
          this.secondaryEmail = res.data.userData.secondaryEmail
        }

        var validateEmail: any;
        validateEmail = this.primaryEmail.split('@')[1];
        this.clientType = res.data.userData.clientType
        this.userdata1 = res.data.exeperienceList
        this.userdatacandidate = res.data.exeperienceList
        res.data.GIGSUMO_GENERIC_EMAIL_DOMAINS.listItems.forEach(ele => {
          this.domainList.push(ele.item)
        })
        if (param === 'JOBS' && ((res.data.exeperienceList == null || res.data.exeperienceList.length == 0) || (res.data.exeperienceList.length > 0 && !this.currentOrg))) {

          if (this.modalRef != undefined) {
            this.modalRef.hide()
          }

          if (this.userType != 'FREELANCE_RECRUITER') {
            this.modalRef = this.modalService.show(template, this.backdropConfig);
            this.addWorkExperience(res.data.userData.clientType);
          }
          /* this functionality wil bring up in FR  fir timezone popup by monisha**/
          else if (param === 'JOBS' && this.userType == 'FREELANCE_RECRUITER' && res.data.currentTimeByTimezone == undefined) {
            this.showModal = true;
          }
          else {

            if (param === 'JOBS') {
              this.commonVariables.jobPostingFlag = true;
              this.commonVariables.candidatePostingFlag = false;
              const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
              this.modalRef = this.modalService.show(template, modalConfig);
              if (res.data.exeperienceList) {
                res.data.exeperienceList.forEach(ele => {
                  this.workExperienceDetailsCheck.push(ele)
                })
              }
              this.createJobs();
            } else if (param === 'CANDIDATE') {
              if (res.data.exeperienceList) {
                res.data.exeperienceList.forEach(ele => {
                  this.workExperienceDetailsCheck.push(ele)
                })
              }
              const modalConfig = { ...this.backdropConfig, class: 'modal-small' }
              this.modalRef = this.modalService.show(template, modalConfig);
              this.createCandidate();
            }

          }
        }
        else if (param === 'JOBS' && ((res.data.exeperienceList != null || res.data.exeperienceList.length > 0) && this.currentOrg)) {
          if (this.modalRef != undefined) {
            this.modalRef.hide()
          }

          this.commonVariables.jobPostingFlag = true;
          this.commonVariables.candidatePostingFlag = false;
          const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
          this.modalRef = this.modalService.show(template, modalConfig);

          res.data.exeperienceList.forEach(ele => {
            this.workExperienceDetailsCheck.push(ele)
          })

          this.createJobs();

        } else if (param == 'JOBS' && this.userType == 'FREELANCE_RECRUITER') {
          if (this.modalRef != undefined) {
            this.modalRef.hide()
          }
          if (res.data.exeperienceList) {
            res.data.exeperienceList.forEach(ele => {
              this.workExperienceDetailsCheck.push(ele)
            });
          }
          this.commonVariables.jobPostingFlag = true;
          this.commonVariables.candidatePostingFlag = false;
          const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
          this.modalRef = this.modalService.show(template, modalConfig);
          this.createJobs();
        }
        else if (this.userType != 'FREELANCE_RECRUITER' && param === 'CANDIDATE' && ((res.data.exeperienceList === null || res.data.exeperienceList.length === 0) || (res.data.exeperienceList.length > 0 && !this.currentOrg))) {
          res.data.exeperienceList.forEach(ele => {
            this.workExperienceDetailsCheck.push(ele)
          })
          this.addWorkExperience(res.data.userData.clientType);
          this.modalRef = this.modalService.show(template, this.backdropConfig);
        }
        /* this functionality wil bring up in FR  fir timezone popup by monisha**/
        else if (param === 'CANDIDATE' && this.userType == 'FREELANCE_RECRUITER' && res.data.currentTimeByTimezone == undefined) {
          this.showModal = true;
        }
        else if (param === 'CANDIDATE' && ((res.data.exeperienceList != null || res.data.exeperienceList.length > 0) && this.currentOrg)) {
          if (this.userType == 'JOB_SEEKER') {
            //job seeker candidate creation validation by monisha
            if (res.data.candidateList) {
              const activeCandidates = res.data.candidateList.filter(candidate => candidate.status.toUpperCase() === 'ACTIVE');
              if (activeCandidates.length >= 1) {
                this.gigsumoService.buttonClicked = true;
                Swal.fire({
                  position: "center",
                  icon: "info",
                  title: "Number of profiles exceeded.",
                  text: "You can't create more than 1 profile for yourself as a job seeker.",
                  showConfirmButton: true,
                  showCancelButton: false,
                });
              } else if (res.data.candidateList.length < 1) {
                this.createCandidate()
                const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
                this.modalRef = this.modalService.show(template, modalConfig);
              }
            } else {
              this.createCandidate()
              const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
              this.modalRef = this.modalService.show(template, modalConfig);
            }
          }
          else {
            this.commonVariables.candidatePostingFlag = true
            this.commonVariables.jobPostingFlag = false
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.emailDomainValidation = false
            this.commonVariables.educationFlag = false
            res.data.exeperienceList.forEach(ele => {
              this.workExperienceDetailsCheck.push(ele)
            })
            this.createCandidate()
            const modalConfig = { ...this.backdropConfig, class: 'modal-small' };
            this.modalRef = this.modalService.show(template, modalConfig);

          }
        } else if (param === 'CANDIDATE' && this.userType == 'FREELANCE_RECRUITER') {
          this.commonVariables.candidatePostingFlag = true;
          this.commonVariables.jobPostingFlag = false;
          this.commonVariables.workExperienceFlag = false;
          this.commonVariables.emailDomainValidation = false;
          this.commonVariables.educationFlag = false;
          res.data.exeperienceList.forEach(ele => {
            this.workExperienceDetailsCheck.push(ele)
          })
          this.createCandidate()
          this.modalRef = this.modalService.show(template, this.backdropConfig);
        }
        setTimeout(() => {
          this.gigsumoService.buttonClicked = true;
        }, 2000);

      });

    } catch (error) {
      this.util.stopLoader();
    }
    finally {
      setTimeout(() => {
        this.util.stopLoader();


      }, 1000);
    }

  }
  getCountries_forform() {
    this.countryList = [];
    this.util.startLoader();
    this.API.query("country/getAllCountries").subscribe((res) => {
      this.util.stopLoader();
      if (res != undefined) {
        res.forEach((ele) => {
          this.countryList.push(ele);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  routeToCredits() {
    this.showmodel = false
    this.modalRef.hide();
    this.router.navigate(['/checkout'])
  }

  openJobOrCandidate(openForm: { content: string, data: any }, template: TemplateRef<any>) {

    if (openForm.content === 'JOBS') {
      this.initiateJobForm();
      this.commonVariables.jobPostingFlag = true
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.educationFlag = false
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)
    } else if (openForm.content === 'CANDIDATE') {
      this.inititateCandidateForm();
      this.commonVariables.candidatePostingFlag = true
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.educationFlag = false
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)
    } else if (openForm.content === 'CREDIT') {
      this.commonVariables.creditFlag = true
      this.commonVariables.educationFlag = false
      this.commonVariables.workExperienceFlag = false
      this.commonVariables.jobPostingFlag = false
      this.commonVariables.candidatePostingFlag = false
      this.commonVariables.postPrivacyFlag = false
      this.commonVariables.emailDomainValidation = false
    }
    setTimeout(() => {
      this.createJobsOrCandidates(this.currentEntity, this.jobCandidateTemplate, true);
    }, 1000);
  }
  validateOtp(param) {
    if (this.domainForm.value.domainValidationOtp == null || this.domainForm.value.domainValidationOtp == '' || this.domainForm.value.domainValidationOtp == undefined) {
      this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })
    } else {
      var data: any = {}
      data.primaryMailId = this.domainForm.value.swapEmail
      if (this.secondaryEmail == null || this.secondaryEmail == undefined || this.secondaryEmail == 'None provided') {
        data.secondaryMailId = this.primaryEmail  // working pending hre abu
      } else if (this.secondaryEmail != null && this.secondaryEmail != undefined && this.secondaryEmail != 'None provided') {
        data.secondaryMailId = this.secondaryEmail
      }
      data.entityId = this.userId
      data.businessId = this.userId
      data.otp = this.domainForm.value.domainValidationOtp
      this.API.create('user/verifyOTPToPrimaryMailId', data).subscribe(res => {
        this.util.startLoader()
        if (res.code == '00000' && res.message != 'Invalid OTP') {
          this.util.stopLoader()
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
          this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
          this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
          this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Please use the new business email address to login to the application, the next time you login.",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.onLogout()
            if (this.workExperienceDetailsCheck.length > 0) {
              if (param == 'JOBS') {
                this.initiateJobForm()
                setTimeout(() => {
                  this.commonVariables.jobPostingFlag = true
                  this.commonVariables.candidatePostingFlag = false
                  this.commonVariables.workExperienceFlag = false
                  this.commonVariables.educationFlag = false
                  this.commonVariables.emailDomainValidation = false
                  this.searchData.setCommonVariables(this.commonVariables)
                }, 3000);
              } else if (param == 'CANDIDATE') {
                this.inititateCandidateForm()
                setTimeout(() => {
                  this.commonVariables.candidatePostingFlag = true;
                  this.commonVariables.jobPostingFlag = false;
                  this.commonVariables.workExperienceFlag = false;
                  this.commonVariables.educationFlag = false;
                  this.commonVariables.emailDomainValidation = false;
                  this.searchData.setCommonVariables(this.commonVariables)
                }, 3000);
              }
            } else {
              if (this.userType != 'FREELANCE_RECRUITER') { this.addWorkExperience() }
            }
          })
        } else if (res.code == '99999') {
          this.util.stopLoader()
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })
        }
        else if (res.code == '99998') {
          this.util.stopLoader()
          this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: true })
        }
      })
    }
  }
  symbolsOnly(control: AbstractControl) {
    if (!/^[^`~!@#$%\^&*()_+={}|[\]\\:';"<>?,./]*$/.test(control.value)) {
      return { symbols: true };
    }
    return null;
  }
  closeValidator(param) {
    if (param == 'JOBS') {
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)
    } else if (param == 'CANDIDATE') {
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)
    }
  }
  get domainControl() {
    return this.domainForm.controls
  }
  closeEmailDomainValidator() {
    if (this.otpEmailSent == true) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure you want to discontinue the validation?",
          text: "If you ignore this process, you may not create Jobs or Candidates.",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
            this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
            this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
            this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
            this.otpEmailSent = false
            this.commonVariables.emailDomainValidation = false
            this.searchData.setCommonVariables(this.commonVariables)
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.commonVariables.emailDomainValidation = true
            this.searchData.setCommonVariables(this.commonVariables)
          }
        })
    } else if (this.otpEmailSent == false) {
      this.commonVariables.emailDomainValidation = false
      this.searchData.setCommonVariables(this.commonVariables)
    }
  }
  otpEmailSent: boolean = false
  domainValidatorSubmit: boolean = false
  proceedAfterValidation(param) {
    this.domainValidatorSubmit = true
    if (this.domainForm.valid) {
      this.util.startLoader()
      var validateEmail: any;
      validateEmail = this.domainForm.value.swapEmail.split('@')[1];
      const a = this.domainList.indexOf(validateEmail)
      if (a != '-1') {
        this.util.stopLoader()
        this.domainForm.get('swapEmail').setErrors({ genericDomain: true })
      } else {
        this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
        this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
        // this.commonVariables.emailDomainValidation = false
        var data: any = {}
        data.email = this.domainForm.value.swapEmail
        data.firstName = this.firstName
        data.lastName = this.lastName
        data.userId = this.userId
        this.API.create('user/sendOtpToMailId', data).subscribe(res => {
          if (res.code == '00000') {
            this.util.stopLoader()
            this.otpEmailSent = true
            this.domainForm.get('domainValidationOtp').setValidators([Validators.required])
            this.domainForm.get('domainValidationOtp').updateValueAndValidity()
            this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
            this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
            this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
            this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
          } else if (res.code == '99998') {
            this.util.stopLoader()
            // this.otpEmailSent = false
            this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: true })
          }
        })
      }
    }
  }
  toTitleCase(str: string): string {
    return str.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }
  async inititateCandidateForm() {
    try {
      // Pre-select Marketplace for Free plan users and JOB_SEEKER before form initialization
      if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
        this.selectedNetworks = ['1'];
      } else {
        this.selectedNetworks = [];
      }

      const promises = [
        this.getCountries(),
        this.generateYears(),
        this.generateYears2(),
        this.getListValues('CANDIDATE')
      ];
      await Promise.all(promises);
      let location: Location;
      if (this.userdatacandidate != null) {
        this.userdatacandidate.forEach(ele => {
          if (ele.currentOrganization == true) {
            location = {
              country: ele.country,
              city: ele.city,
              state: ele.state,
              zipCode: ele.zipcode
            };
          }
        });
        if (location != undefined) this.onChangeCountry(location.country, null);
      }
      this.candidatePostForm = new AppSettings().getCreateCandidateForm(location);
      this.searchData.setCommonVariables(this.commonVariables);
      if (this.userType == 'JOB_SEEKER') {
        this.candidatePostForm.get('candidateEmailId').clearValidators();
        this.candidatePostForm.get('candidateEmailId').updateValueAndValidity();
      }
      try {
        var userid = localStorage.getItem('userId');
        var formval: any = localStorage.getItem(userid + "_landingPagecandidatePostForm");
        if (formval != null || formval != undefined) {
          formval = formval.slice(1, -1);
          var tempdata = CryptoJS.AES.decrypt(decodeURIComponent(formval), "secret key");
          var decrypt = JSON.parse(tempdata.toString(CryptoJS.enc.Utf8));
          this.onChangeCountry(decrypt.country, '');
          if (decrypt.secondarySkills != null) {
            decrypt.secondarySkills.forEach(ele => {
              this.secondarySkillsSelected.push(ele);
            });
          }
          if (decrypt.primarySkills != null) {
            decrypt.primarySkills.forEach(ele => {
              this.primarySkillsSelected.push(ele);
            });
          }
          this.candidatePostForm.patchValue(decrypt);
        }
      } catch (error) {
        localStorage.removeItem(userid + "_landingPagecandidatePostForm");
      }
    }
    finally {
    }
  }
  createCandidateOnProf(event) {
    if (event.target.checked == true) {
      this.candidatePostForm.get('candidateEmailId').setValidators([Validators.required])
    } else {
      this.candidatePostForm.get('candidateEmailId').clearValidators()
      this.candidatePostForm.get('candidateEmailId').updateValueAndValidity({ emitEvent: false })
    }
  }
  candidateJobTitleList: any = []
  otherStatesList: any = []
  showCandidateTabForm = false;
  @ViewChild('candidateTabTemplate', { static: false }) candidateTabTemplate: TemplateRef<any>;

  openCandidateTabForm() {
    // Open the new tab-based candidate form in a modal
    const modalConfig = {
      class: 'modal-xl modal-fullscreen-lg-down',
      backdrop: true,
      keyboard: false,
      ignoreBackdropClick: true
    };
    
    // Show the new tab-based form template
    this.showCandidateTabForm = true;
    if (this.candidateTabTemplate) {
      this.modalRef = this.modalService.show(this.candidateTabTemplate, modalConfig);
    }
  }

  onCandidateTabFormSubmit(formData: any) {
    // Handle the form submission from the tab-based form
    console.log('Tab form submitted:', formData);
    // Call your API to save candidate
    this.saveCandidateFromTabForm(formData);
  }

  onCandidateTabFormCancel() {
    // Handle form cancellation
    this.showCandidateTabForm = false;
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  saveCandidateFromTabForm(formData: any) {
    // Implementation for saving candidate from the new tab form
    this.util.startLoader();

    // For Free plan users and Job Seekers, always post to Marketplace
    const postedToMarketPlace = (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') ? true : (formData.postedToMarketPlace || false);

    const candidateData: any = {
      ...formData,
      createdBy: localStorage.getItem('userId'),
      createdByUserType: localStorage.getItem('userType'),
      source: 'TABBED_FORM',
      postedToMarketPlace: postedToMarketPlace
    };
    if (this.membershipType !== 'Free') {
      candidateData.businessId = localStorage.getItem('myBusinessId') || null;
    }

    // Create FormData similar to existing saveCandidate method
    const formDataPayload = new FormData();
    if (formData.resumeFile) {
      formDataPayload.append("resume", formData.resumeFile);
    }
    formDataPayload.append("candidate", new Blob([JSON.stringify(candidateData)], { type: "application/json" }));

    this.API.create('candidates/createCandidate', formDataPayload).subscribe({
      next: (res) => {
        this.util.stopLoader();
        if (res.code === '00000') {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Candidate profile created successfully',
            confirmButtonColor: '#8B5CF6'
          });
          this.onCandidateTabFormCancel();
          
          // Refresh the page data if needed
          // this.getCandidateStreamData();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Something went wrong while creating candidate',
            confirmButtonColor: '#dc3545'
          });
        }
      },
      error: (err) => {
        this.util.stopLoader();
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to create candidate profile',
          confirmButtonColor: '#dc3545'
        });
        console.error('Error creating candidate:', err);
      }
    });
  }

  async createCandidate() {
    await this.inititateCandidateForm()
    if (this.userType == 'JOB_SEEKER') {
      this.candidatePostForm.patchValue({
        createCandidateOnPlatform: false,
        // JOB_SEEKER's email field is disabled (derived from the user account),
        // so patchEmail()/(input) never fires to sync candidateEmailId. Send the
        // same primaryEmail here so the candidate entity persists the email
        // (otherwise the profile panel shows "-").
        candidateEmailId: this.primaryEmail,
        email: this.primaryEmail,
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phoneNo,
        createdBy: localStorage.getItem('userId')
      })
      this.candidatePostForm.get('email').disable()
      this.candidatePostForm.get('firstName').disable()
      this.candidatePostForm.get('lastName').disable()
    } else {
      this.candidatePostForm.get('email').enable()
      this.candidatePostForm.get('firstName').enable()
      this.candidatePostForm.get('lastName').enable()
      this.candidatePostForm.patchValue({
        createdBy: localStorage.getItem('userId')
      })
    }
  }
  FormData: any;
  uploadFiles: Array<any> = [];
  saveCandidate(statusvaluecandidate) {

    this.candidateSubmit = true
    this.disable_for_draft = true;

    // Validate resume upload is mandatory for non-draft submissions
    // if (statusvaluecandidate == 'ALL' && !this.resumeupload) {
    //   this.disable_for_draft = false;
    //   return true;
    // }

    if (statusvaluecandidate == 'ALL' && this.candidatePostForm.status == "INVALID") {
      this.disable_for_draft = false;
      this.scrollToFirstInvalidControl('candidatefrom')
      return true;
    }
    localStorage.removeItem(this.userid + '_landingPagecandidatePostForm');
    this.FormData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (this.resumeupload != null && this.resumeupload !== '') {
      this.FormData.append("resume", this.resumeupload);
    }
    this.candidatePostForm.patchValue({ 'createdByUserType': localStorage.getItem('userType') })
    this.candidatePostForm.value.createdByUserType = localStorage.getItem('userType')

    if (this.photoIdnew != null || this.photoIdnew != undefined) {
      this.candidatePostForm.value.photo = this.photoIdnew;
      this.candidatePostForm.patchValue({ 'photo': this.photoIdnew })
    }
    if (statusvaluecandidate == "DRAFTED") {
      for (var allstatus in this.candidatePostForm.controls) {
        if (allstatus != 'firstName' && allstatus != 'lastName') {
          this.candidatePostForm.get(allstatus).clearValidators();
        }
        this.candidatePostForm.controls[allstatus].updateValueAndValidity();
      }
      this.candidatePostForm.get('status').patchValue('DRAFTED');
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    if (statusvaluecandidate != "DRAFTED") {
      this.savecandidateafterValdaiton();
    } else {
      this.draftsavecandidate(statusvaluecandidate)
    }
  }

  getRelevantData() {
    const candidateData = this.candidatePostForm.value;
    return {
      firstName: candidateData.firstName,
      lastName: candidateData.lastName,
      primarySkills: candidateData.primarySkills,
      secondarySkills: candidateData.secondarySkills,
      remoteWork: candidateData.remoteWork,
      payType: candidateData.payType,
      totalExperience: candidateData.totalExperience,
      jobTitle: candidateData.jobTitle,
      country: candidateData.country,
      state: candidateData.state,
      availableIn: candidateData.availableIn,
      engagementType: candidateData.engagementType
    };
  }

  showResume = false;
  summary;
  savecandidateafterValdaiton() {
    // The post-save navigate below goes through navigateWithFreshRoute so the
    // candidate list reloads; the old session-wide reuse override here is gone.
    localStorage.removeItem(this.userid + '_landingPagecandidatePostForm');
    this.FormData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (this.resumeupload != null && this.resumeupload !== '') {
      this.FormData.append("resume", this.resumeupload);
    }
    this.resumeupload = "";
    let datas: any = {};
    datas = this.candidatePostForm.getRawValue();
    datas.createdBy = localStorage.getItem('userId');

    //publish to networks sending in api by monisha
    const personalNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Personal Networks';
      });

    const memberNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Member Networks';
      });

    const businessNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Business Networks';
      });
    // Add the categorized network ids to the request
    datas.personalNetworksPublished = personalNetworksPublished;
    datas.memberNetworksPublished = memberNetworksPublished;
    datas.businessNetworksPublished = businessNetworksPublished;
    const isMarketplaceSelected = (this.selectedNetworks || []).map(item => Number(item)).includes(1);
    // For Free plan users and Job Seekers, always post to Marketplace
    datas.postedToMarketPlace = (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') ? true : isMarketplaceSelected;
    if (this.currentOrganizationDetail && this.currentOrganizationDetail.organisationId) {
      datas.organisationId = this.currentOrganizationDetail.organisationId;
      this.candidatePostForm.get('organisationId').patchValue(this.currentOrganizationDetail.organisationId);
    }
    if (this.membershipType !== 'Free') {
      datas.businessId = localStorage.getItem('myBusinessId') || null;
    }
    const currentStatus: string = this.candidatePostForm.value.status;
    datas.candidateReferenceId = datas.candidateId;
    const resumeSummary = this.candidatePostForm.value.resumeSummary || '';
    //image restriction in resume summary by monisha
    const cleanedContent = resumeSummary.replace(/<img[^>]*>/g, '');
    datas.resumeSummary = cleanedContent;
    this.FormData.append("candidate", new Blob([JSON.stringify(datas)], { type: "application/json" }));

    this.util.startLoader();
    this.canidateStreamData = [];
    this.API.create('candidates/createCandidate', this.FormData).subscribe(res => {
      this.searchData.setCandiHighLight(this.candidatePostForm.value.candidateId);
      this.util.startLoader()
      this.fileshow = undefined;
      if (res.code == '00000') {
        // this.gtag.event('candidate-creation', {
        //   'app-name': 'Gigsumo',
        //   'screen-name': 'header'
        // })
        this.photoIdnew = null;
        
        // Save parsed resume data if available
        const candidateId = res.data?.candidateData?.candidateId || res.data?.candidateId;
        if (candidateId && this.parsedResumeData) {
          console.log('🔄 Saving parsed resume data for candidate:', candidateId);
          // The saveParsedResumeDataToBackend method now handles UI refresh automatically
          this.saveParsedResumeDataToBackend(candidateId);
        }
        
        if (environment.AsyncSync == "SYNC") {
          if (res.code == '00000') {
            this.disable_for_draft = false;
            this.canidateStreamData = [];
            this.candidateSubmit = false
            this.util.stopLoader();
            this.modalRef.hide();
            let data: any = {}
            data.count = 1;
            data.flag = true;
            data.status = res.data.candidateData.status
            this.searchData.setcandiadateCount(data);
            this.searchData.setcandidateform(localStorage.getItem('candidateForm'));
            this.currentDate = [];
            this.maxDate = [];
            Swal.fire({
              position: "center",
              icon: "success",
              allowOutsideClick: false,
              allowEscapeKey: false,
              title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.modalService.hide(1);
              this.modalService.hide(2);
              this.modalService.hide(3);
              this.commonVariables.jobPostingFlag = false
              this.commonVariables.workExperienceFlag = false
              this.commonVariables.educationFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
            })
            setTimeout(() => {
              navigateWithFreshRoute(this.router, ["newcandidates"], { queryParams: { createCandidate: res.data.candidateData.candidateId, status: this.candidatePostForm.get('status').value } });
              this.searchData.setHighlighter('newcandidates')
              this.d = "newcandidates";
            }, 100);
            setTimeout(() => {
              this.pageName = 'newcandidates'
              if (this.pageName == 'newcandidates') {
                this.commonVariables.loadCandidates = true
              }
            }, 100);
          }
        }
        else if (environment.AsyncSync == "ASYNC") {
          // let timeout: any = undefined;
          // // 3 mins validate
          // this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
          //   timeout = val;
          // });
          // const source = interval(0);
          // this.subscription = source.subscribe(val => {
          //   // time out
          //   if (timeout != undefined) {
          //     this.canidateStreamData = [];
          //     this.util.stopLoader();
          //     this.subscription.unsubscribe();
          //     Swal.fire({
          //       position: "center",
          //       icon: "info",
          //       title: "Candidate is being created. Please refresh the page",
          //       showConfirmButton: false,
          //       allowEscapeKey: false,
          //       allowOutsideClick: false,
          //       timer: 1500,
          //     })
          //   }
          //   if (this.canidateStreamData && this.canidateStreamData.code == "00000") {
          //     this.util.stopLoader();
          //     // clear subscriber
          //     this.subscription.unsubscribe();
          //     if (this.canidateStreamData != undefined && this.canidateStreamData.length != 0 && this.canidateStreamData.code == "00000" && res.data.candidateData.candidateId == this.streamData.requestId) {
          //       if (res.code == '00000') {
          //         this.disable_for_draft = false;
          //         // clear subscriber response
          //         this.canidateStreamData = [];
          //         this.stremService.clearsubjectvalue();
          //         this.candidateSubmit = false
          //         this.util.stopLoader();
          //         this.modalRef.hide();
          //         let data: any = {}
          //         data.count = 1;
          //         data.flag = true;
          //         data.status = res.data.candidateData.status
          //         this.searchData.setcandiadateCount(data);
          //         this.searchData.setcandidateform(localStorage.getItem('candidateForm'));
          //         this.currentDate = [];
          //         this.maxDate = [];
          //         Swal.fire({
          //           position: "center",
          //           icon: "success",
          //           allowOutsideClick: false,
          //           allowEscapeKey: false,
          //           title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
          //           showConfirmButton: false,
          //           timer: 2000,
          //         }).then(() => {
          //           this.modalService.hide(1);
          //           this.modalService.hide(2);
          //           this.modalService.hide(3);
          //           this.commonVariables.jobPostingFlag = false
          //           this.commonVariables.workExperienceFlag = false
          //           this.commonVariables.educationFlag = false
          //           this.searchData.setCommonVariables(this.commonVariables)
          //         })
          //         setTimeout(() => {
          //           this.router.navigate(["newcandidates"], { queryParams: { createCandidate: res.data.candidateData.candidateId, status: this.candidatePostForm.get('status').value } });
          //           this.searchData.setHighlighter('newcandidates');
          //           this.d = "newcandidates";
          //         }, 100);
          //         setTimeout(() => {
          //           this.pageName = 'newcandidates'
          //           if (this.pageName == 'newcandidates') {
          //             this.commonVariables.loadCandidates = true
          //             this.searchData.setLoadJobOrCandidate(this.commonVariables)
          //           }
          //         }, 200);
          //       } else {
          //         Swal.fire({
          //           position: "center",
          //           icon: "info",
          //           title: "Candidate is being created. Please refresh the page",
          //           showConfirmButton: false,
          //           allowEscapeKey: false,
          //           allowOutsideClick: false,
          //         });
          //       }
          //     }
          //   }
          // });
          this.disable_for_draft = false;
          this.canidateStreamData = [];
          this.candidateSubmit = false
          this.util.stopLoader();
          this.modalRef.hide();
          let data: any = {}
          data.count = 1;
          data.flag = true;
          data.status = res.data.candidateData.status
          this.searchData.setcandiadateCount(data);
          this.searchData.setcandidateform(localStorage.getItem('candidateForm'));
          this.currentDate = [];
          this.maxDate = [];
          Swal.fire({
            position: "center",
            icon: "success",
            allowOutsideClick: false,
            allowEscapeKey: false,
            title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Candidate created"),
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.modalService.hide(1);
            this.modalService.hide(2);
            this.modalService.hide(3);
            this.commonVariables.jobPostingFlag = false
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.educationFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          })
          setTimeout(() => {
            navigateWithFreshRoute(this.router, ["newcandidates"], {
              queryParams: {
                createCandidate: res.data.candidateData.candidateId,
                status: this.candidatePostForm.get('status').value,
                artificialAdd : 'true',
                candidateData : JSON.stringify(res.data.candidateData)
              }
            });
            this.searchData.setHighlighter('newcandidates')
            this.d = "newcandidates";
          }, 100);
          setTimeout(() => {
            this.pageName = 'newcandidates'
            if (this.pageName == 'newcandidates') {
              this.commonVariables.loadCandidates = true
            }
          }, 100);
        }
      }
    });
  }
  // cancel validation check
  cancelJob() {
    this.submit = false
    if (this.jobPostForm && this.jobPostForm.get('clientName').value != null && this.jobPostForm.value.jobTitle != null) {
      this.jobPostForm.get('status').patchValue('DRAFTED');
      this.draftsavecancel('DRAFTED');
    } else if (this.jobPostForm) {
      this.commonVariables.jobPostingFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
      this.modalRef.hide();
      this.jobPostForm.reset()
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.primarySkillsList = []
      this.secondarySkillsList = []
      this.otherSelectedStates = []

      // Reset JD parsing state
      this.jdParsingService.isJdParsing = false;
      this.jdParsingService.jdParseSuccess = false;
      this.jdParsingService.jdParseFailed = false;
    }
  }
  cancelcloseCandidate() {
    this.candidateSubmit = false
    if (this.candidatePostForm.value.firstName != null && this.candidatePostForm.value.lastName != null) {
      this.candidatePostForm.get('status').patchValue('DRAFTED');
      this.draftsavecandidate('DRAFTED');
    } else {
      this.commonVariables.candidatePostingFlag = false
      this.searchData.setCommonVariables(this.commonVariables)
      this.modalRef.hide();
      this.candidatePostForm.reset()
      this.primarySkillsSelected = [];
      this.secondarySkillsSelected = [];
      this.otherSelectedStates = []

      // Reset resume parsing state
      this.parseSuccess = false;
      this.parseFailed = false;
      this.parsedResumeData = null;
      this.showParsedDetails = false;
      this.isParsing = false;
    }
  }
  clientType: any;
  modalRef: BsModalRef;
  serverCurrentDate: string;
  saveJob(statusvalue) {
    this.submit = true
    this.disable_for_draft = true;
    if (statusvalue == 'ALL' && this.jobPostForm.status == "INVALID") {
      this.disable_for_draft = false;
      this.scrollToFirstInvalidControl('jobfrom')
      return true;
    }
    this.streamData = [];
    localStorage.removeItem(this.userid + '_landingPagejobPostForm');
    this.submit = true
    if (statusvalue === "DRAFTED") {
      for (var allstatus in this.jobPostForm.controls) {
        if (allstatus != 'clientName' && allstatus != 'jobTitle') {
          this.jobPostForm.get(allstatus).clearValidators();
        }
        this.jobPostForm.controls[allstatus].updateValueAndValidity();
      }
      this.jobPostForm.get('status').patchValue('DRAFTED');
    }
    if (this.jobPostForm.valid) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
        buttonsStyling: false
      })
      if (statusvalue != "DRAFTED") {
        this.savejobafterValdaiton();
      } else {
        this.draftsavecancel(statusvalue)
      }
    }
  }
  // Holds the pending route-reuse restore fn while a same-menu re-click
  // navigation is in flight (see selectMenu). Null when nothing is pending.
  private reuseRestore: (() => void) | null = null;

  selectMenu(value) {
    this.pageName = value;

    // Re-clicking the already-active menu should reset that page to its
    // default state. A plain navigate to the same URL is a no-op, so we force
    // Angular to destroy + recreate the page component IN PLACE by disabling
    // route reuse for just this one navigation (with onSameUrlNavigation
    // 'reload' so the same-URL navigation actually runs). Recreation re-runs
    // the component constructor/ngOnInit, which fires a fresh backend fetch
    // (newcandidates → candidates/filter, newjobs → jobs/filter), so the page
    // reloads with fresh data, not stale cache. This previously detoured
    // through the visible `/widget` route to trigger recreation, which briefly
    // flashed an unrelated landing page — this avoids that. For a different
    // target, a plain navigate is enough.
    const target = '/' + value;
    const current = this.router.url.split(/[?#]/)[0];
    if (current === target) {
      const reuse = this.router.routeReuseStrategy;
      // Guard against overlapping rapid re-clicks: only the first capture saves
      // the pristine strategy; every navigation restores it once it settles, so
      // we never leave route reuse permanently disabled.
      if (!this.reuseRestore) {
        const savedShouldReuse = reuse.shouldReuseRoute;
        this.reuseRestore = () => {
          reuse.shouldReuseRoute = savedShouldReuse;
          this.reuseRestore = null;
        };
        reuse.shouldReuseRoute = () => false;
      }
      this.router
        .navigate([value], { onSameUrlNavigation: 'reload' })
        .then(() => this.reuseRestore?.(), () => this.reuseRestore?.());
    } else {
      this.router.navigate([value]);
    }

    this.searchData.setHighlighter([value]);
    if (value == "landingPage") {
      this.JobServicecolor.reloadComponent(); // Emit reload signal when value is "landingPage"
    }
  }

  // ── Alerts slider panel (see <app-notification-panel>) ──────────────
  openNotifPanel() {
    this.notifPanelOpen = true;
    // Always reset on open so the newest notifications are at the top.
    this.notifPanelCursor = null;
    this.notifPanelHasMore = false;
    this.fetchNotifPanelList(true);
    // Already on the Notifications page: reload its list too, so it shows the
    // same latest notifications as the slider (the page keeps its own list).
    const path = this.router.url.split('?')[0];
    if (path === '/notification' || path === '/notifications') {
      this.searchData.triggerNotificationsRefresh();
    }
  }

  closeNotifPanel() { this.notifPanelOpen = false; }

  onNotifViewAll() {
    this.notifPanelOpen = false;
    this.selectMenu('notification');
  }

  onNotifItemClick(item: NotificationItem) {
    if (item.unread && item.id) {
      this.API.create('notification/read/' + item.id, {}).subscribe({
        next: () => {
          item.unread = false;
          // The /notifications page fetches its own independent list, so
          // tell it directly rather than leaving it stuck purple until reload.
          this.searchData.markNotificationRead(item.id);
        },
        error: () => {},
      });
    }
  }

  onNotifLoadMore() {
    if (this.notifPanelLoading || this.notifPanelLoadingMore || !this.notifPanelHasMore) return;
    this.fetchNotifPanelList(false);
  }

  // Guard against a second call while the first is still in flight. The button stays
  // visible while the request runs, and a double click would otherwise re-send it.
  notifMarkAllReadInFlight = false;

  /**
   * "Mark all read" in the alerts panel.
   *
   * Calls the bulk endpoint, then reflects the result locally: every loaded item loses
   * its unread dot and the header badge goes to zero. The local update happens ONLY
   * after the call succeeds - flipping first would leave the panel showing everything
   * read while the server still had them unread, which is exactly what the previous
   * note in this spot warned against.
   *
   * userId is read from localStorage, the same source the panel's own fetch uses.
   */
  onNotifMarkAllRead() {
    if (this.notifMarkAllReadInFlight) {
      return;
    }
    const userId = localStorage.getItem('userId');
    if (!userId) {
      return;
    }
    this.notifMarkAllReadInFlight = true;

    this.API.create('notification/markAllAsRead', { userId: userId, read: true }).subscribe({
      next: (res: any) => {
        this.notifMarkAllReadInFlight = false;
        // Trust a successful response the same way onNotifItemClick does for a single
        // read - gating on an exact `code: '00000'` match silently no-ops the whole
        // bulk update (list stays unread, no error) whenever this endpoint's response
        // doesn't carry that field, since the interceptor can also deliver a failed
        // HTTP call into `next` (AppHttpInterceptor falls back to `of(err)` when the
        // error has no body). Only skip the local update on an explicit failure code.
        if (res?.code && res.code !== '00000') {
          console.warn('notification/markAllAsRead returned a failure code', res);
          return;
        }
        this.notifPanelList = this.notifPanelList.map(item => ({ ...item, unread: false }));
        this.notificationcount = 0;
        // Bulk counterpart of the per-item markNotificationRead(id) broadcast above:
        // the /notifications page keeps its own list, so tell it to reload.
        this.searchData.triggerNotificationsRefresh();
      },
      error: () => {
        this.notifMarkAllReadInFlight = false;
      },
    });
  }

  private fetchNotifPanelList(reset: boolean) {
    if (reset) this.notifPanelLoading = true;
    else this.notifPanelLoadingMore = true;

    this.API.create('notification/find', {
      userId: this.userId,
      limit: this.NOTIF_PAGE_SIZE,
      searchAfterKey: reset ? null : this.notifPanelCursor,
    }).subscribe({
      next: (res: any) => {
        if (res?.code === '00000' && res?.data?.notifications) {
          const mapped = mapNotifications(res.data.notifications);
          this.notifPanelList = reset ? mapped : [...this.notifPanelList, ...mapped];
          this.notifPanelCursor = res.data.searchAfterKey ?? null;
          // A full page + a non-null cursor ⇒ more pages probably exist. If
          // the backend returns fewer than a page we stop even if the cursor
          // is present, to avoid a dead-end fetch.
          this.notifPanelHasMore =
            !!this.notifPanelCursor && mapped.length >= this.NOTIF_PAGE_SIZE;
        }
        if (reset) this.notifPanelLoading = false;
        else this.notifPanelLoadingMore = false;
      },
      error: () => {
        if (reset) this.notifPanelLoading = false;
        else this.notifPanelLoadingMore = false;
      },
    });
  }
  draftsavecancel(statusvalue) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later and save. If No is selected,all the changes will be lost.",
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      allowOutsideClick: false,
      allowEscapeKey: false,
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.jobPostForm.get('status').patchValue('DRAFTED');
        this.savejobafterValdaiton();
      } else {
        this.jobPostForm.get('status').patchValue('ACTIVE');
        if (statusvalue != 'DRAFTED') {
          this.savejobafterValdaiton();
        } else {
          this.commonVariables.jobPostingFlag = false
          this.searchData.setCommonVariables(this.commonVariables)
          this.modalRef.hide();
          this.jobPostForm.reset()
          this.primarySkillsSelected = [];
          this.secondarySkillsSelected = [];
          this.primarySkillsList = []
          this.secondarySkillsList = []
          this.otherSelectedStates = []
        }
      }
    });
  }
  draftsavecandidate(statusvaluecandidate) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Save as Draft',
      text: "Would you like to save it as a draft? You can edit this later and save. If No is selected,all the changes will be lost.",
      icon: 'info',
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        if (statusvaluecandidate == 'DRAFTED') {
          this.candidatePostForm.get('status').patchValue('DRAFTED');
        }
        this.savecandidateafterValdaiton();
      } else {
        this.candidatePostForm.get('status').patchValue('DRAFTED');
        if (statusvaluecandidate != 'DRAFTED') {
          this.candidatePostForm.get('status').patchValue('DRAFTED');
          this.savecandidateafterValdaiton();
        } else {
          this.commonVariables.jobPostingFlag = false
          this.searchData.setCommonVariables(this.commonVariables)
          this.modalRef.hide();
          this.candidatePostForm.reset()
          this.primarySkillsSelected = [];
          this.secondarySkillsSelected = [];
          this.primarySkillsList = []
          this.secondarySkillsList = []
          this.otherSelectedStates = []
        }
      }
    });
  }
  savejobafterValdaiton() {
    // The post-save navigate below goes through navigateWithFreshRoute so the
    // job list reloads; the old session-wide reuse override here is gone.
    localStorage.removeItem(this.userid + '_landingPagejobPostForm');
    this.util.startLoader();
    this.jobStreamData = [];
    let datas: any = {};
    datas = this.jobPostForm.getRawValue();
    datas.jobPostedBy = localStorage.getItem('userId');
    //publish to networks sends in api by monisha
    const personalNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Personal Networks';
      });

    const memberNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Member Networks';
      });

    const businessNetworksPublished = (this.selectedNetworks || [])
      .filter((networkId: number) => {
        const network = this.networks.find((n) => n.id === networkId);
        return network && network.type === 'Business Networks';
      });

    // Add the categorized network ids to the request
    datas.personalNetworksPublished = personalNetworksPublished;
    datas.memberNetworksPublished = memberNetworksPublished;
    datas.businessNetworksPublished = businessNetworksPublished;
    const isMarketplaceSelected = (this.selectedNetworks || []).map(item => Number(item)).includes(1);
    // For Free plan users, always post to Marketplace
    datas.postedToMarketPlace = this.membershipType === 'Free' ? true : isMarketplaceSelected;
    if (this.currentOrganizationDetail && this.currentOrganizationDetail.organisationId) {
      datas.organisationId = this.currentOrganizationDetail.organisationId;
    }
    if (this.membershipType !== 'Free') {
      datas.businessId = localStorage.getItem('myBusinessId') || null;
    }

    if (this.workExp && this.workExp.length > 0) {
      this.workExp.forEach(ele => {
        if (ele.currentOrganization == true) {
          this.clientType = ele.clientType;
          datas.createdByType = this.clientType;
        }
      });
    }
    const jobDescription = this.jobPostForm.value.jobDescription || '';
    const cleanedContent = jobDescription.replace(/<img[^>]*>/g, '');
    datas.jobDescription = cleanedContent;
    datas.jobReferenceId = this.jobPostForm.getRawValue().jobId;
    const currentStatus: string = this.jobPostForm.value.status;

    // Resolve behalfOfBusinessId from the clientName autocomplete selection
    // (Option C — quadruple-key model). EXTERNAL picks become the job's
    // behalfOf context; INTERNAL / no-selection leaves it null.
    const currentClientName = this.jobPostForm.get('clientName')?.value;
    if (this.selectedClientSource === 'EXTERNAL'
        && this.selectedClientBusinessId
        && currentClientName === this.selectedClientBusinessName) {
      datas.behalfOfBusinessId = this.selectedClientBusinessId;
    } else {
      datas.behalfOfBusinessId = null;
    }

    // Transform durationType from 'Year' to 'Years' in the payload
    if (datas.durationType === 'Year') {
      datas.durationType = 'Years';
    }

    this.API.create('jobs/createJob', datas).subscribe(res => {
      if (res.code == '00000') {
        // this.gtag.event('job-creation', {
        //   'app-name': 'Gigsumo',
        //   'screen-name': 'feed'
        // })
        this.util.stopLoader();
        if (environment.AsyncSync == "SYNC") {
          if (res.code == '00000') {
            this.disable_for_draft = false;
            this.jobStreamData = [];
            let data: any = {}
            data.count = 1;
            data.flag = true;
            data.status = res.data.jobData.status

            this.searchData.setjobform(localStorage.getItem('jobForm'));
            this.searchData.setjobHighLight(this.jobPostForm.value.jobId);
            this.submit = false
            this.modalRef.hide();
            this.currentDate = [];
            this.maxDate = [];
            Swal.fire({
              position: "center",
              icon: "success",
              title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
              showConfirmButton: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
              timer: 2000,
            }).then(() => {
              this.commonVariables.jobPostingFlag = false
              this.searchData.setCommonVariables(this.commonVariables)
              this.modalService.hide(1);
              this.modalService.hide(2);
              this.modalService.hide(3);
            })
            setTimeout(() => {
              navigateWithFreshRoute(this.router, ["newjobs"], { queryParams: { createJob: res.data.jobData.jobId, status: data.status } });
              this.searchData.setHighlighter('newjobs')
            }, 2000);
          }
        } else if (environment.AsyncSync == "ASYNC") {
          // old process           
          // let timeout: any = undefined;

          // this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe((val) => {
          //   timeout = val;
          // });
          // const source = interval(0);
          // this.subscription = source.subscribe(val => {
          //   if (timeout != undefined) {
          //     this.jobStreamData = [];
          //     this.util.stopLoader();
          //     Swal.fire({
          //       position: "center",
          //       icon: "info",
          //       title: "Job is being created. Please refresh the page",
          //       showConfirmButton: false,
          //       allowEscapeKey: false,
          //       allowOutsideClick: false,
          //       timer: 1500,
          //     })
          //     this.subscription.unsubscribe();
          //     this.modalService.hide(1)
          //   }
          //   if (this.jobStreamData && this.jobStreamData != undefined && this.jobStreamData.length != 0 && this.jobStreamData != null) {
          //     this.util.stopLoader();
          //     this.subscription.unsubscribe();
          //     if (this.jobStreamData.length != 0 && this.jobStreamData != undefined && this.jobStreamData.code == "00000" && res.data.jobData.jobId == this.streamData.requestId) {
          //       if (res.code == '00000') {
          //         this.disable_for_draft = false;
          //         this.subscription.unsubscribe();
          //         this.jobStreamData = [];
          //         this.stremService.clearsubjectvalue();
          //         let data: any = {}
          //         data.count = 1;
          //         data.flag = true;
          //         data.status = res.data.jobData.status;
          //         this.searchData.setjobCount(data);
          //         this.searchData.setjobform(localStorage.getItem('jobForm'));
          //         this.submit = false
          //         this.modalRef.hide();
          //         this.currentDate = [];
          //         this.maxDate = [];
          //         Swal.fire({
          //           position: "center",
          //           icon: "success",
          //           title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
          //           showConfirmButton: false,
          //           allowEscapeKey: false,
          //           allowOutsideClick: false,
          //           timer: 2000,
          //         }).then(() => {
          //           this.commonVariables.jobPostingFlag = false
          //           this.searchData.setCommonVariables(this.commonVariables)
          //           this.modalService.hide(1);
          //           this.modalService.hide(2);
          //           this.modalService.hide(3);
          //         })
          //         setTimeout(() => {
          //           this.router.navigate(["newjobs"], { queryParams: { createJob: res.data.jobData.jobId, status: data.status } });
          //           this.searchData.setHighlighter('newjobs')
          //         }, 2000);
          //       }
          //     } else {
          //       Swal.fire({
          //         position: "center",
          //         icon: "info",
          //         title: "Job is being created. Please refresh the page",
          //         showConfirmButton: false,
          //         allowEscapeKey: false,
          //         allowOutsideClick: false,
          //         timer: 1500,
          //       })
          //     }
          //   }
          // });

          this.disable_for_draft = false;
          this.jobStreamData = [];
          let data: any = {}
          data.count = 1;
          data.flag = true;
          data.status = res.data.jobData.status;

          this.searchData.setjobform(localStorage.getItem('jobForm'));
          this.searchData.setjobHighLight(this.jobPostForm.value.jobId);
          this.submit = false
          this.modalRef.hide();
          this.currentDate = [];
          this.maxDate = [];
          Swal.fire({
            position: "center",
            icon: "success",
            title: super.getTextBasedOnStatus(currentStatus, currentStatus === GigsumoConstants.DRAFTED ? "Draft saved" : "Job created"),
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            timer: 2000,
          }).then(() => {
            this.commonVariables.jobPostingFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
            this.modalService.hide(1);
            this.modalService.hide(2);
            this.modalService.hide(3);
          })
          setTimeout(() => {
            navigateWithFreshRoute(this.router, ["newjobs"], {
              queryParams: {
                createJob: res.data.jobData.jobId,
                status: data.status,
                artificialAdd: 'true',
                jobData: JSON.stringify(res.data.jobData)
              } 
            });
            this.searchData.setHighlighter('newjobs')
          }, 2000);
        }

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;

      }
    }, err => {
      this.util.stopLoader();
    });
  }

  validateLast(year) {
    var fromYear = this.jobPostForm.value.experienceFrom
    if (fromYear != null) {
      if (fromYear > year) {
        return true
      } else {
        return false
      }
    }
  }
  freelancerInternalHireFlag: boolean = false
  onClientTypeChange(value) {
    if (this.userType != 'FREELANCE_RECRUITER') {
      this.freelancerInternalHireFlag = false
      if (value == GigsumoConstants.DIRECT_HIRE) {
        this.jobPostForm.patchValue({ clientName: this.jobPostedBehalfOflist[0].orgName })
        this.jobPostForm.get('clientName').disable()
      } else {
        this.jobPostForm.get('clientName').enable()
        this.jobPostForm.get('clientName').patchValue(null)
      }
    } else if (this.userType == 'FREELANCE_RECRUITER') {
      if (value == GigsumoConstants.DIRECT_HIRE) {
        if (this.jobPostForm.get('jobPostedBehalfOf').value != null) {
          this.jobPostForm.patchValue({ clientName: this.jobPostForm.get('jobPostedBehalfOf').value })
          this.jobPostForm.get('clientName').disable()
        } else {
          this.jobPostForm.get('clientName').patchValue(null)
          this.jobPostForm.get('clientName').enable()
        }
      } else {
        this.jobPostForm.get('clientName').patchValue(null)
        this.jobPostForm.get('clientName').enable()
      }
    }
    if (value == GigsumoConstants.DIRECT_HIRE && this.userType != "FREELANCE_RECRUITER") {
      this.onChangeCountry(this.jobPostedBehalfOflist[0].country, '');
      const stateTitleCase = this.jobPostedBehalfOflist[0].state;
      this.jobPostForm.patchValue({ country: this.jobPostedBehalfOflist[0].country })
      this.jobPostForm.patchValue({ city: this.jobPostedBehalfOflist[0].city })
      this.jobPostForm.patchValue({ state: stateTitleCase });
      this.jobPostForm.patchValue({ zipCode: this.jobPostedBehalfOflist[0].zipCode })
    } else if (value == GigsumoConstants.DIRECT_HIRE && this.userType === "FREELANCE_RECRUITER") {
      this.jobPostedBehalfOflist.forEach(ele => {
        if (ele.orgName === this.jobPostForm.get('jobPostedBehalfOf').value) {
          this.onChangeCountry(ele.country, '');
          this.jobPostForm.get('country').patchValue(ele.country);
          this.jobPostForm.get('city').patchValue(ele.city);
          this.jobPostForm.get('state').patchValue(ele.state);
          this.jobPostForm.get('zipCode').patchValue(ele.zipCode);
        }
      })
    } else if (value != GigsumoConstants.DIRECT_HIRE) {
      this.jobPostForm.get('country').patchValue(null)
      this.jobPostForm.get('state').patchValue(null)
      this.jobPostForm.get('city').patchValue(null)
      this.jobPostForm.get('zipCode').patchValue(null)
    }
  }
  onengagementTypeChange(value) {
    if (value == 'W2 - Full Time') {
      this.jobPostForm.get('duration').disable();
      this.jobPostForm.get('durationType').disable();
      this.updateControl({ value: 'duration', form: this.jobPostForm }, "CLEAR");
      this.updateControl({ value: 'durationType', form: this.jobPostForm }, "CLEAR");
    } else {
      this.updateControl({ value: 'duration', form: this.jobPostForm });
      this.updateControl({ value: 'durationType', form: this.jobPostForm });
      this.jobPostForm.get('duration').enable();
      this.jobPostForm.get('durationType').enable();
      this.jobPostForm.get('durationType').patchValue('Months');
    }
  }
  years2: any = []
  generateYears2() {
    this.years2 = []
    // var max = new Date().getFullYear();
    // var min = max - 80;
    for (var i = 1; i <= 20; i++) {
      this.years2.push(i);
    }
  }
  years: any = []
  Toyears: any = []
  generateYears() {
    this.years = []
    this.Toyears = []
    // var max = new Date().getFullYear();
    // var min = max - 80;
    for (var i = 0; i <= 20; i++) {
      this.years.push(i);
    }
    for (var i = 1; i <= 20; i++) {
      this.Toyears.push(i);
    }
  }
  profileyears: any = []
  generateYearsprofile() {
    var max = new Date().getFullYear();
    var min = max - 80;
    for (var i = min; i <= max; i++) {
      this.profileyears.push(i);
    }
  }
  dateFormat(date: any): string {
    if (date != null) {
      let date1 = new Date(date);
      let date_transform = this.datePipe.transform(date1, 'MM/dd/yyyy')
      return date_transform;
    }
  }
  primarySkillsSelected = [];
  secondarySkillsSelected = [];
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  secondarySkillsList: any = []
  primarySkillsList: any = []
  submit: boolean = false
  widgetload(widgetName: string, count) {
    this.setHighLighter("");
    this.countProvider.clearBenefits();
    let dataPass: any = {};
    if (widgetName == "JobInviteComponent") {
      dataPass.menu = "Job Invites Received";
    } else if (widgetName == "ResumeRequestComponent") {
      dataPass.menu = "Resume Requests Received";
    } else if (widgetName == "CandidateInviteComponent") {
      dataPass.menu = "Job Applicants";
    } else if (widgetName == "SuggestedJobComponent") {
      dataPass.menu = "Marketplace Jobs";
    } else if (widgetName == "SuggestedCandidateComponent") {
      dataPass.menu = "Marketplace Candidates";
    } else if (widgetName == "FeaturedJobsComponent") {
      dataPass.menu = "Featured Jobs";
    } else if (widgetName == "FeaturedCandidateComponent") {
      dataPass.menu = "Featured Candidates";
    }
    else if (widgetName === "ResumeRequestSentComponent") {
      dataPass.menu = "Resume Requests Sent"
    } else if (widgetName === "JobInviteSentComponent") {
      dataPass.menu = "Job Invites Sent"
    } else if (widgetName === "JobsAppliedByTheUserComponent") {
      dataPass.menu = "Jobs Applied"
    }
    dataPass.master = "HEADER_WIDGETS";
    dataPass.masterMenu = "HEADER_WIDGETS";
    dataPass.widgetName = widgetName;
    dataPass.count = count;

    this.router.navigate(['/suggestions'], { queryParams: dataPass, onSameUrlNavigation: "reload" });

  }
  isSelected(id: number): boolean {
    return this.gigsumoService.isSelected(id, this.selectedNetworks);
  }


  onCheckboxChange(networkId: number, checked: boolean, form: FormGroup): void {
    if (checked) {
      if (!this.selectedNetworks.includes(networkId)) {
        this.selectedNetworks.push(networkId);
      }
    } else {
      this.selectedNetworks = this.selectedNetworks.filter(id => id !== networkId);
    }
    form.get('selectedNetworks').setValue(this.selectedNetworks);
  }

  // Prevent Free plan users and Job Seekers from unchecking Marketplace
  // Also re-add any org-locked networks if the user removed them
  onNetworkSelectionChange(form: FormGroup): void {
    // Strip any disabled networks the user may have somehow selected
    if (this.disabledNetworkTypes.size > 0) {
      const filtered = this.selectedNetworks.filter(n => {
        const net = this.networkGroups.find(g => String(g.id) === String(n));
        return !this.isNetworkDisabledByPermission(net);
      });
      if (filtered.length !== this.selectedNetworks.length) {
        this.selectedNetworks = filtered;
        form.get('selectedNetworks').setValue(this.selectedNetworks);
      }
    }
    if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
      const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
      if (!hasMarketplace) {
        this.selectedNetworks = ['1', ...this.selectedNetworks];
        form.get('selectedNetworks').setValue(this.selectedNetworks);
      }
    }
    if (this.lockedNetworkIds.size > 0) {
      let changed = false;
      this.lockedNetworkIds.forEach(lockedId => {
        if (!this.selectedNetworks.some(n => String(n) === lockedId)) {
          this.selectedNetworks = [...this.selectedNetworks, lockedId];
          changed = true;
        }
      });
      if (changed) form.get('selectedNetworks').setValue(this.selectedNetworks);
    }
  }

  selectedNetworks: any[] = [];
  networkGroups: any[] = [];
  networks: any[] = [];
  lockedNetworkIds: Set<string> = new Set();
  disabledNetworkTypes: Set<string> = new Set();

  isNetworkLocked(networkId: any): boolean {
    return this.lockedNetworkIds.has(String(networkId));
  }

  isNetworkDisabledByPermission(network: any): boolean {
    if (!network) return false;
    if (network.id === '1') return this.disabledNetworkTypes.has('Marketplace');
    return this.disabledNetworkTypes.has(network.type);
  }
  groupedNetworks: any = {};
  getListValues(param) {
    this.clientTypeList = []
    this.jobPostedBehalfOflist = []
    this.payTypeList = []
    this.secondarySkillsList = []
    this.primarySkillsList = []
    this.periodList = []
    this.recruiterTitleList = []
    this.totalExperienceList = []
    this.workAuthorizationList = []
    this.durationTypeList = []
    this.engagementTypeList = []
    this.util.startLoader()
    var data: any = { "domain": "ENGAGEMENT_TYPE,JOB_ENGAGEMENT_TYPES,CLIENT_TYPE,JOB_CLIENT_TYPES,PAY_TYPE,DURATION,PRIMARY_SKILLS,WORK_AUTHORIZATION,CANDIDATE_AVAILABLITY,TOTAL_EXPERIENCE,SECONDARY_SKILLS,GIGSUMO_SKILLS_LIST,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST" }
    if (param == 'JOBS') {
      data.type = 'JOB';
    } else if (param == 'CANDIDATE') {
      data.type = 'CANDIDATE';
    }
    data.userId = localStorage.getItem("userId");
    this.API.create('listvalue/findbyList', data).subscribe(res => {
      if (res.code == '00000') {
        const data = res.data;
        //getting publish to networks in list values by monisha
        const businessNetworks = data.businessNetworks ? data.businessNetworks.map((network: any) => ({
          id: network.b2bNetworkId,
          name: network.b2bNetworkName,
          type: 'Business Networks'
        })) : [];

        const memberNetworks = data.memberNetworks ? data.memberNetworks.map((network: any) => ({
          id: network.businessNetworkId,
          name: network.businessNetworkName,
          type: 'Member Networks'
        })) : [];

        const personalNetworks = data.personalNetworks ? data.personalNetworks.map((network: any) => ({
          id: network.networkId,
          name: network.networkName,
          type: 'Personal Networks'
        })) : [];
        const allNetworks = [...businessNetworks, ...memberNetworks, ...personalNetworks];

        this.networks = allNetworks;
        // Group networks by type
        this.groupedNetworks = allNetworks.reduce((groups: any, network: any) => {
          const { type } = network;
          if (!groups[type]) {
            groups[type] = [];
          }
          groups[type].push(network);
          return groups;
        }, {});
        this.networkGroups = Object.keys(this.groupedNetworks).reduce((result: any[], type: string) => {
          return result.concat(this.groupedNetworks[type].map((network: any) => ({
            ...network,
            type
          })));
        }, []);
        // Add Marketplace at the top`
        const marketplaceNetwork = {
          id: '1', // Assign a unique ID
          name: 'Marketplace',
          type: 'Marketplace'
        };
        this.networkGroups = [marketplaceNetwork, ...this.networkGroups];

        // Pre-select Marketplace for Free plan users and Job Seekers
        if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
          const hasMarketplace = this.selectedNetworks.some(id => id === '1' || id === 1);
          if (!hasMarketplace) {
            this.selectedNetworks = ['1', ...this.selectedNetworks];
          }
        }

        // Apply org-level publish settings (pre-select + lock networks, permissions)
        const myBusinessId = localStorage.getItem('myBusinessId');
        if (myBusinessId) {
          this.API.query(`business/getNetworkPermissions?businessId=${myBusinessId}`).subscribe({
            next: (settingsRes: any) => {
              const schedule: any[] = settingsRes?.data?.publishSchedule || [];
              const day1Step = schedule.find((s: any) => s.day === 1);
              const defaultNetworkIds: string[] = day1Step
                ? [
                    ...((day1Step.b2bNetworkIds as string[]) || []),
                    ...((day1Step.personalNetworkIds as string[]) || []),
                    ...((day1Step.memberNetworkIds as string[]) || []),
                    ...(day1Step.marketplace ? ['1'] : [])
                  ]
                : [];
              this.lockedNetworkIds.clear();
              if (defaultNetworkIds.length > 0) {
                defaultNetworkIds.forEach((networkId: string) => {
                  const id = String(networkId);
                  if (!this.selectedNetworks.some(n => String(n) === id)) {
                    this.selectedNetworks = [...this.selectedNetworks, id];
                  }
                  this.lockedNetworkIds.add(id);
                });
              }
              // Apply network category permissions
              const perms = settingsRes?.data?.networkPermissions;
              this.disabledNetworkTypes.clear();
              if (perms) {
                if (perms.personalNetworks === false) this.disabledNetworkTypes.add('Personal Networks');
                if (perms.memberNetworks === false) this.disabledNetworkTypes.add('Member Networks');
                if (perms.b2bNetworks === false) this.disabledNetworkTypes.add('Business Networks');
                if (perms.marketplace === false) this.disabledNetworkTypes.add('Marketplace');
              }
              // Mark network groups with disabled flag
              this.networkGroups = this.networkGroups.map(n => ({
                ...n,
                disabled: this.isNetworkDisabledByPermission(n)
              }));
            },
            error: () => {}
          });
        }

        this.jobId = res.data.jobId;
        if (param != 'CANDIDATE') {
          this.jobPostForm.patchValue({ 'jobId': res.data.jobId });
          this.API.query('business/check/orgname/' + this.userId).subscribe(res => {
            if (res.code == '00000' || '10008') {
              if (res.data != null && res.data.organisation != null && res.data.organisation.length != 0) {
                let organisations: Array<any> = res.data.organisation;
                res.data.organisation.forEach(ele => {
                  this.jobPostedBehalfOflist.push({ country: ele.country, orgName: ele.organizationName, state: ele.state, zipCode: ele.zipCode, city: ele.city })
                  if (this.userType == 'FREELANCE_RECRUITER' && organisations.length > 1) {
                    this.jobPostForm.get('jobPostedBehalfOf').enable()
                    this.addCurrentOrgValidation();
                  } else if (this.userType == 'FREELANCE_RECRUITER' && organisations.length == 1) {
                    this.jobPostForm.get('jobPostedBehalfOf').patchValue(ele.organizationName);
                    this.jobPostForm.get('jobPostedBehalfOf').disable();
                    this.addCurrentOrgValidation();
                  } else {
                    this.jobPostForm.get('jobPostedBehalfOf').patchValue(ele.organizationName);
                    this.jobPostForm.get('jobPostedBehalfOf').disable()
                    if (this.userType == 'FREELANCE_RECRUITER') {
                      this.removeCurrentOrgValidation();
                    }
                  }
                })
              } else if (res.code == '10002') {
                if (this.userType == 'FREELANCE_RECRUITER') {
                  this.removeCurrentOrgValidation();
                }
                this.jobPostForm.get('jobPostedBehalfOf').disable()
              }
            } else if (res.code == '10002') {
              if (this.userType == 'FREELANCE_RECRUITER') {
                this.removeCurrentOrgValidation();
              }
              this.jobPostForm.get('jobPostedBehalfOf').disable()
            }
          });
        }
        if (param === 'CANDIDATE') {
          this.candidatePostForm.patchValue({ 'candidateId': res.data.candidateId });
          this.usStatesList = []
          this.API.query("country/getAllStates?countryCode=US")
            .subscribe((res) => {
              if (res) {
                res.forEach(ele => {
                  this.usStatesList.push(ele.stateName)
                  this.otherStatesList.push(ele.stateName)
                })
              }
            }, err => {
              this.util.stopLoader();
            });
        }
        if (param === 'CANDIDATE') {
          res.data.CLIENT_TYPE.listItems.forEach(ele => {
            this.clientTypeList.push(ele.item);
            var mySet = new Set(this.clientTypeList);
            this.clientTypeList = [...mySet]
          })
        } else if (param === 'JOBS') {
          res.data.JOB_CLIENT_TYPES.listItems.forEach(ele => {
            this.clientTypeList.push(ele.item);
            var mySet = new Set(this.clientTypeList);
            this.clientTypeList = [...mySet]
          })
        }

        res.data.PAY_TYPE.listItems.forEach(ele => {
          this.payTypeList.push(ele.item)
          var mySet = new Set(this.payTypeList);
          this.payTypeList = [...mySet]
        })
        res.data.SECONDARY_SKILLS.listItems.forEach(ele => {
          if (ele.item) {
            this.secondarySkillsList.push(ele.item)
            var mySet = new Set(this.secondarySkillsList);
            this.secondarySkillsList = [...mySet]
          }
        })
        res.data.PRIMARY_SKILLS.listItems.forEach(ele => {
          if (ele.item) {
            this.primarySkillsList.push(ele.item)
            var mySet = new Set(this.primarySkillsList);
            this.primarySkillsList = [...mySet]
          }
        })
        res.data.CANDIDATE_AVAILABLITY.listItems.forEach(ele => {
          this.periodList.push(ele.item)
          var mySet = new Set(this.periodList);
          this.periodList = [...mySet]
        })
        res.data.TOTAL_EXPERIENCE.listItems.forEach(ele => {
          this.totalExperienceList.push(ele.item)
          var mySet = new Set(this.totalExperienceList);
          this.totalExperienceList = [...mySet]
        })
        if (param === 'JOBS') {
          res.data.JOB_ENGAGEMENT_TYPES.listItems.forEach(ele => {
            this.engagementTypeList.push(ele.item)
            var mySet = new Set(this.engagementTypeList);
            this.engagementTypeList = [...mySet]
          })
        } else if (param === 'CANDIDATE') {
          res.data.ENGAGEMENT_TYPE.listItems.forEach(ele => {
            this.engagementTypeList.push(ele.item)
            var mySet = new Set(this.engagementTypeList);
            this.engagementTypeList = [...mySet]
          })
        }
        res.data.DURATION.listItems.forEach(ele => {
          this.durationTypeList.push(ele.item)
          var mySet = new Set(this.durationTypeList);
          this.durationTypeList = [...mySet]
        })
        res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
          this.candidateJobTitleList.push(ele.item)
          var mySet = new Set(this.candidateJobTitleList);
          this.candidateJobTitleList = [...mySet]
        })
        res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
          this.recruiterTitleList.push(ele.item)
        })
        setTimeout(() => {
          if (param == 'CANDIDATE') {
            this.util.stopLoader()
            this.commonVariables.jobPostingFlag = false
            this.commonVariables.candidatePostingFlag = true
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.educationFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          } else if (param == 'JOBS') {
            this.util.stopLoader()
            this.commonVariables.jobPostingFlag = true
            this.commonVariables.candidatePostingFlag = false
            this.commonVariables.workExperienceFlag = false
            this.commonVariables.educationFlag = false
            this.searchData.setCommonVariables(this.commonVariables)
          }
        }, 2000);
      }
    })
  }
  onChangePeriod(value) {
  }
  jobformreset() {
    this.submit = false;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: 'Are you sure ?',
      text: " All data will be lost",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.jobPostForm.reset({ jobId: this.jobPostForm.get('jobId').value, jobPostedBehalfOf: this.jobPostForm.get('jobPostedBehalfOf').value, durationType: 'Months' })
        this.jobPostForm.get('city').enable();
        this.jobPostForm.get('country').enable();
        this.jobPostForm.get('state').enable();
        this.jobPostForm.get('zipCode').enable();
        this.jobPostForm.get('clientType').enable();
        this.jobPostForm.get('duration').enable();
        this.jobPostForm.get('durationType').enable();
        this.updateControl({ value: 'duration', form: this.jobPostForm });
        this.updateControl({ value: 'durationType', form: this.jobPostForm });
        localStorage.removeItem(this.userid + "_landingPagejobPostForm");

        // For Free plan users, preserve Marketplace selection
        if (this.membershipType === 'Free') {
          this.selectedNetworks = ['1'];
          this.jobPostForm.get('selectedNetworks').setValue(this.selectedNetworks);
        } else {
          this.selectedNetworks = [];
        }

        // Reset JD parsing state
        this.jdParsingService.isJdParsing = false;
        this.jdParsingService.jdParseSuccess = false;
        this.jdParsingService.jdParseFailed = false;
      }
    })
  }
  candidateformreset() {
    this.candidateSubmit = false;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: 'Are you sure ?',
      text: " All data will be lost.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        this.candidatePostForm.reset({
          candidateId: this.candidatePostForm.get('candidateId').value
        });
        this.candidatePostForm.get('workAuthorization').disable();
        this.workAuthorizationList = []

        // Resume upload / parsing teardown. Clear previously only reset the reactive form,
        // so the uploaded resume chip, the "parsed successfully" state, a running progress
        // bar and an in-flight parse response all survived (and could refill the form).
        if (this.resumeParseSubscription) {
          this.resumeParseSubscription.unsubscribe();
          this.resumeParseSubscription = null;
        }
        if (this.progressSimulationInterval) {
          clearInterval(this.progressSimulationInterval);
          this.progressSimulationInterval = null;
        }
        this.isUploading = false;
        this.uploadProgress = 0;
        this.parseRetryCount = 0;
        this.isParsing = false;
        this.removeFiles();

        // ng-select mirrors bound with [(ngModel)] next to formControlName
        this.primarySkillsSelected = [];
        this.secondarySkillsSelected = [];
        this.otherSelectedStates = [];
        this.selectedJobTitle = null;

        // Candidate photo
        this.fileshow = undefined;
        this.photoId = null;
        if (this.myFileInputcandidate?.nativeElement) {
          this.myFileInputcandidate.nativeElement.value = null;
        }

        setTimeout(() => {
          if (this.userType === 'JOB_SEEKER') {
            this.candidatePostForm.patchValue({
              email: this.primaryEmail,
              firstName: this.firstName,
              lastName: this.lastName,

            })
            this.candidatePostForm.get('email').disable()
            this.candidatePostForm.get('firstName').disable()
            this.candidatePostForm.get('lastName').disable();
          }
          localStorage.removeItem(this.userid + "_landingPagecandidatePostForm");

          // For Free plan users and JOB_SEEKER, preserve Marketplace selection
          if (this.membershipType === 'Free' || this.userType === 'JOB_SEEKER') {
            this.selectedNetworks = ['1'];
            this.candidatePostForm.get('selectedNetworks').setValue(this.selectedNetworks);
          } else {
            this.selectedNetworks = [];
          }
        }, 500);
      }
    })
  }
  getInitials(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  getColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  getInitialsfullname(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }
  getColorfullname(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  formfield() {
    let location: Location;
    if (this.userdatacandidate != null) {
      this.userdatacandidate.forEach(ele => {
        if (ele.currentOrganization == true) {
          location = {
            country: ele.country, city: ele.city, state: this.toTitleCase(ele.state), zipCode: ele.zipcode
          };
        }
      })
    }
    this.candidatePostForm = new AppSettings().getCreateCandidateForm(location);
  }
  onChangeCountry_timezone(event) {
    this.countryChosen = event;
    this.timeZonecountryvalues(this.countryChosen);
  }
  workflag: boolean = false;
  onChangeCountry(event, param) {
    this.countryChosen = event;
    if (this.candidatePostForm == undefined) {
      this.formfield();
      setTimeout(() => {
        this.candidatePostForm.get('workAuthorization').enable();
      }, 1500);
    }
    if (param == 'jobs') {
      this.jobPostForm.get('city').patchValue(null)
      this.jobPostForm.get('state').patchValue(null)
      this.jobPostForm.get('zipCode').patchValue(null)
    }
    if (param == 'candidates') {
      this.candidatePostForm.get('city').patchValue(null)
      this.candidatePostForm.get('state').patchValue(null)
      this.candidatePostForm.get('zipCode').patchValue(null)
    }
    this.timeZonecountryvalues(this.countryChosen);
    if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Hourly') {
      this.figureLength = 2
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Daily') {
      this.figureLength = 3
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Monthly') {
      this.figureLength = 6
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Weekly') {
      this.figureLength = 5
    } else if ((this.countryChosen == 'US' || this.countryChosen == 'AU' || this.countryChosen == 'CA') && this.payType == 'Yearly') {
      this.figureLength = 8
    } else if (this.countryChosen == 'IN' && this.payType == 'Hourly') {
      this.figureLength = 4
    } else if (this.countryChosen == 'IN' && this.payType == 'Daily') {
      this.figureLength = 5
    } else if (this.countryChosen == 'IN' && this.payType == 'Monthly') {
      this.figureLength = 7
    } else if (this.countryChosen == 'IN' && this.payType == 'Weekly') {
      this.figureLength = 6
    } else if (this.countryChosen == 'IN' && this.payType == 'Yearly') {
      this.figureLength = 8
    }
    if (event == "US" && this.candidatePostForm != undefined) {
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.selectedCountries = true
      const countryCode = event;
      this.workAuthorizationList = []
      this.API.query('listvalue/find?domain=WORK_AUTHORIZATION_US').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });
          this.API
            .query("country/getAllStates?countryCode=" + countryCode)
            .subscribe((res) => {
              this.usStatesList = [];
              res.forEach(ele => {
                this.usStatesList.push(ele.stateName);
              })
            }, err => {
              this.util.stopLoader();
            });
        }
      })
    } else if (event == "AU" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.API.query('listvalue/find?domain=WORK_AUTHORIZATION_AU').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          })
          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListAU.length == 0) {
            this.stateListAU = [];
            this.API
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListAU = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "IN" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.API.query('listvalue/find?domain=WORK_AUTHORIZATION_IN').subscribe(res => {
        if (res.code == '00000') {
          this.workAuthorizationList = [];
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });
          this.selectedCountries = true;
          const countryCode = event;
          if (this.stateListIN.length == 0) {
            this.stateListIN = [];
            this.API
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListIN = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else if (event == "CA" && this.candidatePostForm != undefined) {
      this.workAuthorizationList = [];
      this.candidatePostForm.get('workAuthorization').enable();
      this.candidatePostForm.get('workAuthorization').patchValue(null)
      this.candidatePostForm.get('workAuthorization').setValidators([Validators.required])
      this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
      this.API.query('listvalue/find?domain=WORK_AUTHORIZATION_CA').subscribe(res => {
        if (res.code == '00000') {
          res.data.listValues[0].listItems.forEach(ele => {
            this.workAuthorizationList.push(ele.item)
            var mySet = new Set(this.workAuthorizationList);
            this.workAuthorizationList = [...mySet]
          });
          this.selectedCountries = true
          const countryCode = event;
          if (this.stateListCA.length == 0) {
            this.API
              .query("country/getAllStates?countryCode=" + countryCode)
              .subscribe((res) => {
                this.stateListCA = res;
              }, err => {
                this.util.stopLoader();
              });
          }
        }
      })
    } else {
      this.selectedCountries = false;
      if (event != null && this.candidatePostForm != undefined) {
        this.workflag = true;
        this.workAuthorizationList = [];
        if (this.countryChosen != 'US' && this.countryChosen != 'AU' && this.countryChosen != 'IN' && this.countryChosen != 'CA') {
          setTimeout(() => {
            this.candidatePostForm.get('workAuthorization').patchValue(null)
            this.candidatePostForm.get('workAuthorization').disable();
            this.candidatePostForm.get('workAuthorization').clearValidators();
            this.candidatePostForm.get('workAuthorization').updateValueAndValidity();
          }, 2000);
        }
      }
    }
    if (this.typeTargetValue != null) {
      this.onTargetRateTyped(this.typeTargetValue, param)
    }
  }
  onTargetRateTyped(value, param) {
    this.typeTargetValue = value
  }
  commonVariables: any = {};
  digitKeyOnly(e) {
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    if ((keyCode >= 37 && keyCode <= 40) || (keyCode == 8 || keyCode == 9 || keyCode == 13) || (keyCode >= 48 && keyCode <= 57)) {
      return true;
    }
    return false;
  }
  searchSubject = new Subject<String>();
  orgNameSubject = new Subject<String>();
  patchEmail(value) {
    this.candidatePostForm.patchValue({
      candidateEmailId: this.candidatePostForm.get('email').value
    })
    if (localStorage.getItem("userType") != "JOB_SEEKER") {
      this.emailidcehck(value);
    }
  }
  emailidcehck(id) {
    this.API.query("user/checkMailAlreadyExists/" + id).subscribe((res) => {
      if (res.data != null && res.data.exists) {
        if (res.data.exists) {
          this.candidatePostForm.get('email').setErrors({ existingEmailAddress: true });
          this.candidatePostForm.get('candidateEmailId').patchValue(null);
        }
      } else {
        this.candidatePostForm.get('email').setErrors({ existingEmailAddress: null })
        this.candidatePostForm.get('email').updateValueAndValidity({ emitEvent: false })
      }
    })
  }
  enableScroll(): void {
    this.isScrollEnabled = true;
    this.toggleBodyOverflow(true);
  }
  disableScroll(): void {
    this.isScrollEnabled = false;
    this.toggleBodyOverflow(false);
  }
  toggleBodyOverflow(isEnabled: boolean) {
    const body = document.body;
    if (isEnabled) {
      body.style.overflow = 'visible';
    } else {
      body.style.overflow = 'hidden'
    }
  }
  modalRef2: BsModalRef | null;
  fileChangeEvent(event, popupName): void {
    const checkSize = super.checkImageSize(event.target.files[0]);
    this.imageChangedEvent = event;
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (checkSize > 10) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      this.myFileInputcandidate.nativeElement.value = null;
    }
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInputcandidate.nativeElement.value;
      const numberOfFiles = event.target.files.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileshow = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }
    if (!acceptedImageTypes.includes(event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInputcandidate.nativeElement.value = "";
      this.modalRef.hide();
    }
    else {
      this.PopupServicevlaues(popupName);
    }
  }
  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }
  uploadPhotoHere() {
    this.myFileInputcandidate.nativeElement.click();
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  croppedImage: any = "";
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });
    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }
  closePhoto2() {
    this.modalRef2.hide();
    this.photo = null;
    this.fileshow = undefined;
    this.myFileInputcandidate.nativeElement.value = null;
    this.photoIdnew = null;
  }
  img4: any = {};
  imageLoaded2() {
    this.util.startLoader();
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    // setTimeout(() => {
    this.API.create("upload/image", formData).subscribe((res) => {
      this.util.stopLoader();
      if (res) {
        this.photoIdnew = res.fileId;
        this.modalRef2.hide();
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  /**
   * TEST METHOD - Call from browser console to test toaster
   * Usage: window['testToaster']()
   */
  testToaster() {
    this.toasterService.success('Test Success', 'This is a test success notification');
    this.toasterService.info('Test Info', 'This is a test info notification');
    this.toasterService.warning('Test Warning', 'This is a test warning notification');
    this.toasterService.error('Test Error', 'This is a test error notification');
  }

  /** How many recent notifications to look at on each stream ping. Must not
   *  exceed the seedNotificationBaseline() limit (20), so nothing older than the
   *  baseline window can ever come back as "unseen". */
  private readonly NOTIF_TOAST_LOOKBACK = 20;

  /** notifyTime (server epoch ms) of the newest notification that already existed
   *  when this session's baseline was taken. Anything at or before it — e.g. the
   *  notifications received while the user was logged out — is never toasted. */
  private notifToastCutoff = 0;

  /** Server notifyTime as epoch ms; 0 when missing or unparseable. */
  private notifyTimeMs(n: any): number {
    const t = n?.notifyTime != null ? new Date(n.notifyTime).getTime() : 0;
    return isNaN(t) ? 0 : t;
  }

  /** Mark every record as already seen and move the cutoff up to the newest one. */
  private recordNotificationBaseline(notifications: any[]): void {
    notifications.forEach((n: any) => {
      if (n?.notifyId) {
        this.shownNotifyIds.add(n.notifyId);
      }
      this.notifToastCutoff = Math.max(this.notifToastCutoff, this.notifyTimeMs(n));
    });
  }

  /**
   * Take the "everything that already existed" snapshot, once per session.
   * Every notifyId returned here is marked as seen, so nothing historical can
   * ever be toasted. Until this lands, no notification toaster is allowed.
   */
  private seedNotificationBaseline(): void {
    const userId = this.userId || localStorage.getItem('userId');
    if (!userId) {
      // No user yet: leave the gate closed rather than risk replaying history.
      return;
    }

    this.API.create('notification/find', {
      userId,
      limit: 20,
      searchAfterKey: null
    }).subscribe({
      next: (res) => {
        const notifications = res?.data?.notifications;
        // Open the gate only on a real snapshot. The API answers HTTP 200 with
        // code 99999 when it fails internally; opening the gate then (empty
        // ledger) let the first ping toast every notification received while the
        // user was logged out. Left closed, the first ping becomes the baseline.
        if (res?.code === '00000' && Array.isArray(notifications)) {
          this.recordNotificationBaseline(notifications);
          this.notifBaselineReady = true;
        }
      },
      error: () => {
        // Baseline unavailable — stay closed. A missing toaster is far better
        // than replaying the user's whole notification history at login, and the
        // next stream ping re-seeds from its own response (see below).
        this.notifBaselineReady = false;
      }
    });
  }

  /**
   * Fetch the most recent notifications and toast only the ones this session has
   * not shown yet, identified by notifyId.
   */
  fetchAndShowLatestNotification(): void {
    // A destroyed nav-bar owns a stale ledger (e.g. from before logout); it must
    // never toast. The live instance handles every notification on its own.
    if (this.destroyed) {
      return;
    }
    // The account logged in right now. `this.userId` is captured once when the
    // nav-bar starts, so after an account switch in the same browser it could
    // fetch — and toast — another user's notifications.
    const currentUserId = localStorage.getItem('userId');
    if (!currentUserId) {
      return;
    }
    const params = {
      userId: currentUserId,
      limit: this.NOTIF_TOAST_LOOKBACK,
      searchAfterKey: null
    };

    this.API.create('notification/find', params).subscribe({
      next: (res) => {
        if (this.destroyed) {
          return;
        }
        if (res.code === '00000' && res.data && res.data.notifications) {
          const notifications: any[] = res.data.notifications;

          // No baseline yet — the seed call failed or has not come back. Use this
          // response as the baseline and show nothing, so a missed seed costs one
          // toaster instead of replaying the user's history.
          if (!this.notifBaselineReady) {
            this.recordNotificationBaseline(notifications);
            this.notifBaselineReady = true;
            return;
          }

          // Unseen only. Records without a notifyId can't be tracked, so they are
          // skipped rather than shown on every ping. A record owned by a different
          // userId is never toasted: it has no matching entry on this user's
          // notifications page. Only notifications newer than the login baseline
          // are toasted, so ones received while logged out stay silent.
          const unseen = notifications.filter(
            (n: any) => n?.notifyId && !this.shownNotifyIds.has(n.notifyId)
              && (!n.userId || n.userId === currentUserId)
              && this.notifyTimeMs(n) > this.notifToastCutoff
          );

          // One toaster per new notification of this user — e.g. the burst of AI
          // suggestion notifications created right after login. The API returns
          // newest first; show oldest-first so a burst reads in arrival order.
          // Marking each id seen here keeps later pings from repeating it.
          unseen
            .slice()
            .reverse()
            .forEach((notification: any, index: number) => {
              this.shownNotifyIds.add(notification.notifyId);
              setTimeout(() => {
                if (!this.destroyed) {
                  this.showNotificationToaster(notification);
                }
              }, index * 300); // Stagger toaster appearance
            });
        }
      },
      error: (err) => {
        console.error('Error fetching notifications:', err);
      }
    });
  }

  /**
   * Show notification toaster with proper formatting
   */
  private showNotificationToaster(notification: any): void {

    // Extract notification details
    const notifyType = notification.notifyType || '';

    // If employee request was accepted, refresh business data to update bento menu.
    // Runs before the page-text check below so it still happens when no toast is shown.
    if (notifyType === 'BUSINESS_EMPLOYEE_REQUEST_ACCEPTED') {
      this.refreshBusinessData();
    }

    // The toast message is the notification's message on the Notifications page,
    // word for word. A notification with no message there gets no toast; it is
    // already marked seen, so it is not retried on the next stream ping.
    const messageText = this.notifMessageText.textOf(notification);
    if (!messageText) {
      return;
    }

    // Title (and colour/icon data) come from the toaster formatter, per notifyType.
    const content = this.notifContent.format(notification);
    const title = content.title;

    // Colour and icon come from the formatter, per notifyType. The substring
    // tests that used to live here gave CONTRACT_AGREEMENT_SIGNING_REQUESTED a
    // user-plus icon (its name contains "REQUEST"). The icon is a registered
    // @ng-icons Tabler name (see icon-provider.ts).
    const type = content.severity;
    const icon = content.icon;

    // Show toaster with click action to navigate to notifications page
    this.toasterService.show({
      type,
      title,
      message: messageText,
      icon,
      duration: 7000,
      clickAction: () => {
        // Modals are attached to <body>, outside the router outlet, so they
        // survive the navigation below unless closed here.
        this.closeOpenModals();
        // router.navigate() to the same URL is a no-op, so a click while
        // already on the notifications page would otherwise do nothing.
        if (this.router.url.split('?')[0] === '/notification') {
          this.searchData.triggerNotificationsRefresh();
        } else {
          this.router.navigate(['/notification']);
        }
      },
      notificationData: notification
    });
  }

  /** Close every open ngx-bootstrap, NgbModal and SweetAlert popup. */
  private closeOpenModals(): void {
    for (let i = this.modalService.getModalsCount(); i >= 1; i--) {
      this.modalService.hide(i);
    }
    this.ngbModal.dismissAll();
    if (Swal.isVisible()) {
      Swal.close();
    }
  }

  ngOnDestroy(): void {
    this.callNotification = false;
    this.callUnreadMsg = false;

    // Cleanup all subscriptions using destroy$ subject
    this.destroy$.next();
    this.destroy$.complete();

    this.destroyed = true;
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    if (this.searchBoxResizeObserver) {
      this.searchBoxResizeObserver.disconnect();
    }

  }
  sortConfigWork: TypeaheadOrder = {
    direction: "desc",
    field: "organisationName",
  };
  noResult: boolean = false
  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
    this.jobPostForm.patchValue({
      organisationId: null
    })
  }
  onKeyZip(event: any, param, index) {
    let data: any = {};
    data.countryCode = "US";
    data.zipCode = event.target.value;
    data.stateCode = "";
    if (data.zipCode.length === 5) {
      this.API.create("country/geodetails", data).subscribe((res) => {
        if (
          res &&
          res != null &&
          res != "" &&
          res.length > 0 &&
          event.target.value != ""
        ) {
          res.forEach((ele) => {
            let cityName = ele.cityName;
            let stateName = ele.stateName;
            if (param == 'job') {
              this.jobPostForm.patchValue({
                city: cityName,
                state: stateName,
              });
            } else if (param == 'candidate') {
              this.candidatePostForm.patchValue({
                city: cityName,
                state: stateName,
              });
            } else if (param == 'work') {
              this.workExperience.controls[0].patchValue({
                city: cityName,
                state: stateName,
              });
            }
          });
        }
      });
    } else if (data.zipCode.length < 5 || data.zipCode.length > 5) {
    }
  }
  autoComplete1: MatAutocompleteTrigger;
  searchBarShow1: boolean = false
  uniqueOrgList: Array<Partial<HealthCareOrganization>> = [];
  getOrgList(value) {
    if (value != null) {
      const orgList: Array<Partial<HealthCareOrganization>> = [];
      this.API.query("care/organizations?organizationName=" + this.workExperience.value[0].organisationName)
        .pipe(debounceTime(500))
        .subscribe((res) => {
          if (res) {
            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.zipCode = ele.zipCode;
              obj.address1 = ele.address1;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList.push(obj);
            })
            const uniqueList = new Set(orgList);
            this.uniqueOrgList = Array.from(uniqueList);
          }
        }, err => {
          this.util.stopLoader();
        });
      this.searchBarShow1 = true;
    } else {
      this.searchBarShow1 = false
    }
  }
  closeModal_credit() {
    this.gigsumoService.buttonClicked = true;
    this.modalRef.hide();
  }
  otherSelectedStates: any = []

  onOtherPreferedChange(event: any) {
    if (!event.target.checked) {
      this.otherSelectedStates = [];
      this.candidatePostForm.get('otherPreferedStates').setValue([]);
    }
  }

  closeModal() {
    this.gigsumoService.buttonClicked = true;
    this.primarySkillsSelected = [];
    this.secondarySkillsSelected = [];
    this.primarySkillsList = []
    this.secondarySkillsList = []
    this.otherSelectedStates = []
    this.modalRef.hide();
    // this.cancelJob()
    this.otpEmailSent = false
    this.domainValidatorSubmit = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.emailDomainValidation = false
    this.commonVariables.educationFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.workExperienceFlag = false
    this.submit = false
    this.domainForm.get('domainValidationOtp').patchValue(null)
    this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
    this.domainForm.get('domainValidationOtp').clearValidators()
    this.domainForm.get('domainValidationOtp').updateValueAndValidity()
    this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
    this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
    this.domainForm.get('swapEmail').setErrors({ emailExistsAlready: null })
    this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })

    // Reset JD parsing state
    this.jdParsingService.isJdParsing = false;
    this.jdParsingService.jdParseSuccess = false;
    this.jdParsingService.jdParseFailed = false;
  }
  closeCandidate() {
    this.candidateSubmit = false
    this.primarySkillsSelected = [];
    this.secondarySkillsSelected = [];
    this.otherSelectedStates = []
    this.modalService.hide(1)
    this.cancelcloseCandidate()
    this.otpEmailSent = false
    setTimeout(() => {
      this.commonVariables.candidatePostingFlag = false
    }, 3000);
    this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
    this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
    this.domainForm.get('domainValidationOtp').setErrors({ wrongDomainValidationOtp: null })
    this.domainForm.get('domainValidationOtp').updateValueAndValidity({ emitEvent: false })
    this.domainForm.get('swapEmail').setErrors({ genericDomain: null })
    this.domainForm.get('swapEmail').updateValueAndValidity({ emitEvent: false })
    this.fileshow = undefined;
    this.myFileInputcandidate.nativeElement.value = null;
    this.photoIdnew = null;
  }

  userdetailList: any = {};
  userDetails$: Observable<any>;
  UserName: any = '';
  emailid: any = '';


  getUnreadMessageUserCount(res: any) {
    this.unreadUserMsgCount = res;
  }
  updatepath(imgpath) {
    this.img = imgpath;
  }
  test(flag) {
    this.reloadUser = flag;
  }
  checkUserProfileStatus(): void {
    const userId = localStorage.getItem("userId");
    // this.util.startLoader()
    this.API.query("user/profilestatus/" + userId).subscribe((res) => {
      if (res != undefined && res && res === "PENDING") {
        // this.util.stopLoader()
        const data: any = {};
        data.userId = this.userId;
        this.router.navigate(["userClassification"], { queryParams: data });
      }
    }, err => {
      // this.util.stopLoader();
    });
  }
  c: any;
  d: any;
  getUserHeaderCount(): void {
    const userId = localStorage.getItem("userId");
    const formattedDate = this.gigsumoService.getFormattedCurrentDate();
    this.API.query("user/header/" + userId + "/" + formattedDate).subscribe((res) => {
      if (res) {
        this.notificationDatasshow = res;
        // REST baseline is in place: count-based stream toasters may fire from now on.
        this.headerCountsLoaded = true;
        const countsMapping = {
          'Job Invites Received': 'jobInvitesReceivedCount',
          'Job Applicants': 'jobApplicationsReceivedCount',
          'Resume Requests Received': 'resumeRequestReceivedCount',
          'Featured Candidates': 'totalFeaturedCandidatesCount',
          'Jobs Applied': 'jobsAppliedCount',
          'Featured Jobs': 'totalFeaturedJobsCount',
          'Job Invites Sent': 'jobInvitesSentCount',
          'Marketplace Candidates': 'totalSuggCandidatesCount',
          'Resume Requests Sent': 'resumeRequestedCount',
          'Marketplace Jobs': 'totalsuggJobsCount',
        };
        this.labelToShow.forEach(ele => {
          const propertyName = countsMapping[ele.value];
          if (propertyName && res[propertyName] !== undefined) {
            ele.count = res[propertyName];
          }
        });
        this.unreadUserMsgCount = res.message || 0;
        this.notificationcount = res.notification || 0;

        this.jobInvitesReceivedCount = res.jobInvitesReceivedCount || 0;
        this.resumeRequestReceivedCount = res.resumeRequestReceivedCount || 0;
        this.jobApplicationsReceivedCount = res.jobApplicationsReceivedCount || 0;
        // Calculate inbox count if all counts are available
        if (res.jobInvitesReceivedCount !== undefined && res.resumeRequestReceivedCount !== undefined && res.jobApplicationsReceivedCount !== undefined) {
          this.inboxCount = this.jobApplicationsReceivedCount + this.resumeRequestReceivedCount + this.jobInvitesReceivedCount;
        }
        ['newPost', 'candidateNonSeenMessageCount', 'jobNonSeenMessageCount'].forEach(propertyName => {
          if (res[propertyName] !== undefined) {
            this.commonValues.setloadData(res.newPost);
            this.commonValues.setMsgCount(res.messageBottomChat);
          }
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  getnotificationView(): void {
    const userId = localStorage.getItem("userId");
    // this.util.startLoader()
    var value: any = {}
    value.userId = this.userId
    value.offset = null
    value.limit = 10
    this.API.create("notification/query", value).subscribe((res) => {
      if (res != undefined && res) {
        // this.util.stopLoader()
        this.getNotification(res.data['notifications']);
      }
    }, err => {
      // this.util.stopLoader();
    });
  }
  profileStatus() {
    let datas: any = {};
    datas.userId = localStorage.getItem('userId')
    // this.util.startLoader()
    this.API.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(res => {
      if (res != undefined && res) {
        // this.util.stopLoader();
        this.userType = res.userType;

        const workExperience = this.userdetailList.workExperience;
        if (workExperience && workExperience.length > 0) {
          const currentExperience = workExperience.find(ele => ele.currentOrganization);
          if (currentExperience) {
            this.userdetailList.organisation = currentExperience.organisationName;
          }
        }
      }
    }, err => {
      // this.util.stopLoader();
    });
  }


  ngAfterViewInit(): void {
    this.userId = localStorage.getItem("userId");
    this.intervalId = setInterval(() => {
      if (this.destroyed) {
        clearInterval(this.intervalId);
        return;
      }
      if (this.userId) {
        this.manageSocketConnections();
      }
    }, 10000);

    this.userService.onlineAPI('ONLINE');
    this.getUserHeaderCount();
    this.userProfileUpdate();
    this.watchGlobalSearchBoxShift();
  }

  @ViewChild('trigger') globalSearchTrigger: MatAutocompleteTrigger;
  @ViewChild('mytest') globalSearchInput: ElementRef<HTMLInputElement>;
  private searchBoxResizeObserver: ResizeObserver | undefined;

  // The header's View button and avatar render once user data arrives, which
  // shifts the search box sideways. If the dropdown is already open at that
  // moment the overlay keeps its old anchor and sits beside the box. Watch the
  // box's size and re-anchor the open panel whenever the header settles. No
  // visual change: the panel simply follows the box it belongs to.
  private watchGlobalSearchBoxShift() {
    const input = this.globalSearchInput?.nativeElement;
    if (!input || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.searchBoxResizeObserver = new ResizeObserver(() => {
      if (this.globalSearchTrigger?.panelOpen) {
        this.globalSearchTrigger.updatePosition();
      }
    });
    this.searchBoxResizeObserver.observe(input);
    const form = input.closest('form');
    if (form) {
      this.searchBoxResizeObserver.observe(form);
    }
  }


  private handleVisibilityChange() {

    const messageResponse = this.Socketserver.reloadconnection();



    if (document.visibilityState === 'hidden' && messageResponse.connected != undefined && !messageResponse.connected) {
      // console.log("Screen not Visible");
      this.Socketserver.disconnectAllClients();
      this.StreamSocket.disconnectAllClients();
    } else if (document.visibilityState === 'visible' && messageResponse.connected != undefined && !messageResponse.connected) {
      // console.log("Screen Visible");
      this.Socketserver.initiateConnection();
      this.StreamSocket.initiateConnection();
      setTimeout(() => {
      }, 3000);

    }

  }




  private manageSocketConnections(): void {
    const messageResponse = this.Socketserver.reloadconnection();
    const streamResponse = this.StreamSocket.reloadconnection();
    setTimeout(() => {
      const topicToCheck = '/topic/streams';
      const isSubscribedStream = this.StreamSocket.getSubscribedTopics().some(topic => topic.startsWith(topicToCheck));
      const isSubscribedServer = this.Socketserver.getSubscribedTopics().some(topic => topic.startsWith(topicToCheck));

      // Stream Topics Reconnect: don't delete
      if (streamResponse.connected && this.StreamSocket.getSubscribedTopics().length === 0 && this.userId) {
        // this.StreamSocket.clearTopices();
        setTimeout(() => {
          this.stremService.startTopic();
        }, 1000);
      } else if (!isSubscribedStream) {
        this.stremService.startTopic();
      }


      // Server Topics Reconnect: don't delete
      if (messageResponse.connected && this.Socketserver.getSubscribedTopics().length === 0 && this.userId) {
        // this.Socketserver.clearTopices();
        setTimeout(() => {
          this.stremService.serverTopicfor_eyenotification();
        }, 1000);
      } else if (!isSubscribedServer) {
        this.stremService.serverTopicfor_eyenotification();
      }
    }, 3000);

  }


  getNotification(val: any): any {
    if (val) {
      this.notificationList = val;
    }
  }
  getCountNotification(val: any): any {
    let c = 0;
    val.forEach((e: any) => {
      if (!e.read) {
        c += 1;
      }
    });
    return c;
  }

  redirect(vlue) {
  }
  instantiateDependencies() {
    this.formserchData();
    this.labelsBasedonUserType(this.userType)
  }
  formserchData() {
    // Seeded from the restored term rather than blank. The form is built later in
    // ngOnInit than restoreGlobalSearch runs, so by this point globalSearchValue
    // already holds whatever search the user was on, and the input renders with it.
    this.serachForm = this.fb.group({
      serachData: [this.globalSearchValue || ""],
    });
  }
  globalSearchValue: any = ''
  photoUrl: string = AppSettings.photoUrl;
  globalSearchSubject = new Subject<string>();

  getSearchText(value: any) {
    this.globalSearchSubject.next(value);
  }

  // Clicking a dropdown result hops through "/" (-> /auth, another layout)
  // before opening the target page, and /business mounts its own user layout.
  // Both rebuild this nav bar, and a fresh instance has no results, so the
  // dropdown lost the previous search. Put the last result back on init.
  private restoreGlobalSearch() {
    const saved = this.globalSearchState.get();
    if (saved) {
      this.globalSearchValue = saved.term;
      // `name` is the ngModel behind the visible input. Restoring only
      // globalSearchValue put the results back in the dropdown but left the box
      // itself blank, which is what made the term look lost after opening a result.
      this.name = saved.term;
      this.userData = saved.users;
      this.bunissData = saved.businesses;
      this.userCount = saved.userCount;
      this.businessCount = saved.businessCount;
      this.searchBarShow = saved.users.length > 0 || saved.businesses.length > 0;
    }
    // Watched in BOTH cases, not just when nothing was saved: it only ever fills an
    // empty box, so it cannot fight the restored value, and it is what keeps the
    // term visible when the listing page changes tabs without rebuilding this bar.
    // The store lives in memory, so a page refresh empties it while
    // the listing page is still open on a search. The term is in the URL, so fall
    // back to that: the box should never be blank while a result page is showing.
    this.followRouteSearchTerm();
  }

  /**
   * Keeps the header box in step with the term in the URL.
   *
   * A one-time snapshot read was not enough. Two cases miss it:
   *  - searchList() hops through "/" before opening the listing page, so a rebuilt
   *    nav bar can run ngOnInit while the router is still on the intermediate URL
   *    and the snapshot carries no searchData yet.
   *  - switching All / People / Business only changes query params, so the nav bar
   *    is NOT rebuilt and ngOnInit never runs again.
   *
   * Subscribing covers both, and query params live on the router state rather than
   * on one route, so this sees them from the nav bar's own position in the tree.
   * Only fills a box that is empty, so it can never overwrite what someone is
   * currently typing.
   */
  private followRouteSearchTerm() {
    this._route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const routeTerm = params ? params['searchData'] : null;
        if (routeTerm && !this.name) {
          this.globalSearchValue = routeTerm;
          this.name = routeTerm;
          if (this.serachForm) {
            this.serachForm.patchValue({ serachData: routeTerm }, { emitEvent: false });
          }
        }
      });
  }

  onChangeSearch(val: string) {
    // A run of spaces is not a search term. Trim before deciding whether to fire,
    // so "   " takes the same branch as an empty box and clears the dropdown
    // instead of querying Elasticsearch for whitespace. The trimmed value is also
    // what gets sent, saved and carried into the listing page, so " james " and
    // "james" are one search rather than two.
    this.globalSearchValue = (this.serachForm.value.serachData ?? '').trim();
    const data = {
      search: this.globalSearchValue,
      searchContent: "ALL",
      loginUserId: localStorage.getItem("userId"),
      page: {
        offSet: 0,
        pageCount: 5,
      },
    };
    if (this.globalSearchValue !== "") {
      this.util.startLoader();
      this.API.create("home/profiles/search", data)
        // .pipe(debounceTime(500))
        .subscribe((res) => {
          this.util.stopLoader();
          this.searchBarShow = true;
          this.globalsearchRes = res;
          if (res != null && res != null) {
            this.dynamicArray = [""];
            this.dynamicdata = res;
            if (res.businessPages != "undefined") {
              this.bunissData = res.businessPages;
              this.businessCount =  res.page?.businessTotalCount ?? 0;
              if (this.dynamicdata.businessPages != null) {
                this.dynamicdata.businessPages.forEach((element) => {
                  if (element.businessLogo != null) {
                    element.businessLogo1 =
                      AppSettings.photoUrl + element.businessLogo;
                  } else {
                    element.businessLogo1 = null;
                  }
                  this.dynamicArray.push(element);
                });
              }
            }
            if (res.users != "undefined") {

              this.userData = res.users || [];
              this.userCount = res.page?.userTotalCount ?? 0;
              this.dynamicdata.users.forEach((element) => {
                if (element.photo != null) {
                  element.userImage = element.photo.startsWith('http') ? element.photo : AppSettings.photoUrl + element.photo;
                } else {
                  element.userImage = null;
                }
                element.UserTitle = "User";
                this.dynamicArray.push(element);
              });
            }
            if (res.communityPages != "undefined") {
              this.CommunityData = res.communityPages;
              this?.dynamicdata?.communityPages?.forEach((element) => {
                if (element.logo != null) {
                  element.logo = AppSettings.photoUrl + element.logo;
                } else {
                  element.logo = null;
                }
                element.firstName = element.communityName;
                this.dynamicArray.push(element);
              });
            }
            // Survives the nav bar being rebuilt on navigation (see restoreGlobalSearch).
            this.globalSearchState.save({
              term: this.globalSearchValue,
              users: this.userData || [],
              businesses: this.bunissData || [],
              userCount: this.userCount,
              businessCount: this.businessCount,
            });
          }
        }, err => {
          this.util.stopLoader();
        });
    } else {
      this.searchBarShow = false;
      this.bunissData = [];
      this.userData = [];
      this.userCount = 0;
      this.businessCount = 0;
      this.globalSearchState.clear();
    }

  }
  onFocused(e) {
  }
  onLogout() {
    var val: any = {}
    val.isLoggedOut = true
    this.searchData.setCommonVariables(val);
    this.util.startLoader();
    this.API.onLogout().subscribe((res) => {
      if (res) {
        if (res.code === "00000") {
          this.businessProvider.setBusiness(null);
          this.util.stopLoader();
          this.gigsumoService.clearCache();
          this.onLogoutSuccess();
          this.userService.onlineAPI('OFFLINE');
        } else {
          this.util.stopLoader();
        }
      }
    });
  }
  onLogoutSuccess() {
    this.cookieservice.deleteAll();
    let allCookies = document.cookie.split(";");
    if (allCookies) {
      for (let i = 0; i < allCookies.length; i++) {
        document.cookie = allCookies[i] + "=;expires=" + new Date(0).toUTCString();
      }
    }
    localStorage.clear();
    this.globalSearchState.clear();
    this.stremService.OnDestroy();
    // The toaster container lives outside the router outlet and keeps rendering
    // whatever it holds across the navigation, so anything still on screen has
    // to be dropped explicitly before we land on the login page.
    this.toasterService.clear();
    this.router.navigate(["/auth/login"]);
  }

  viewMyProfile() {
    var data: any = {}
    data.userId = this.userId
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate(["/personalProfile"], { queryParams: data }));
  }

  gotoBusiness() {
    this.router.navigate(['/landingPage/business']);
  }





  openUserManagement() {
    // Defer pageName change to next tick to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.pageName = "admin";
    });

    const plan = this.userPlanProvider.userPlan;
    console.log(this.userPlanProvider.userPlanDetails, plan);

    // Only for Free plan routing
    if (plan == "Free") {
      const d = this.currentOrgProvider.getCurrentOrg;
      let params = {
        userId: localStorage.getItem('userId'),
        plan: plan,
        businessName: d && d.organisationName,
        businessEmail: localStorage.getItem('userName'),
        bid: this.gigsumono,
      }
      this.router.navigate(['/user-management/plan'], { queryParams: params });
    } else {
      // Only for Business plan routing
      this.router.navigate([`/user-management/plan`]);
    }
  }

  throwAlert() {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: { confirmButton: 'btn btn-primary btn-sm' },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Access Restrictions',
      text: "Currently, admin screens are restricted to business page owners alone. Please, stay tuned for access to all users very soon.",
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true
    })
  }


  goToSecuritySettings() {
    var data: any = {}
    data.userId = this.userId
    data.destination = "securitySettings"
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate(["/personalProfile"], { queryParams: data }));
  }
  businessSelected(val, role) {
    // Term kept, same reasoning as userSelected above.
    if (role == "BUSINESS_PAGE") {
      if (val.businessId != undefined) {
        localStorage.setItem("businessId", val.businessId);
        var data: any = {};
        data.businessId = val.businessId;
        data.businessName = val.businessName;
        data.isEmployee = val.employee;
        data.bannerbusinessEmail = val.businessEmail;
        data.isFollower = val.followed;
        data.isAdmin = val.admin;
        data.isSuperAdmin = val.superAdmin;
        this.searchedpage(val.businessId, "BUSINESS");
        this.setVisitor(data);
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() => this.router.navigate(["/business/post"], { queryParams: data }));
      }
    }
    else if (role == "COMMUNITY_PAGE") {
      let newobj: any = {};
      newobj.communityId = val.communityId
      newobj.userId = localStorage.getItem('userId')
      this.API.create("community/home", newobj).subscribe(res => {
        localStorage.setItem("communityId", val.communityId);
        var data: any = {};
        data.communityId = val.communityId;
        data.communityName = val.communityName;
        data.communityType = val.communityType;
        data.isJoined = res.data.isJoined;
        data.isAdmin = res.data.isAdmin;
        data.isSuperAdmin = res.data.isSuperAdmin;
        this.searchedpage(val.communityId, "COMMUNITY");
        this.router
          .navigateByUrl("/", { skipLocationChange: true })
          .then(() =>
            this.router.navigate(["/community"], { queryParams: data })
          );
      }, err => {
        this.util.stopLoader();
      });
    }
    else if (role == "JOBSSEARCH") {
      if (val.jobPostedBy != this.userId) {
        var profiledata: any = {};
        profiledata.userId = localStorage.getItem('userId')
        profiledata.userType = localStorage.getItem('userType')
        this.util.stopLoader
        let element: any = {}
        let dataview: any = {};
        this.util.stopLoader
        dataview.jobPostedBy = localStorage.getItem('userId');
        dataview.jobId = val.jobId;
        if (val.jobPostedBy != this.userId && val.isViewed == false) {
          this.util.startLoader
          this.API.updatePut("jobs/updateJobViewed", dataview).subscribe((res) => {
            this.util.stopLoader();
          }, err => {
            this.util.stopLoader();
          });
        } else if (val.businessId != null) {
          data.menu = "Jobs"
          this.router.navigate(["/business/post"], { queryParams: data });
        }
      }
      if (val.businessId != null) {
        let dataBusiness: any = {};
        dataBusiness.jobId = val.jobId;
        dataBusiness.businessId = val.businessId;
        dataBusiness.menu = "Jobs"
        this.router.navigate(["/business/post"], { queryParams: dataBusiness });
      }
      else {
        var dataa: any = {};
        dataa.jobId = val.jobId;
        dataa.businessId = val.businessId;
        dataa.userType = val.user.userType
        dataa.userId = val.jobPostedBy
        dataa.menu = "Jobs"
        this.router.navigate(['newjobs'], { queryParams: dataa });
      }
    }
    else if (role == "CANDIDATESEARCH") {
      var data: any = {};
      data.candidateId = val.candidateId;
      data.userId = val.createdBy
      data.userType = val.user.userType
      this.router.navigate(["/newcandidates"], { queryParams: data })
    }
  }
  setVisitor(data) {
    var datum: any = {};
    datum.businessId = data.businessId;
    datum.userId = localStorage.getItem("userId");
    this.util.startLoader()
    this.API.create("business/save/pagevisitor", datum).subscribe((res) => {
      if (res.code == "00000") {
        this.util.stopLoader()
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  userSelected(valUser, pageType) {
    this.searchedpage(valUser.userId, "USER");
    var userData: any = {};
    userData.userId = valUser.userId;
    // The term stays in the box. It used to be wiped here, so opening a result
    // left the header search empty while the listing page behind it still showed
    // the same search and still carried it in the URL.
    //    this.router.navigate(['personalProfile'], {queryParams : userData})
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() =>
        this.router.navigate(["/personalProfile"], { queryParams: userData })
      );
  }
  searchList(data, temp: MatAutocompleteTrigger) {
    // Nothing to search for. A whitespace-only box leaves globalSearchValue empty
    // once trimmed, and opening the listing page on a blank term just renders an
    // empty result set with no way to tell why.
    if (!this.globalSearchValue) {
      temp.closePanel();
      return;
    }
    // //// console.log(data);
    let datas: any = {};
    datas.data = data;
    datas.searchData = this.globalSearchValue;
    // datas.searchData = this.serachForm.value.serachData;
    //this.searchedpage(data);
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate(["Search-list"], { queryParams: datas }));
    // this.router.navigate(["Search-list"], { queryParams: datas });
    // this.router.navigate(['clear']);
    //  this.commonservice.redirect(data,'Search-list'
    temp.closePanel();
    // this.serachForm.reset();
  }
  searchedpage(userid, pageType) {
    let datas: any = {};
    datas.userId = localStorage.getItem("userId");
    datas.pageId = userid;
    datas.pageType = pageType;
    this.util.startLoader()
    this.API.create("widget/searchedpage", datas).subscribe((res) => {
      if (res) {
        this.util.stopLoader()
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  notification() {
    var userid = localStorage.getItem("userId");
    this.util.startLoader();
    this.API.query("notification/" + userid).subscribe((res) => {
      if (res) {
        this.util.stopLoader();
        this.counts = res.length;
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  itemclick(data) { }
  eduSaveFlag: boolean = false
  saveWorkExperience() {
    this.workSaveFlag = true
    if (this.eperienceForm.valid) {
      this.currentOrg = true;
      this.util.startLoader();
      this.API.create("user/v1/workexperience", this.workExperience.getRawValue()[0]).subscribe((res) => {
        if (res.code == '00000') {
          this.util.stopLoader();
          localStorage.setItem("currentOrganization", this.workExperience.getRawValue()[0].organisationName)
          // Invalidate user cache so profile page shows fresh data
          this.cacheInvalidationService.invalidateCurrentUserCache();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Work Experience added successfully",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            //credit validation
            var profiledata: any = {};
            profiledata.userId = localStorage.getItem('userId')
            profiledata.userType = localStorage.getItem('userType')
            this.util.startLoader()
            this.API.create('user/profileDetails', profiledata).subscribe(res => {
              this.util.stopLoader()
              if (res.code == '00000') {
                this.workExp = res.data.exeperienceList;
                let element: any = {}
                if (this.currentEntity == 'JOBS') {
                  // element = res.data.creditConsumptions.find(item => item.creditType === AppSettings.CREATE_JOB)
                } else if (this.currentEntity == 'CANDIDATE') {
                  //element = res.data.creditConsumptions.find(item => item.creditType === AppSettings.CREATE_CANDIDATE)
                }
                //if (res.data.creditPoints >= element.points || localStorage.getItem('userType') == 'student' || this.userType == 'JOB_SEEKER') {
                if (this.currentEntity == 'JOBS') {
                  this.createJobs();
                } else if (this.currentEntity == 'CANDIDATE') {
                  this.createCandidate()
                }
                // } else {
                //   this.commonVariables.creditFlag = true
                //   this.redirectToCreditPage();
                //   this.commonVariables.educationFlag = false
                //   this.commonVariables.workExperienceFlag = false
                //   this.commonVariables.jobPostingFlag = false
                //   this.commonVariables.candidatePostingFlag = false
                //   this.commonVariables.postPrivacyFlag = false
                //   this.commonVariables.emailDomainValidation = false
                // }
              }
            })
          })
        }
      })
    }
  }
  closeWorkExperience() {
  }
  redirectToCreditPage() {
    // this.openModalWithComponent();
  }
  years1: any = []
  generateYears1() {
    this.years1 = []
    var max = new Date().getFullYear();
    var min = max - 80;
    for (var i = min; i <= max; i++) {
      this.years1.push(i);
    }
  }
  workExperience: UntypedFormArray
  eperienceForm: UntypedFormGroup
  currentYear: any = new Date().getFullYear();
  educationDetail: UntypedFormArray;
  addEducation() {
    this.generateYears1()
    this.getCountries()
    this.eduForm = this.formBuilder.group({
      educationDetail: this.formBuilder.array([]),
    });
    // this.educationDetail = this.eduForm.get("educationDetail") as FormArray;
    // this.educationDetail.push(this.createEducation());
    this.getInstitutions()
  }
  addWorkExperience(clientType: string = null) {
    this.generateYears1()
    this.getCountries()
    this.clientTypeList = []
    this.candidateJobTitleList = []
    this.recruiterTitleList = []
    var data = { "domain": "CLIENT_TYPE,PAY_TYPE,GIGSUMO_JOB_TITLE,GIGSUMO_RECRUITERS_TITLE_LIST" }
    this.API.create('listvalue/findbyList', data).subscribe(res => {
      if (res.code == '00000') {
        res.data.CLIENT_TYPE.listItems.forEach(ele => {

          this.clientTypeList.push(ele.item);
        })
        res.data.GIGSUMO_JOB_TITLE.listItems.forEach(ele => {
          this.candidateJobTitleList.push(ele.item)
        })
        res.data.GIGSUMO_RECRUITERS_TITLE_LIST.listItems.forEach(ele => {
          this.recruiterTitleList.push(ele.item)
        })
        this.getOrganization(clientType)
      }
    })
  }
  get geteducation() {
    return this.eduForm.get("educationDetail") as UntypedFormArray;
  }
  getEducationFormGroup(index: any): UntypedFormGroup {
    const formGroup = this.educationDetail.controls[index] as UntypedFormGroup;
    return formGroup;
  }
  sortConfigEdu: TypeaheadOrder = {
    direction: "desc",
    field: "institutionName",
  };
  autoComplete2: MatAutocompleteTrigger;
  searchBarShow2: boolean = false
  uniqueOrgList2: Array<Partial<HealthCareOrganization>> = [];
  platformOrgList2: Array<Partial<HealthCareOrganization>> = [];
  externalOrgList2: Array<any> = [];
  clientNameSearched2: boolean = false;
  getOrganization1(value) {
    const trimmed = (value ?? '').toString().trim();
    // Free-text edit invalidates the prior autocomplete selection.
    if (trimmed !== this.selectedClientBusinessName) {
      this.selectedClientBusinessId = '';
      this.selectedClientBusinessName = '';
      this.selectedClientSource = '';
    }
    if (trimmed === '') {
      this.searchBarShow2 = false;
      this.clientNameSearched2 = false;
      this.platformOrgList2 = [];
      this.externalOrgList2 = [];
      this.uniqueOrgList2 = [];
      return;
    }

    this.searchBarShow2 = true;
    this.clientNameSearched2 = false;

    this.API.query("care/organizations?organizationName=" + encodeURIComponent(trimmed))
      .subscribe({
        next: (res: any) => {
          const orgList2: Array<Partial<HealthCareOrganization>> = [];
          if (Array.isArray(res)) {
            res.forEach(ele => {
              const obj: any = {};
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.zipCode = ele.zipCode;
              obj.businessId = ele.businessId;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList2.push(obj);
            });
          }
          this.platformOrgList2 = orgList2;
          this.uniqueOrgList2 = orgList2;
          this.clientNameSearched2 = true;
        },
        error: () => {
          this.platformOrgList2 = [];
          this.uniqueOrgList2 = [];
          this.clientNameSearched2 = true;
        }
      });

    const loggedInBusinessId = localStorage.getItem('myBusinessId');
    if (loggedInBusinessId) {
      this.API.create('agreementDocumentChecklist/findExternalConnections', {
        businessId: loggedInBusinessId,
        roleFilter: 'Client',
        searchContent: trimmed
      }).subscribe({
        next: (extRes: any) => {
          const externals = extRes?.data?.customerFilters || [];
          const needle = trimmed.toLowerCase();
          this.externalOrgList2 = externals
            .filter((ext: any) =>
              ext?.businessName && ext.businessName.toLowerCase().indexOf(needle) !== -1)
            .map((ext: any) => ({
              organizationId: ext.businessId,
              organizationName: ext.businessName,
              businessId: ext.businessId,
              source: 'EXTERNAL'
            }));
          this.clientNameSearched2 = true;
        },
        error: () => {
          this.externalOrgList2 = [];
          this.clientNameSearched2 = true;
        }
      });
    } else {
      this.externalOrgList2 = [];
    }
  }
  currentlyPursued(event, index) {
    if (event.target.checked == true) {
      this.educationDetail.controls[index].patchValue({
        currentlyPursued: true,
      });
      this.educationDetail.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.educationDetail.controls[index].patchValue({ endMonth: null });
      this.educationDetail.controls.forEach((ele) => {
        ele.get("endYear").clearValidators();
        ele.get("endYear").updateValueAndValidity();
        ele.get("endMonth").clearValidators();
        ele.get("endMonth").updateValueAndValidity();
      });
    } else if (event.target.checked == false) {
      this.educationDetail.controls[index]
        .get("currentlyPursued")
        .markAsUntouched();
      this.educationDetail.controls[index]
        .get("currentlyPursued")
        .updateValueAndValidity();
      this.educationDetail.controls[0].patchValue({ showThisOnProfile: false });
      this.educationDetail.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.educationDetail.controls[index].patchValue({ endMonth: null });
      this.educationDetail.controls.forEach((ele) => {
        ele.get("endMonth").setValidators([Validators.required]);
        ele.get("endMonth").updateValueAndValidity();
        ele.get("endYear").setValidators([Validators.required]);
        ele.get("endYear").updateValueAndValidity();
      });
    }
  }
  schoolData: any = {}
  onChangeSchool(event, index) {
    //// console.log(event.item);
    var data = event.value + "/" + event.item.institutionId;
    this.util.startLoader();
    this.API.query("care/intitutions/" + data).subscribe((res) => {
      this.util.stopLoader();
      res.forEach((ele) => {
        this.schoolData.institutionId = event.item.institutionId;
        this.schoolData.city = ele.city;
        this.schoolData.eduId = ele.eduId;
        this.schoolData.userId = this.userId;
        this.schoolData.state = ele.state;
        this.schoolData.country = ele.country;
        // this.schoolData.countryName = ele.countryName;
        this.schoolData.zipcode = ele.zipCode && ele.zipCode !== null ? ele.zipCode : null;
        this.schoolData.street = ele.street && ele.street !== null ? ele.street : null;
        this.getEducationFormGroup(index).patchValue(this.schoolData);
        this.educationDetail.controls[0].get('city').disable()
        this.educationDetail.controls[0].get('country').disable()
        this.educationDetail.controls[0].get('state').disable()
        this.educationDetail.controls[0].get('zipcode').disable()
        this.educationDetail.controls[0].get('street').disable()
      });
    }, err => {
      this.util.stopLoader();
    });
  }
  eduForm: UntypedFormGroup
  instList: any = []
  getInstitutions() {
    this.instList = []
    this.util.startLoader()
    this.API.query("care/institutions").subscribe((res) => {
      if (res) {
        this.util.stopLoader()
        this.instList = [];
        res.forEach((ele) => {
          var obj: any = {};
          obj.institutionId = ele.institutionId;
          obj.institutionName = ele.institutionName;
          obj.city = ele.city;
          obj.state = ele.state;
          obj.country = ele.country;
          obj.countryName = ele.countryName;
          obj.street = ele.street && ele.street !== null ? ele.street : null;
          this.instList.push(obj);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
    this.educationDetail = this.eduForm.get("educationDetail") as UntypedFormArray;
    this.educationDetail.push(this.createEducation());
    this.commonVariables.educationFlag = true
    this.commonVariables.workExperienceFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.emailDomainValidation = false
    this.util.stopLoader()
  }
  createEducation() {
    return this.formBuilder.group({
      schoolName: [null, [Validators.required]],
      institutionId: [null],
      eduId: [null],
      userId: [null],
      degree: [null, [Validators.required]],
      showThisOnProfile: [false],
      currentlyPursued: [true],
      startMonth: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
      endMonth: [null],
      endYear: [this.currentYear],
      city: [null, [Validators.required]],
      street: [null, [Validators.required]],
      state: [null, [Validators.required]],
      zipcode: [null, [Validators.required, CustomValidator.minmaxLetters(this.ZIPCODE.min, this.ZIPCODE.max)]],
      country: [null, [Validators.required]],
      speciality: [null, [Validators.required]],
    });
  }
  getWorkFormGroup(index): UntypedFormGroup {
    const formGroup = this.workExperience.controls[index] as UntypedFormGroup;
    return formGroup;
  }
  showThis(event, i) {
    if (event.target.checked == true) {
      this.commonVariables.noOrgSelected = false;
      this.searchData.setCommonVariables(this.commonVariables);
    } else if (event.target.checked == false) {
      this.commonVariables.noOrgSelected = true;
      this.searchData.setCommonVariables(this.commonVariables);
    }
  }
  timezoneslist: any = []
  onChangeCountryorg(event, value, index) {
    if (value == "work") {
      this.workExperience.controls[index].patchValue({
        state: null,
        zipcode: null,
        city: null,
        country: event,
      });
      this.workExperience.controls.forEach((ele) => {
        ele.get("state").setValidators([Validators.required]);
        ele.get("state").updateValueAndValidity();
      });
    }
    if (event == "United States") {
    } else if (event == "AU") {
      const countryCode = event;
      this.stateListAU = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListAU = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "IN") {
      const countryCode = event;
      this.stateListIN = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListIN = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else if (event == "CA") {
      const countryCode = event;
      this.stateListCA = [];
      this.util.startLoader();
      this.API
        .query("country/getAllStates?countryCode=" + countryCode)
        .subscribe((res) => {
          if (res) {
            this.util.stopLoader();
            this.stateListCA = res;
          }
        }, err => {
          this.util.stopLoader();
        });
    } else {
    }
    const countryCode = event;
    if (event != null && this.eperienceForm != undefined) {
      this.workExperience.controls[0].get("timeZone").enable();
    }
    this.timeZonecountryvalues(countryCode);
  }
  curOrg(event, index) {
    if (event.target.checked == true) {
      this.workExperience.controls[index].patchValue({
        currentOrganization: true,
      });
      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.workExperience.controls[index].patchValue({ endMonth: null });
      this.workExperience.controls.forEach((ele) => {
        ele.get("endYear").clearValidators();
        ele.get("endYear").updateValueAndValidity();
        ele.get("endMonth").clearValidators();
        ele.get("endMonth").updateValueAndValidity();
      });
    } else if (event.target.checked == false) {
      this.workExperience.controls[index]
        .get("currentOrganization")
        .markAsUntouched();
      this.workExperience.controls[index]
        .get("currentOrganization")
        .updateValueAndValidity();
      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
      });
      this.workExperience.controls[index].patchValue({ endMonth: null });
      this.workExperience.controls.forEach((ele) => {
        ele.get("endMonth").setValidators([Validators.required]);
        ele.get("endMonth").updateValueAndValidity();
        ele.get("endYear").setValidators([Validators.required]);
        ele.get("endYear").updateValueAndValidity();
      });
      this.workExperience.controls[0]
        .get("badge")
        .setErrors({ checkIfChecked: true });
    }
  }
  monthChange(index, val) {
    if (val == "exp") {
      var a: any = this.workExperience.value[index].startYear;
      var b: any = this.workExperience.value[index].endYear;
      if (a == b) {
        this.workExperience.controls[index].patchValue({
          endMonth: null,
        });
      }
    } else if (val == "edu") {
    }
  }
  months: any = [
    { code: 1, name: "January" },
    { code: 2, name: "February" },
    { code: 3, name: "March" },
    { code: 4, name: "April" },
    { code: 5, name: "May" },
    { code: 6, name: "June" },
    { code: 7, name: "July" },
    { code: 8, name: "August" },
    { code: 9, name: "September" },
    { code: 10, name: "October" },
    { code: 11, name: "November" },
    { code: 12, name: "December" },
  ];
  yearIndex: any;
  yearData: any;
  yearChange(index, event, val, par) {
    if (val == "exp") {
      var stYr = parseInt(this.workExperience.value[index].startYear);
      var maxYr = new Date().getFullYear();
      if (stYr == maxYr) {
        this.workExperience.controls[index].patchValue({ startMonth: null });
      }
      this.yearData = event.target.value;
      this.yearIndex = index;
      this.workExperience.controls[index].patchValue({
        endYear: this.currentYear,
        endMonth: null,
      });
    }
  }
  onChangeYear(i, val, par) {
    const maxyr = new Date().getFullYear();
    if (val == "exp") {
      if (
        this.workExperience.value[0].startYear ==
        this.workExperience.value[0].endYear ||
        this.workExperience.value[0].endYear == maxyr
      ) {
        this.workExperience.controls[0].patchValue({ endMonth: null });
      }
      if (
        this.workExperience.value[0].startYear ==
        this.workExperience.value[0].endYear
      ) {
        this.validateMonth = true;
      } else {
        this.validateMonth = false;
      }
    }
  }
  checkYear(y, i, val) {
    if (val == "exp") {
      let yearDataInt = parseInt(this.workExperience.value[i].startYear);
      let year = parseInt(y);
      if (yearDataInt != null) {
        if (yearDataInt > year) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  validateMonth: boolean;
  checkMonth(m, i, val) {
    var max = new Date().getFullYear();
    if (val == "exp") {
      let endyr = parseInt(this.workExperience.value[i].endYear);
      let stMonth = this.workExperience.value[i].startMonth;
      let styr = parseInt(this.workExperience.value[i].startYear);
      let stMonthCode;
      let n = new Date().getMonth();
      let monthCode = m;
      this.months.forEach((e) => {
        if (e.name == stMonth) {
          stMonthCode = e.code;
        }
      });
      if (styr == max && (this.validateMonth || styr == endyr)) {
        if (monthCode > n + 1 || stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != max && (this.validateMonth || styr == endyr)) {
        if (stMonthCode > monthCode) {
          return true;
        } else {
          return false;
        }
      } else if (styr != endyr && endyr == max) {
        if (monthCode > n + 1) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  checkMonth1(m, i, val) {
    if (val == "exp") {
      var n = new Date().getMonth();
      var maxYear = new Date().getFullYear();
      var maxMonth = n + 1;
      var monthCode = m;
      let startYear = parseInt(this.workExperience.value[i].startYear);
      if (startYear == maxYear) {
        if (monthCode > maxMonth) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  getOrganization(clientType: string = null) {
    this.eperienceForm = this.formBuilder.group({
      workExperience: this.formBuilder.array([])
    })
    this.workExperience = this.eperienceForm.get("workExperience") as UntypedFormArray;
    this.workExperience.push(this.createWorkExperience());
    if (this.workExperience.controls[0].get('timeZone') != null && this.userType == "JOB_SEEKER") {
      this.workExperience.controls[0].get('timeZone').clearValidators()
      this.workExperience.controls[0].get('timeZone').updateValueAndValidity()
    }
    this.workExperience.at(0).get('clientType').patchValue(clientType);
    this.commonVariables.workExperienceFlag = true
    this.commonVariables.educationFlag = false
    this.commonVariables.jobPostingFlag = false
    this.commonVariables.candidatePostingFlag = false
    this.commonVariables.emailDomainValidation = false
    this.currentOrgProvider.setCurrentOrg(this.workExperience.controls[0].get('currentOrganization').value);
  }
  // when no result matched the value, organization id is set to null
  changeTypeaheadNoResults(index, val) {
    if (val == "work") {
      this.getWorkFormGroup(index).patchValue({
        organisationId: null,
      });
    } else if (val == "edu") {
      // this.getEducationFormGroup(index).patchValue({
      //   institutionId: null,
      // });
    }
    // else if(val == 'currentOrg'){
    //   this.getWorkFormGroup(index).patchValue({
    //     organisationId: null
    //   })
    // }
  }
  workSaveFlag: boolean = false;
  createWorkExperience(): UntypedFormGroup {
    return this.formBuilder.group({
      currentOrganization: [true],
      organisationName: [
        null, [Validators.required, CustomValidator.checkWhiteSpace(),
        CustomValidator.max(this.ORGANIZATION_NAME.max)]
      ],
      clientType: [null, [Validators.required]],
      action: [null],
      businessId: [null],
      expId: [null],
      userId: [this.userId],
      badge: [true],
      organisationId: [null],
      timeZone: [null, [Validators.required]],
      title: [null, [Validators.required]],
      state: [null, [Validators.required, CustomValidator.max(this.STATE.max)]],
      zipcode: [null, [Validators.required, CustomValidator.minmaxLetters(this.ZIPCODE.min, this.ZIPCODE.max)]],
      city: [null, [Validators.required, CustomValidator.max(this.CITY.max)]],
      country: [null, [Validators.required]],
      startMonth: [null, [Validators.required]],
      startYear: [this.currentYear, [Validators.required]],
    });
  }
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');
    if (pastedText != null) {
      this.util.startLoader();
      this.API.query("care/organizations?organizationName=" + pastedText)
        .pipe(debounceTime(2000))
        .subscribe((res) => {
          this.util.stopLoader();
          if (res) {
            this.util.stopLoader();
            const orgList: Array<Partial<HealthCareOrganization>> = [];
            // this.orgList = [];
            res.forEach(ele => {
              var obj: any = {}
              obj.organizationId = ele.organizationId;
              obj.organizationName = ele.organizationName;
              obj.city = ele.city;
              obj.address1 = ele.address1;
              obj.zipCode = ele.zipCode;
              obj.address2 = ele.address2;
              obj.state = ele.state;
              obj.country = ele.country;
              obj.countryName = ele.countryName;
              obj.street = ele.street && ele.street !== null ? ele.street : null;
              orgList.push(obj);
            })
            const uniqueList = new Set(orgList);
            this.uniqueOrgList = Array.from(uniqueList);
          }
        }, err => {
        });
      this.searchBarShow = true;
    } else {
      this.searchBarShow = false
    }
  }
  saveEducation() {
    this.eduSaveFlag = true
    if (this.eduForm.valid) {
      this.util.startLoader();
      this.API
        .create("user/create/education", this.educationDetail.getRawValue()[0])
        .subscribe((res) => {
          this.util.stopLoader();
          if (res.code == "0000") {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Education added successfully",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              // localStorage.setItem('userName', this.domainForm.value.swapEmail)
              this.createCandidate()
            })
          }
        })
    }
  }
  ContactAdmin() {
    let data: any = {}
    data.userId = localStorage.getItem('userId');
    data.groupType = "SUPPORT";
    let url = "findContactsByRefererId";
    this.API.messagePageService('POST', url, data).subscribe(res => {
      var userData: any = {};
      userData.groupId = null;
      if (res.length != 0) {
        userData.groupId = null;
        if (res[0].groupId) {
          userData.groupId = res[0].groupId;
        }
      }
      this.messageData = [];
      this.messagemodelflag = true;
      this.messageData.onlySupport = "SUPPORT";
      this.messageData.groupType = "SUPPORT";
      this.messageData.messageType = "SUPPORT";
      this.messageData.userId = localStorage.getItem('userId');
      this.messageData.id = userData.groupId;
    });
  }
  messageData: any;
  messagemodelflag = false;
  closeMessage(event) {
    this.messagemodelflag = false;
  }
  updateSupportModule() {
    let module = new jobModuleConfig(this.ContactAdmin);
    module.source = this;
    this.supportModal = module;
  }

  // Apps Menu Functions - Hover triggered
  onAppsMenuHover() {
    // Clear any pending close timeout
    if (this.appsMenuHoverTimeout) {
      clearTimeout(this.appsMenuHoverTimeout);
      this.appsMenuHoverTimeout = null;
    }
    // Show dropdown immediately on hover
    this.showAppsMenu = true;
  }

  onAppsMenuLeave() {
    // Add a small delay before closing to allow moving to dropdown
    this.appsMenuHoverTimeout = setTimeout(() => {
      this.showAppsMenu = false;
    }, 150);
  }

  closeAppsMenu() {
    // Clear any pending timeout
    if (this.appsMenuHoverTimeout) {
      clearTimeout(this.appsMenuHoverTimeout);
      this.appsMenuHoverTimeout = null;
    }
    this.showAppsMenu = false;
  }

  navigateToApp(app: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (!app.hidden) {
      // Close dropdown immediately
      this.closeAppsMenu();

      // Special handling for different menu items
      switch (app.id) {
        case 'community':
          // Community requires API call to fetch details and query params
          this.comunitydetailsapicall();
          break;

        case 'job-center':
          // Job Center - Navigate to Business Jobs module
          this.router.navigate(['/job-center']);
          break;

        case 'talent-center':
          // Talent Center - Navigate to Business Candidates module
          this.router.navigate(['/talent-center']);
          break;

        case 'applicants':
          // Applicants app-tile — routed to the renamed Talent Pools module.
          this.router.navigate(['/talent-pools']);
          break;

        case 'contract-center':
          // Contract Center - navigate with page name set
          this.pageName = 'contract-center';
          this.router.navigate([app.route]);
          break;

        default:
          // Default navigation for other apps (Business, Networks, Workspaces, etc.)
          this.router.navigate([app.route]);
          break;
      }
    }
  }

  comunitydetailsapicall() {
    let datas: any = {};
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader();
    this.loadAPIcall = true;
    this.API.queryPassval("community/check/user", datas).subscribe(ress => {
      this.loadAPIcall = false;
      this.util.stopLoader();
      // A deactivated community can still be opened by the platform SUPERADMIN, who has to get
      // inside it to activate it again. Everyone else keeps the popup below.
      const isAppSuperAdmin = localStorage.getItem('userType') === 'SUPERADMIN';
      if (ress.data.communityModelList.length != 0 && (ress.data.communityModelList[0].status == 'ACTIVE' || isAppSuperAdmin)) {
        let datas: any = {};
        datas.communityId = ress.data.communityModelList[0].communityId;
        datas.userId = localStorage.getItem('userId');
        this.util.startLoader();
        this.API.create("community/home", datas).subscribe(res => {
          this.util.stopLoader();
          if (res) {
            localStorage.setItem('communityId', res.data.communityhome.communityId);
            localStorage.setItem('isAdmin', res.data.isAdmin);
            localStorage.setItem('communityAdmin', res.data.isAdmin);
            localStorage.setItem('communityType', res.data.communityhome.communityType);
            localStorage.setItem('isSuperAdmin', res.data.isSuperAdmin);
            localStorage.setItem('communitySuperadmin', res.data.isSuperAdmin);
            localStorage.setItem('isJoined', res.data.isJoined);
            localStorage.setItem('screen', 'community');
            this.router.navigate(['/community'], { queryParams: ress.data.communityModelList[0] });
          }
        });
      } else {
        // No active community to open — navigating to /community with no
        // communityId left the page in a broken state (community-banner's
        // own fetch would call community/details/undefined and crash).
        // Same popup new-nav-bar.component.ts already uses for this case.
        // Also covers a Super Admin revoking this user's membership while
        // they were still sitting on that community's page: this call
        // re-checks membership on every "Community" tile click, comes back
        // empty, and previously left them stranded on the now-inaccessible
        // page with nothing but this popup - redirect them home instead.
        Swal.fire({
          icon: "info",
          title: "You are not a member of the Gigsumo Global Community",
          showConfirmButton: false,
          timer: 5000
        }).then(() => {
          this.router.navigate(['landingPage']);
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  canShowBusinessNetwork(): boolean {
    const userType = localStorage.getItem('userType');
    return userType !== 'JOB_SEEKER';
  }

  canShowBusinessModules(): boolean {
    // Primary source: localStorage (persists across route changes and component recreation)
    const role = localStorage.getItem('businessRole');
    const ownerId = localStorage.getItem('businessOwnerId');

    if (!role) {
      return false;
    }

    return role === 'SUPERADMIN' || ownerId === this.userId;
  }

  updateBusinessMenuVisibility(): void {
    const canShow = this.canShowBusinessModules();
    this.appsList?.forEach(app => {
      if (['job-center', 'talent-center', 'applicants'].includes(app.id)) {
        app.hidden = !canShow;
      }
    });
  }

  /**
   * Refreshes business data from API and updates localStorage + bento menu visibility.
   * Called when a BUSINESS_EMPLOYEE_REQUEST_ACCEPTED notification is received via WebSocket,
   * so the employee's bento menu reflects their upgraded plan immediately.
   */
  refreshBusinessData(): void {
    const userId = localStorage.getItem('userId');
    if (!userId) return;

    this.API.query(`business/findUserRoleInBusiness/${userId}`).subscribe({
      next: (response: any) => {
        if (response && response.code === GigsumoConstants.SUCESSCODE &&
            response.data?.businessData && (
              response.data.businessData.subscriptionType === GigsumoConstants.GrowthPlan ||
              response.data.businessData.subscriptionType === GigsumoConstants.StarterPlan ||
              response.data.businessData.subscriptionType === GigsumoConstants.ScaleXPlan
            )) {
          const processedData = {
            ...response.data.businessData,
            role: response.data.role
          };

          // Update all data sources
          localStorage.setItem('businessRole', processedData.role);
          localStorage.setItem('businessOwnerId', processedData.businessOwner || '');
          this.businessDetails = processedData;
          businessSubject.next(processedData);
          this.updateBusinessMenuVisibility();
        }
      },
      error: (err) => {
        console.error('Error refreshing business data:', err);
      }
    });
  }

  initializeAppsList() {
    const userType = localStorage.getItem('userType');
    const contractRoles: string[] = JSON.parse(localStorage.getItem('contractRoles') || '[]');
    const bizRole = localStorage.getItem('businessRole') || '';
    const isAdminOrSuper = bizRole === 'SUPERADMIN' || bizRole === 'ADMIN';

    this.appsList = [
      {
        id: 'community',
        label: 'Community',
        route: '/community',
        icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 100 100"><g><path fill="#4a5568" d="M35.3,12.2L50,33.3l14.8-21.4c2.4-3.5-4.1-5.5-7,0C54.6,18,46,18.2,42.4,12.4C38.5,6.1,33,9,35.3,12.2L35.3,12.2z"/><path fill="#4a5568" d="M50.2,66.7L35.3,88.1c-2.4,3.7,4,5.7,7,0.2c3.2-6.1,11.9-6.3,15.4-0.5c3.7,6.1,9.3,3.2,7,0L50.2,66.7z"/></g></svg>`,
        hidden: false
      },
      {
        id: 'admin-center',
        label: 'Admin Center',
        route: '/user-management/company/profile',
        icon: `<svg width="32px" height="32px" fill="#4a5568" viewBox="0 0 36 36"><path d="M14.68,14.81a6.76,6.76,0,1,1,6.76-6.75A6.77,6.77,0,0,1,14.68,14.81Zm0-11.51a4.76,4.76,0,1,0,4.76,4.76A4.76,4.76,0,0,0,14.68,3.3Z"></path><path d="M33.68,23.32l-2-.61a7.21,7.21,0,0,0-.58-1.41l1-1.86A.38.38,0,0,0,32,19l-1.45-1.45a.36.36,0,0,0-.44-.07l-1.84,1a7.15,7.15,0,0,0-1.43-.61l-.61-2a.36.36,0,0,0-.36-.24H23.82a.36.36,0,0,0-.35.26l-.61,2a7,7,0,0,0-1.44.6l-1.82-1a.35.35,0,0,0-.43.07L17.69,19a.38.38,0,0,0-.06.44l1,1.82A6.77,6.77,0,0,0,18,22.69l-2,.6a.36.36,0,0,0-.26.35v2.05A.35.35,0,0,0,16,26l2,.61a7,7,0,0,0,.6,1.41l-1,1.91a.36.36,0,0,0,.06.43l1.45,1.45a.38.38,0,0,0,.44.07l1.87-1a7.09,7.09,0,0,0,1.4.57l.6,2a.38.38,0,0,0,.35.26h2.05a.37.37,0,0,0,.35-.26l.61-2.05a6.92,6.92,0,0,0,1.38-.57l1.89,1a.36.36,0,0,0,.43-.07L32,30.4A.35.35,0,0,0,32,30l-1-1.88a7,7,0,0,0,.58-1.39l2-.61a.36.36,0,0,0,.26-.35V23.67A.36.36,0,0,0,33.68,23.32ZM24.85,28a3.34,3.34,0,1,1,3.33-3.33A3.34,3.34,0,0,1,24.85,28Z"></path></svg>`,
        hidden: userType === 'JOB_SEEKER'
      },
      {
        id: 'contract-center',
        label: 'Contract Center',
        route: '/contract-center',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path d="M9 14H15M12 11V17M8 7H7.8C6.11984 7 5.27976 7 4.63803 7.32698C4.07354 7.6146 3.6146 8.07354 3.32698 8.63803C3 9.27976 3 10.1198 3 11.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V11.8C21 10.1198 21 9.27976 20.673 8.63803C20.3854 8.07354 19.9265 7.6146 19.362 7.32698C18.7202 7 17.8802 7 16.2 7H16M8 7V6C8 4.34315 9.34315 3 11 3H13C14.6569 3 16 4.34315 16 6V7M8 7H16" stroke="#4a5568" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        hidden: this.userType === 'JOB_SEEKER' || (!isAdminOrSuper && !contractRoles.includes('CONTRACT_MANAGER') && !contractRoles.includes('SIGNATURE_AUTHORITY'))
      },
      {
        id: 'billing-center',
        label: 'Billing Center',
        route: '/billing-center',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path class="apps-billing-path" d="M3 10H21M7 15H8M12 15H13M6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19Z" stroke="#4a5568" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        hidden: this.userType === 'JOB_SEEKER' || (!isAdminOrSuper && !contractRoles.includes('BILLING_MANAGER'))
      },
      {
        id: 'job-center',
        label: 'Job Center',
        route: '/job-center',
        icon: `<svg width="32px" height="32px" viewBox="0 0 1024 1024"><path fill="#4a5568" d="M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448H128zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128z"/><path fill="#4a5568" d="M384 128v64h256v-64H384zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64z"/></svg>`,
        hidden: true
      },
      {
        id: 'talent-center',
        label: 'Talent Center',
        route: '/talent-center',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path d="M18 19V18C18 15.7909 16.2091 14 14 14H10C7.79086 14 6 15.7909 6 18V19M23 19V18C23 15.7909 21.2091 14 19 14H18.5M1 19V18C1 15.7909 2.79086 14 5 14H5.5M17 11C18.6569 11 20 9.65685 20 8C20 6.34315 18.6569 5 17 5M7 11C5.34315 11 4 9.65685 4 8C4 6.34315 5.34315 5 7 5M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z" stroke="#4a5568" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        hidden: true
      },
      {
        id: 'applicants',
        label: 'Talent Pools',
        route: '/talent-pools',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path d="M9 12L11 14L15 10M19 21V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H9.8C8.11984 3 7.27976 3 6.63803 3.32698C6.07354 3.6146 5.6146 4.07354 5.32698 4.63803C5 5.27976 5 6.11984 5 7.8V21L12 17L19 21Z" stroke="#4a5568" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
        hidden: true
      },
      {
        id: 'business',
        label: 'Business',
        route: '/landingPage/business',
        icon: `<svg width="32px" height="32px" viewBox="0 0 50 50"><path fill="#4a5568" d="M9 0C7.355469 0 6 1.355469 6 3L6 50L44 50L44 3C44 1.355469 42.644531 0 41 0 Z M 9 2L41 2C41.554688 2 42 2.445313 42 3L42 48L38 48L38 36L27 36L27 48L8 48L8 3C8 2.445313 8.445313 2 9 2 Z M 12 6L12 14L23 14L23 6 Z M 27 6L27 14L38 14L38 6 Z M 14 8L21 8L21 12L14 12 Z M 29 8L36 8L36 12L29 12 Z"/></svg>`,
        hidden: false
      },
      {
        id: 'business-network',
        label: 'Business Network',
        route: '/landingPage/b2bnetworkListing',
        icon: `<svg width="32px" height="32px" viewBox="0 0 64 64"><path fill="#4a5568" d="M52,7H12a6,6,0,0,0-6,6V51a6,6,0,0,0,6,6H52a6,6,0,0,0,6-6V13A6,6,0,0,0,52,7Zm2,44a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2H52a2,2,0,0,1,2,2Z"/><path fill="#4a5568" d="M45,29a2,2,0,0,0,0-4H22.83l2.58-2.59a2,2,0,0,0-2.82-2.82l-6,6a2,2,0,0,0-.44,2.18A2,2,0,0,0,18,29Z"/></svg>`,
        hidden: !this.canShowBusinessNetwork()
      },
      {
        id: 'workspaces',
        label: 'Workspaces',
        route: '/landingPage/team',
        icon: `<svg stroke-width="2" width="32px" height="32px" viewBox="0 0 256 256"><g><path stroke="#4a5568" fill="#4a5568" stroke-width="5" d="M184.4,48.5L184.4,48.5c1.9,9.7,10.4,16.8,20.3,16.8c9.9,0,18.4-7.1,20.3-16.8l2.5-12.7c0.8-6.2-1-12.4-5.1-17.1s-10-7.4-16.2-7.4h-2.9c-6.2,0-12.1,2.7-16.2,7.4s-6,10.9-5.1,17.4L184.4,48.5z"/></g></svg>`,
        hidden: false
      },
      {
        id: 'member-network',
        label: 'Member Network',
        route: '/landingPage/membernetworkListing',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path fill="#4a5568" fill-rule="evenodd" clip-rule="evenodd" d="M10.5 4.5C9.67157 4.5 9 5.17157 9 6V9C9 9.37302 9.13616 9.71423 9.36148 9.97666L6.77005 13H5.5C4.67157 13 4 13.6716 4 14.5V17.5C4 18.3284 4.67157 19 5.5 19H8.5C9.32843 19 10 18.3284 10 17.5V14.5C10 13.6716 9.32843 13 8.5 13H8.08713L10.248 10.4789C10.33 10.4928 10.4141 10.5 10.5 10.5H13.5C13.5859 10.5 13.67 10.4928 13.752 10.4789L15.9149 13.0024C15.1261 13.0465 14.5 13.7001 14.5 14.5V17.5C14.5 18.3284 15.1716 19 16 19H19C19.8284 19 20.5 18.3284 20.5 17.5V14.5C20.5 13.6716 19.8284 13 19 13H17.23L14.6385 9.97665C14.8638 9.71422 15 9.37301 15 9V6C15 5.17157 14.3284 4.5 13.5 4.5H10.5Z"/></svg>`,
        hidden: false
      },
      {
        id: 'my-network',
        label: 'My Network',
        route: '/landingPage/network',
        icon: `<svg width="32px" height="32px" viewBox="0 0 32 32"><path fill="#4a5568" d="M9.28,25h0A5,5,0,0,0,10,22a3.16,3.16,0,0,0-3-3,3.16,3.16,0,0,0-3,3,5,5,0,0,0,.74,3h0c-.36.1-2.72,1.2-2.72,3a1,1,0,0,0,2,0c0-.28.89-.88,1.28-1l.11,0a2.35,2.35,0,0,0,1.1-.57,2.63,2.63,0,0,0,1,0,2.35,2.35,0,0,0,1.1.57l.07,0c.43.16,1.28.77,1.32,1.05a1,1,0,0,0,2,0C12,26.24,9.64,25.14,9.28,25Z"/></svg>`,
        hidden: false
      },
      {
        id: 'my-connections',
        label: 'My Connections',
        route: '/landingPage/connection',
        icon: `<svg width="32px" height="32px" viewBox="0 0 24 24"><g fill="none" stroke="#4a5568" stroke-width="1.5"><path d="M14.5,6 C13.1193,6 12,4.8807 12,3.5 C12,2.11929 13.1193,1 14.5,1 C15.8807,1 17,2.11929 17,3.5 C17,4.8807 15.8807,6 14.5,6 Z"/><path d="M2,4 C0.89543,4 0,3.10455 0,2 C0,0.89543 0.89543,0 2,0 C3.10455,0 4,0.89543 4,2 C4,3.10455 3.10455,4 2,4 Z"/></g></svg>`,
        hidden: false
      }
    ];

    this.updateBusinessMenuVisibility();
  }



}
